export default {
  translation: {

    // App
    'apartment_system': 'Sistema de Gestión de Apartamentos',
    'apartment_management': 'Gestión de Apartamentos',
    'building_management': 'Gestión de Edificios',

    // Navigation - updated
    'dashboard': 'Panel de Control',
    'user_management': 'Gestión de Usuarios',
    'building_management': 'Gestión de Edificios',
    'apartment_management': 'Gestión de Apartamentos',
    'owner_management': 'Gestión de Propietarios',
    'tenant_management': 'Gestión de Inquilinos',
    'payment_management': 'Gestión de Pagos',
    'service_management': 'Gestión de Servicios',
    'report_management': 'Informes y Análisis',
    'log_management': 'Registros de Actividad',

    // Buildings
    'buildings': 'Edificios',
    'building_list': 'Lista de Edificios',
    'add_building': 'Añadir Edificio',
    'edit_building': 'Editar Edificio',
    'building_details': 'Detalles del Edificio',
    'building_name': 'Nombre del Edificio',
    'building_address': 'Dirección',
    'total_floors': 'Total de Pisos',
    'total_apartments': 'Total de Apartamentos',
    'switch_building': 'Cambiar Edificio',

    // Apartments (renamed from Properties)
    'apartments': 'Apartamentos',
    'apartment_list': 'Lista de Apartamentos',
    'add_apartment': 'Añadir Apartamento',
    'add_your_first_apartment': 'Añade tu primer apartamento',
    'edit_apartment': 'Editar Apartamento',
    'apartment_details': 'Detalles del Apartamento',
    'apartment_number': 'Número de Apartamento',
    'apartment_display': 'Habitación {{number}}',
    'apt': 'Apt',
    'floor_number': 'Número de Piso',
    'floor_display': 'Piso {{number}}',
    'monthly_rent': 'Alquiler Mensual',
    'apartment_status': 'Estado',
    'vacant': 'Vacante',
    'occupied': 'Ocupado',
    'under_maintenance': 'En Mantenimiento',
    'key_status': 'Estado de las llaves',
    'at_office': 'En la oficina',
    'with_tenant': 'Con el inquilino',
    'with_maintenance': 'En mantenimiento',
    'lost': 'Perdido',
    'key_handover': 'Entrega de llaves',
    'give_out_keys': 'Entregar llaves',
    'return_keys': 'Devolver llaves',
    'keys': 'Llaves',
    'remotes': 'Mandos',
    'fobs': 'Llaveros / Fobs',
    'possession_date': 'Fecha de posesión',
    'key_details': 'Detalles de las llaves',
    'key_history': 'Historial de llaves',
    'record_handover': 'Registrar entrega',
    'confirm_and_record': 'Confirmar entrega',
    'add_notes': 'Agregar notas adicionales aquí...',
    'no_key_history': 'No se encontró historial de entrega de llaves.',
    'loading_history': 'Cargando historial...',
    'by': 'por',
    'warning_handover_no_tenant': 'Registrando entrega sin inquilino asociado.',
    'key_handover_success': 'Entrega de llaves registrada con éxito',
    'failed_to_record_handover': 'Error al registrar la entrega de llaves',
    'failed_to_load_history': 'Error al cargar el historial de llaves',
    'key_management': 'Gestión de llaves',
    'manage_keys': 'Gestionar llaves',
    'total_handovers': 'Total eventos',
    'given_out': 'Entregadas',
    'returned': 'Devueltas',
    'currently_out': 'Actualmente fuera',

    // Services
    'services': 'Servicios',
    'service_payments': 'Pagos de Servicios',
    'generate_services': 'Generar Pagos de Servicios',
    'service_statistics': 'Estadísticas de Servicios',
    'service_type': 'Tipo de Servicio',
    'service_amount': 'Monto',
    'service_date': 'Fecha de Servicio',
    'service_status': 'Estado de Pago',
    'service_paid': 'Pagado',
    'service_unpaid': 'No Pagado',
    'total_service_fees': 'Total de Cuotas de Servicio',

    // Reports - updated
    'revenue_report': 'Informe de Ingresos',
    'payment_logs': 'Registros de Pagos',
    'occupancy_report': 'Informe de Ocupación',
    'monthly_payments_report': 'Informe de Pagos Mensuales',
    'monthly_payments_subtitle': 'Vista consolidada de alquileres y pagos de servicios de inquilinos',
    'all_paid': 'Todo pagado',
    'try_adjusting_filters': 'Intenta ajustar el mes, el año o los filtros',
    'pending': 'pendiente',
    'total': 'Total',
    'print_receipt': 'Imprimir Recibo',
    'monthly_revenue': 'Ingresos Mensuales',
    'building_revenue': 'Ingresos por Edificio',
    'owner_revenue': 'Ingresos de Propietarios',
    'paid_until': 'Pagado Hasta',
    'tenant_payments': 'Estado de Pagos del Inquilino',
    'next_billing_date': 'Próxima Fecha de Facturación',
    'current_tenant': 'Inquilino Actual',
    'future_tenant_upcoming': 'Futuro Inquilino',

    // Logs
    'activity_logs': 'Registros de Actividad',
    'all_user_activities': 'Todas las Actividades de Usuario',
    'all_user_activities_desc': 'Ver todas las actividades y cambios de los usuarios',
    'tenant_logs': 'Historial de Inquilinos',
    'tenant_activity_desc': 'Ver todas las actividades relacionadas con los inquilinos',
    'revenue_by_user': 'Ingresos por Usuario',
    'monthly_revenue_by_user': 'Ingresos Mensuales por Usuario',
    'revenue_breakdown_desc': 'Ver el desglose de ingresos por usuario para un mes específico',
    'time': 'Hora',
    'entity': 'Entidad',
    'details': 'Detalles',
    'amount': 'Monto',
    'search_logs': 'Buscar en los registros...',
    'filter_activities': 'Filtrar actividades',
    'action_type': 'Tipo de acción',
    'entity_type': 'Tipo de entidad',
    'apply_filter': 'Aplicar filtro',
    'entries': 'entradas',
    'no_logs_matching_search': 'No se encontraron registros que coincidan con sus criterios de búsqueda',
    'no_logs_available': 'No hay registros de actividad disponibles',
    'showing_range': 'Mostrando {{start}} a {{end}} de {{total}} entradas',
    'select_month': 'Seleccionar mes',
    'payment_count': 'Recuento de pagos',
    'total_amount': 'Monto total',
    'percentage': 'Porcentaje',
    'no_revenue_data': 'No hay datos de ingresos disponibles para este mes',
    'january': 'Enero',
    'february': 'Febrero',
    'march': 'Marzo',
    'april': 'Abril',
    'may': 'Mayo',
    'june': 'Junio',
    'july': 'Julio',
    'august': 'Agosto',
    'september': 'Septiembre',
    'october': 'Octubre',
    'november': 'Noviembre',
    'december': 'Diciembre',
    'notification_log': 'Registro de notificaciones',
    'all_notifications': 'Todas las notificaciones',
    'all_channels': 'Todos los canales',
    'all_statuses': 'Todos los estados',
    'all_recipients': 'Todos los destinatarios',
    'sent_at': 'Enviado el',
    'template_subject': 'Plantilla / Asunto',
    'email_templates': 'Plantillas de correo electrónico',
    'active_templates_count_one': 'Una plantilla activa',
    'active_templates_count_other': '{{count}} plantillas activas',
    'new_template': 'Nueva plantilla',
    'test_email_placeholder': 'Dirección de correo de prueba (se usa para todos los botones de envío de prueba)',
    'no_email_templates': 'Aún no hay plantillas de correo electrónico',
    'create_first_template': 'Crear primera plantilla',
    'rent_due': 'Alquiler vencido',
    'late_payment': 'Pago atrasado',
    'lease_renewal': 'Renovación de contrato',
    'lease_expiry': 'Vencimiento de contrato',
    'move_in': 'Mudanza de entrada',
    'move_out': 'Mudanza de salida',
    'violation': 'Violación',
    'maintenance': 'Mantenimiento',
    'inspection': 'Inspección',
    'owner_payout': 'Pago al propietario',
    'email_template_form_desc': 'Diseñe correos electrónicos automatizados para sus inquilinos y propietarios',
    'update_template': 'Actualizar plantilla',
    'create_template': 'Crear plantilla',
    'visual': 'Visual',
    'html': 'HTML',
    'live_preview': 'Vista previa en vivo',
    'subject_line': 'Línea de asunto',
    'email_content': 'Contenido del correo',
    'event_trigger': 'Activador de evento',
    'internal_name': 'Nombre interno',
    'dynamic_tags': 'Etiquetas dinámicas',
    'starter_templates': 'Plantillas de inicio',
    'starter_templates_desc': 'Elija una base para empezar a diseñar más rápido',
    'apply_design': 'Aplicar diseño',
    'payment_settings': 'Ajustes de pago',
    'accept_online_payments': 'Aceptar pagos en línea',
    'stripe_connect_desc': 'Conecte su cuenta de Stripe para permitir que los inquilinos paguen el alquiler directamente a través del portal. Los fondos se depositan directamente en su cuenta bancaria y nuestro sistema rastrea todo automáticamente.',
    'why_stripe_connect': '¿Por qué usar Stripe Connect?',
    'stripe_benefit_1': 'Recaudación y seguimiento automatizados de alquileres',
    'stripe_benefit_2': 'Depósitos directos en su cuenta bancaria',
    'stripe_benefit_3': 'Procesamiento seguro que cumple con PCI',
    'stripe_benefit_4': 'Soporte para división de tarifas de plataforma',
    'start_stripe_onboarding': 'Iniciar la integración de Stripe',
    'stripe_account_status': 'Estado de la cuenta de Stripe',
    'active_verified': 'Activo y verificado',
    'pending_onboarding': 'Acción requerida: Onboarding pendiente',
    'complete_setup': 'Completar configuración',
    'payments_enabled': 'Pagos habilitados',
    'payouts_enabled': 'Retiros habilitados',
    'account_id': 'ID de cuenta',
    'payment_configuration': 'Configuración de pago',
    'platform_fee_type': 'Tipo de tarifa de plataforma',
    'no_fee_direct': 'Sin tarifa (pago directo)',
    'percentage_soon': 'Porcentaje (Próximamente)',
    'fixed_soon': 'Monto fijo (Próximamente)',
    'platform_fee_disabled': 'La tarifa de plataforma QuadCores está deshabilitada actualmente para su organización.',
    'yes': 'Sí',
    'no': 'No',
    'previous': 'Anterior',
    'next': 'Siguiente',

    // Common
    'loading': 'Cargando...',
    'save': 'Guardar',
    'cancel': 'Cancelar',
    'edit': 'Editar',
    'delete': 'Eliminar',
    'add': 'Añadir',
    'view': 'Ver',
    'search': 'Buscar',
    'filter': 'Filtrar',
    'actions': 'Acciones',
    'status': 'Estado',
    'refresh': 'Actualizar',
    'active': 'Activo',
    'inactive': 'Inactivo',
    'yes': 'Sí',
    'no': 'No',
    'confirm': 'Confirmar',
    'success': 'Éxito',
    'error': 'Error',
    'warning': 'Advertencia',
    'info': 'Información',

    // App
    'apartment_system': 'Sistema de Apartamentos',
    'apartment_management': 'Gestión de Apartamentos',

    // Authentication
    'login': 'Iniciar Sesión',
    'logout': 'Cerrar Sesión',
    'login_to_continue': 'Inicia sesión para continuar',
    'dont_have_account': "¿No tienes una cuenta?",
    'register': 'Registrarse',
    'username': 'Nombre de usuario',
    'password': 'Contraseña',
    'email': 'Correo electrónico',
    'remember_me': 'Recordarme',
    'forgot_password': '¿Olvidaste tu contraseña?',
    'forgot_password_instructions': 'Ingresa tu nombre de usuario o correo electrónico para recibir un código de verificación',
    'send_code': 'Enviar código de verificación',
    'reset_password': 'Restablecer contraseña',
    'password_reset_success': 'Tu contraseña se ha restablecido correctamente',
    'password_min_length': 'La contraseña debe tener al menos 8 caracteres',
    'login_failed': 'Error al iniciar sesión',
    'invalid_credentials': 'Credenciales no válidas',
    'security_verification': 'Verificación de seguridad',
    'verification_code_sent': 'Código de verificación enviado a tu dispositivo registrado.',
    'enter_valid_otp': 'Por favor ingrese un código de verificación válido',
    'verification_failed': 'Verificación fallida',
    'code_resent_success': 'Código de verificación reenviado con éxito.',
    'too_many_attempts': 'Demasiados intentos. Por favor intente más tarde.',
    'check_device_for_code': 'Revisa tu dispositivo para el código',
    'verifying': 'Verificando...',

    // Navigation
    'dashboard': 'Panel de Control',
    'core': 'Principal',
    "accounting": "Contabilidad",
    'user_management': 'Gestión de Usuarios',
    'property_management': 'Gestión de Propiedades',
    'maintenance_operations': 'Mantenimiento y Operaciones',
    'financial_management': 'Gestión Financiera',
    'financial_payments': 'Pagos',
    'financial_accounting': 'Contabilidad',
    'financial_portfolio': 'Cartera y KPIs',
    'portfolio_kpis': 'Cartera y KPI',
    'reports_analytics': 'Informes y Análisis',
    'system': 'Sistema',

    // Users
    'system_users': 'Usuarios del Sistema',
    'user_list': 'Lista de Usuarios',
    'add_user': 'Añadir Usuario',
    'edit_user': 'Editar Usuario',
    'user_profile': 'Perfil de Usuario',
    'first_name': 'Nombre',
    'last_name': 'Apellido',
    'phone_number': 'Número de Teléfono',
    'role': 'Rol',
    'administrator': 'Administrador',
    'front_desk': 'Recepción',
    'created_at': 'Creado El',
    'last_login': 'Último Inicio de Sesión',
    'never': 'Nunca',

    // Properties
    'properties': 'Propiedades',
    'property_list': 'Lista de Propiedades',
    'add_property': 'Añadir Propiedad',
    'property_owners': 'Propietarios',
    'owner_list': 'Lista de Propietarios',
    'add_owner': 'Añadir Propietario',
    'owners': 'Propietarios',
    'owner_contracts': 'Contratos de Propietarios',
    'management_agreements': 'Acuerdos de Gestión',
    'add_contract': 'Añadir Contrato',
    'contract_details': 'Detalles del Contrato',
    'no_contracts_message': 'No se encontraron contratos de gestión para este propietario.',
    'contract_type': 'Tipo de Contrato',
    'total_contract_value': 'Valor Total del Contrato',
    'contract_progress': 'Progreso del Contrato',
    'installment_schedule': 'Calendario de Pagos',

    // Tenants
    'tenants': 'Inquilinos',
    'tenant_list': 'Lista de Inquilinos',
    'add_tenant': 'Añadir Inquilino',
    'owner_living': 'Propietario Residente',
    'future_tenant': 'Futuro Inquilino',

    // Payments
    'payments': 'Pagos',
    'all_payments': 'Todos los Pagos',
    'record_payment': 'Registrar Pago',
    'manage_services': 'Gestionar Servicios',
    'generate_payments': 'Generar Pagos',
    'overdue_payments': 'Pagos Atrasados',
    'receipts': 'Recibos',

    // Reports
    'reports': 'Informes',
    'all_reports': 'Todos los Informes',
    'reports_dashboard': 'Panel de Informes',
    'financial_reports': 'Informes Financieros',
    'payment_reports': 'Informes de Pagos',
    'property_reports': 'Informes de Propiedades',
    'reports_1099_desc': 'Informe IRS 1099-MISC para distribuciones de propiedades a propietarios',
    'vendor_1099_nec': 'Proveedor 1099-NEC',
    'vendor_1099_desc': 'Informes anuales del IRS: proveedores pagados ≥ $600 en compensación para no empleados',
    'rent_roll_desc': 'Instantánea de todas las unidades, estado de ocupación, alquiler y detalles del contrato',
    'ar_aging_desc': 'Saldos pendientes de inquilinos agrupados por antigüedad (0, 1-30, 31-60, 61-90, 90+)',
    'total_vendors': 'Total de Proveedores',
    'require_1099': 'Requiere 1099',
    'total_reportable': 'Total Reportable',
    '1099_required': '1099 Requerido',
    'below_threshold': 'Por debajo del umbral',
    'occupancy_rate': 'Tasa de ocupación',
    'scheduled_rent': 'Alquiler programado',
    'aging_breakdown': 'Desglose por Antigüedad',

    // Settings
    'settings': 'Configuración',
    'profile_settings': 'Configuración de Perfil',
    'system_settings': 'Configuración del Sistema',
    'profile': 'Perfil',
    'personal_details': 'Detalles Personales',
    'security_settings': 'Configuración de Seguridad',
    'change_password': 'Cambiar Contraseña',
    'current_password': 'Contraseña Actual',
    'new_password': 'Nueva Contraseña',
    'confirm_new_password': 'Confirmar Nueva Contraseña',
    'organization_settings': 'Configuración de la Organización',
    'organization_name': 'Nombre de la Organización',
    'timezone': 'Zona Horaria',
    'subscription_plan': 'Plan de Suscripción',
    'trial_period': 'Período de Prueba',
    'days_left': 'Quedan {{days}} días',
    'subscription_required': 'Suscripción Requerida',
    'subscription_expired_message': 'El acceso a tu espacio de trabajo está bloqueado. Renueva tu suscripción para seguir gestionando tus propiedades.',
    'premium_experience_notice': 'Espacio de Trabajo Premium Requerido',
    'feature_locked_message': 'Esta función no está disponible en tu plan actual. Por favor, actualiza para acceder.',
    'renew_subscription': 'Renovar Suscripción',
    'update_profile_success': 'Perfil actualizado con éxito',
    'update_password_success': 'Contraseña cambiada con éxito',
    'update_system_success': 'Configuración del sistema actualizada con éxito',
    'settings_subtitle': 'Gestiona tu cuenta y preferencias del sistema',
    'manage_your_account_and_system_preferences': 'Gestiona tu cuenta y preferencias del sistema',
    'standard_plan': 'Plan Estándar',
    'enterprise_plan': 'Plan Empresarial',

    // Notifications
    'notifications': 'Notificaciones',
    'view_all_notifications': 'Ver Todas las Notificaciones',

    // WhatsApp Settings
    'whatsapp_settings': 'Configuración de WhatsApp',
    'whatsapp_settings_description': 'Notificaciones automatizadas de WhatsApp para inquilinos y propietarios',
    'send_reminders_now': 'Enviar Recordatorios Ahora',
    'general_settings': 'Configuración General',
    'whatsapp_enable': 'Habilitar Notificaciones de WhatsApp',
    'whatsapp_enable_sub': 'Activa o desactiva todos los mensajes automatizados de WhatsApp',
    'default_country_code': 'Código de País por Defecto',
    'default_messaging_language': 'Idioma de Mensajería por Defecto',
    'default_language_help': 'Se utiliza si el inquilino no tiene un idioma preferido configurado.',
    'tenant_rent_reminder': 'Recordatorio de Alquiler del Inquilino',
    'enable_tenant_rent_reminders': 'Habilitar Recordatorios',
    'tenant_rent_reminder_sub': 'Enviar recordatorio a los inquilinos antes o después de la fecha de vencimiento del pago',
    'days_before_due': 'Días Antes del Vencimiento',
    'service_fee_reminder': 'Recordatorio de Cuota de Servicio',
    'enable_service_fee_reminder': 'Habilitar Recordatorio de Cuota de Servicio',
    'service_fee_reminder_sub': 'Notificar a los inquilinos sobre próximos pagos de cuotas de servicio',
    'owner_reminder': 'Recordatorio para Propietarios',
    'enable_owner_reminders': 'Habilitar Recordatorios para Propietarios',
    'owner_reminder_sub': 'Notificar a los propietarios cuando sus inquilinos tengan pagos atrasados',
    'payment_confirmation': 'Confirmación de Pago',
    'send_on_payment': 'Enviar al Pagar',
    'payment_confirmation_sub': 'Se envía automáticamente al inquilino cuando se registra un pago',
    'preview_reminders': 'Vista Previa de Recordatorios',
    'notification_log_desc': 'Registro de todas le notificaciones enviadas',
    'total_sent': 'Total Enviados',
    'failed_bounced': 'Fallidos / Rebotados',
    'email_templates_desc': 'Diseñe correos electrónicos automatizados para sus inquilinos y propietarios',
    'test_email_address': 'Correo de prueba',
    'payment_settings': 'Ajustes de Pago',
    'accept_online_payments': 'Aceptar Pagos en Línea',
    'connect_stripe_desc': 'Conecte su cuenta de Stripe para permitir que los inquilinos paguen el alquiler directamente a través del portal.',
    'start_stripe_onboarding': 'Iniciar Onboarding de Stripe',
    'active_verified': 'Activo y Verificado',
    'action_required_onboarding': 'Acción requerida: Onboarding pendiente',
    'webhooks_desc': 'Envíe eventos a sus sistemas cuando ocurran cosas en APS',
    'recent_deliveries': 'Entregas Recientes',
    'failed_to_load_settings': 'Error al cargar la configuración',
    'settings_saved': 'Configuración guardada con éxito',
    'failed_to_save': 'Error al guardar',
    'server_error': 'Error del servidor',
    'whatsapp': 'WhatsApp',
    'on': 'ON',
    'off': 'OFF',
    'sms_twilio': 'SMS (Twilio)',
    'via_twilio': 'vía Twilio',
    'sender': 'Remitente',
    'no_recipients_match': 'Ningún destinatario coincide con la configuración actual y los datos activos.',
    'enable_whatsapp_notifications': 'Habilitar Notificaciones de WhatsApp',
    'whatsapp_enable_desc': 'Activa o desactiva todos los mensajes automatizados de WhatsApp',
    'enable_sms_notifications': 'Habilitar Notificaciones SMS (Twilio)',
    'sms_enable_desc': 'Activa o desactiva todos los mensajes SMS automatizados',
    'rent_reminders_desc': 'Enviar a inquilinos con pagos de alquiler atrasados o próximos',
    'enable_service_fee_reminders': 'Habilitar Recordatorios de Cuota de Servicio',
    'service_fee_reminders_desc': 'Notificar a inquilinos y propietarios residentes sobre cargos de servicio no pagados',
    'owner_reminders_desc': 'Alertar a los propietarios cuando los inquilinos tengan pagos atrasados',
    'send_payment_confirmation': 'Enviar Confirmación de Pago',
    'payment_confirmation_desc': 'Notificar automáticamente al inquilino por WhatsApp cuando se registre un pago',
    'send_test_sms': 'Enviar SMS de Prueba',
    'test_sms_desc': 'Verifique su integración con Twilio enviando un mensaje de prueba a cualquier número de teléfono.',
    'phone_number': 'Número de Teléfono',
    'sms_sent_to': 'SMS enviado a {{to}}',
    'sms_failed': 'Error al enviar SMS',
    'enter_phone_number': 'Ingrese primero un número de teléfono',
    'whatsapp_enable': 'Habilitar WhatsApp',
    'whatsapp_enable_sub': 'Activa o desactiva todos los mensajes automatizados de WhatsApp',
    'default_message_language': 'Idioma de Mensajes Predeterminado',
    'english': 'Inglés',
    'arabic': 'Árabe',
    'french': 'Francés',
    'german': 'Alemán',
    'italian': 'Italiano',
    'spanish': 'Español',
    'kurdish': 'Kurdo',
    'preview_send': 'Vista Previa y Enviar',
    'save_settings': 'Guardar Configuración',
    'confirm_send_all': 'Confirmar y Enviar Todo',
    'no_pending_reminders': 'No hay recordatorios pendientes en este momento.',
    'recipient_pending': 'destinatario(s) pendiente(s)',
    'org_settings_desc': 'Configuración general de la organización',
    'flat_amount': 'Cantidad fija',
    'percent_of_rent': 'Porcentaje del alquiler',
    'late_fee_configuration': 'Configuración de cargos por retraso',
    'enabled': 'Habilitado',
    'disabled': 'Deshabilitado',
    'legal_note_late_fees': 'Las leyes estatales varían. Consulte sus leyes locales sobre propietarios e inquilinos.',
    'grace_period_days': 'Periodo de gracia (días)',
    'fee_type': 'Tipo de cargo',
    'late_fee_summary': 'Cargo por retraso',
    'applied_after': 'aplicado después de',
    'past_due': 'vencimiento',
    'days': 'días',
    'amount': 'Monto',
    'percentage': 'Porcentaje',
    'active': 'Activo',
    'trial': 'Prueba',
    'past_due': 'Vencido',
    'canceled': 'Cancelado',
    'expired': 'Expirado',
    'unknown': 'Desconocido',
    'completed': 'Completado',
    'pending': 'Pendiente',
    'failed': 'Fallido',
    'all': 'Todo',
    'date': 'Fecha',
    'organization': 'Organización',
    'method': 'Método',
    'actions': 'Acciones',
    'starter_plan': 'Starter',
    'pro_plan': 'Pro',
    'enterprise_plan': 'Enterprise',
    'starter_desc': 'Para propietarios independientes que gestionan registros internos.',
    'pro_desc': 'Para empresas profesionales con flujos de trabajo automatizados.',
    'enterprise_desc': 'Control de nivel institucional con portales de autoservicio completos.',
    'starter_f1': 'Hasta 100 unidades',
    'starter_f2': '2 plazas de Admin',
    'starter_f3': 'Gestión de edificios y unidades',
    'starter_f4': 'Libro mayor de partida doble',
    'starter_f5': 'Seguimiento manual de alquileres',
    'starter_f6': 'Informes financieros básicos',
    'starter_f7': 'Notificaciones por correo electrónico',
    'most_popular': 'Más Popular',
    'pro_f1': 'Hasta 150 unidades',
    'pro_f2': '5 plazas de Admin',
    'pro_f3': 'Centro de mantenimiento global',
    'pro_f4': 'Cumplimiento de depósitos de seguridad',
    'pro_f5': 'Estados de cuenta mensuales automáticos',
    'pro_f6': 'Recordatorios por WhatsApp',
    'pro_f7': 'Gestión de propietarios y órdenes de trabajo',
    'pro_f8': 'Analítica de ocupación',
    'pro_f9': 'Reservas, listas de espera y traslados',
    'pro_f10': 'Soporte prioritario estándar',
    'ent_f1': 'Unidades y Admins ilimitados',
    'ent_f2': 'Portales para inquilinos y propietarios',
    'ent_f3': 'Mensajería segura bidireccional',
    'ent_f4': 'Pagos de alquiler Stripe E2E',
    'ent_f5': 'Sistema de correo electrónico automatizado',
    'ent_f6': 'Firma digital de contratos',
    'ent_f7': 'Soporte multiorganización',
    'ent_f8': 'Plantillas de informes personalizadas',
    'ent_f9': 'Logs di actividad avanzados',
    'ent_f10': 'Acceso a API y Webhooks',
    'ent_f11': '2FA vía WhatsApp OTP',
    'choose_a_plan': 'Elige un Plan',
    'subscribe_now': 'Suscríbete Ahora',
    'contact_sales': 'Contactar Ventas',
    'upgrade': 'Subir de nivel',
    'current': 'Actual',
    'custom': 'Personalizado',
    'yr': 'año',
    'mo': 'mes',
    'expires': 'Expira',
    'renews': 'Renueva',
    'opening': 'Abriendo...',
    'subscription_plan': 'Plan de Suscripción',
    'manage_your_subscription_and_billing': 'Gestiona tu suscripción e historial de facturación',
    'stripe_portal_title': 'Gestión del Portal',
    'stripe_portal_desc': 'Gestiona tu suscripción de forma segura a través de nuestro portal de Stripe.',
    'stripe_secure_notice': '🔒 Pagos seguros procesados por Stripe',
    'no_payment_history': 'No se encontró historial de pagos',
    'payment_history': 'Historial de Pagos',
    'monthly': 'Mensual',
    'annual': 'Anual',
    'subscribe_with_stripe': 'Suscríbete de forma segura a través de Stripe',
    'save_20_annual': 'Ahorra 20% · ${{amount}}/año facturado anualmente',

    // Forms
    'personal_information': 'Información Personal',
    'account_information': 'Información de la Cuenta',
    'security': 'Seguridad',
    'enter_first_name': 'Ingresa el nombre',
    'enter_last_name': 'Ingresa el apellido',
    'enter_email': 'Ingresa el correo electrónico',
    'enter_username': 'Ingresa el nombre de usuario',
    'enter_password': 'Ingresa la contraseña',
    'enter_phone_number': 'Ingresa el número de teléfono',
    'confirm_password': 'Confirmar Contraseña',
    'leave_blank_to_keep_current': 'Déjalo en blanco para mantener la contraseña actual',

    // Validation
    'first_name_required': 'El nombre es requerido',
    'last_name_required': 'El apellido es requerido',
    'email_required': 'El correo electrónico es requerido',
    'invalid_email': 'Por favor ingresa una dirección de correo válida',
    'username_required': 'El nombre de usuario es requerido',
    'username_too_short': 'El nombre de usuario debe tener al menos 3 caracteres',
    'password_required': 'La contraseña es requerida',
    'password_too_short': 'La contraseña debe tener al menos 6 caracteres',
    'passwords_do_not_match': 'Las contraseñas no coinciden',
    'phone_invalid_format': 'Por favor ingresa un número de teléfono válido',

    // Actions
    'saving': 'Guardando...',
    'deleting': 'Eliminando...',
    'loading_users': 'Cargando usuarios...',
    'loading_user_data': 'Cargando datos del usuario...',
    'update': 'Actualizar',
    'activate': 'Activar',
    'deactivate': 'Desactivar',
    'show_all': 'Mostrar Todo',
    'hide_inactive': 'Ocultar Inactivos',
    'all_roles': 'Todos los Roles',
    'retry': 'Reintentar',

    // Messages
    'no_users_found': 'No se encontraron usuarios',
    'user_created_successfully': 'Usuario creado con éxito',
    'user_updated_successfully': 'Usuario actualizado con éxito',
    'user_deleted_successfully': 'Usuario eliminado con éxito',
    'confirm_deletion': 'Confirmar Eliminación',
    'delete_user_confirmation': '¿Estás seguro de que deseas eliminar a {{name}}? Esta acción no se puede deshacer.',

    // Dashboard
    'welcome_back': 'Bienvenido/a de nuevo',
    'dashboard_subtitle': 'Esto es lo que está pasando hoy con tus propiedades.',
    'total_properties': 'Total de Propiedades',
    'active_tenants': 'Inquilinos Activos',
    'monthly_revenue': 'Ingresos Mensuales',
    'pending_payments': 'Pagos Pendientes',
    'recent_activity': 'Actividad Reciente',
    'recent_transactions': 'Transacciones Recientes',
    'quick_actions': 'Acciones Rápidas',
    'alerts_notifications': 'Alertas y Notificaciones',
    'showing': 'Mostrando',
    'of': 'de',
    'users': 'usuarios',
    'contact': 'Contacto',
    'user': 'Usuario',
    'active_properties': 'Propiedades Activas',
    'occupancy_rate_desc': '{{rate}}% tasa de ocupación',
    'vs_last_month': 'vs mes pasado',
    'overdue_amount': '{{amount}} atrasado',
    'payment_desc': 'Pago de {{type}} - Apt {{number}}',
    'overdue_payments': 'Pagos Atrasados',
    'overdue_payments_msg': '{{count}} inquilinos tienen pagos pendientes por un total de {{amount}}',
    'view_details': 'Ver Detalles',
    'lease_expiring_soon': 'Contrato Próximo a Vencer',
    'lease_expiring_msg': '{{count}} contratos de alquiler vencen en los próximos 30 días',
    'review_leases': 'Revisar Contratos',
    'trial_ending_soon': 'El Período de Prueba Termina Pronto',
    'trial_ending_msg': 'Tu prueba termina en {{days}} días. Suscríbete para evitar la interrupción del servicio.',
    'upgrade_plan': 'Actualizar Plan',
    'last_7_days': 'Últimos 7 días',
    'last_30_days': 'Últimos 30 días',
    'last_3_months': 'Últimos 3 meses',
    'last_year': 'Último año',
    'error_loading_dashboard': 'Error al cargar el panel',
    'reports_dashboard': 'Panel de Informes',
    'overview_of_financial_performance': 'Resumen del rendimiento financiero y estadísticas de propiedades',
    'view_all_reports': 'Ver Todos los Informes',
    'total_revenue': 'Ingresos Totales',
    'total_payments_count': '{{count}} pagos',
    'total_tenants': 'Total de Inquilinos',
    'new_tenants_this_year': '{{count}} nuevos este año',
    'total_buildings_count': '{{count}} edificios',
    'total_owners': 'Total de Propietarios Residentes',
    'ended_contracts_count': '{{count}} contratos finalizados',
    'urgent_action': 'Acción Urgente',
    'monthly_revenue_year': 'Ingresos Mensuales - {{year}}',
    'occupancy_rate': 'Tasa de Ocupación',
    'quick_reports': 'Informes Rápidos',
    'annual_revenue': 'Ingresos Anuales',
    'yearly_breakdown': 'Desglose anual de todos los ingresos',
    'building_revenue': 'Ingresos por Edificio',
    'revenue_by_building': 'Desglose de ingresos por edificio',
    'owner_revenue': 'Ingresos de Propietarios',
    'revenue_by_owner': 'Desglose de ingresos por propietario',
    'detailed_payment_history': 'Historial de pagos detallado y registros',
    'occupied': 'Ocupado',
    'vacant': 'Vacante',
    'maintenance': 'Mantenimiento',
    'excellent': 'Excelente',
    'good': 'Bueno',
    'needs_improvement': 'Necesita Mejorar',
    'rent': 'Alquiler',
    'service': 'Servicio',
    'deposit': 'Depósito',
    'commission': 'Comisión',
    'insurance': 'Seguro',
    'total': 'Total',
    'no_recent_payments': 'No se encontraron pagos recientes',
    'no_overdue_payments': 'No se encontraron pagos atrasados',
    'overdue': 'Atrasado',
    'partial': 'Parcial',
    'expired': 'Caducado',
    'pending': 'Pendiente',
    'paid': 'Pagado',
    'apt': 'Apt',
    'days_overdue': 'días de retraso',
    'more_overdue_tenants': 'más inquilinos atrasados',
    'error_fetching_occupancy': 'Error al obtener datos de ocupación',
    'failed_load_occupancy': 'Error al cargar estadísticas de ocupación',
    'error_fetching_payments': 'Error al obtener pagos recientes',
    'failed_load_payments': 'Error al cargar pagos recientes',
    'error_fetching_tenant_status': 'Error al obtener estado de pago de inquilinos',
    'failed_load_tenant_status': 'Error al cargar estado de pago de inquilinos',
    'failed_to_load_report_data': 'Error al cargar datos del informe',
    'mgmt_fee_collected': 'Honorarios de gestión cobrados (acum. anual)',
    'mgmt_fee_outstanding': 'Honorarios de gestión pendientes',
    'active_tenant_arrears': 'Atrasos de inquilinos activos',
    'all_accounts_settled': 'Todas las cuentas saldadas',
    'owner_payments': 'Pagos de Propietarios',
    'all_months': 'Todos los Meses',

    "floor_number": "Piso {{number}}",
    "apartment_number": "Habitación {{number}}",

    // Sidebar specific translations
    'core': 'Principal',
    'user_management': 'Gestión de Usuarios',
    'property_management': 'Gestión de Propiedades',
    'maintenance_operations': 'Mantenimiento y Operaciones',
    'financial_management': 'Gestión Financiera',
    'financial_payments': 'Pagos',
    'financial_accounting': 'Contabilidad',
    'financial_portfolio': 'Cartera y KPIs',
    'reports_analytics': 'Informes y Análisis',
    'logs_audit': 'Registros y Auditoría',
    'all_activities': 'Todas las Actividades',
    'tenant_activities': 'Actividades de Inquilinos',
    'system': 'Sistema',
    'bookings': 'Reservas',
    'booking_list': 'Lista de Reservas',
    'new_booking': 'Nueva Reserva',
    'booking_calendar': 'Calendario de Reservas',
    'waitlist': 'Lista de Espera',
    'analytics': 'Análisis',

    'system_users': 'Usuarios del Sistema',
    'user_list': 'Lista de Usuarios',
    'add_user': 'Añadir Usuario',

    'buildings': 'Edificios',
    'building_list': 'Lista de Edificios',
    'add_building': 'Añadir Edificio',

    'apartments': 'Apartamentos',
    'apartment_list': 'Lista de Apartamentos',
    'add_apartment': 'Añadir Apartamento',

    'owners': 'Propietarios',
    'owner_list': 'Lista de Propietarios',
    'add_owner': 'Añadir Propietario',

    'tenants': 'Inquilinos',
    'tenant_list': 'Lista de Inquilinos',
    'add_tenant': 'Añadir Inquilino',
    'overdue_rent': 'Alquileres Atrasados',

    'payments': 'Pagos',
    'all_payments': 'Todos los Pagos',
    'record_payment': 'Registrar Pago',
    'payment_stats': 'Estadísticas de Pago',

    'service_payments': 'Pagos de Servicios',
    'manage_services': 'Gestionar Servicios',
    'generate_payments': 'Generar Pagos',
    'service_statistics': 'Estadísticas de servicios',
    'finance': 'Finanzas',
    'transactions': 'Transacciones',
    'service_charges': 'Cargos por servicio',
    'owner_installments': 'Cuotas del propietario',
    'messages': 'Mensajes',
    'announcements_manager': 'Gestor de anuncios',
    'all_announcements': 'Todos los anuncios',
    'sales': 'Ventas',
    'sales_management': 'Gestión de ventas',
    'inspections': 'Inspecciones',
    'all_inspections': 'Todas las inspecciones',
    'renewal_risk': 'Riesgo de renovación',
    'lease_renewals': 'Renovaciones de contrato',
    'lease_applications': 'Solicitudes de alquiler',
    'application_links': 'Enlaces de solicitud',
    'leases': 'Contratos',
    'violations': 'Violaciones',
    'notices': 'Avisos',
    'screening': 'Evaluación',
    'documents': 'Documentos',
    'amenities_parking': 'Servicios y Estacionamiento',

    // Messages
    'messages_title': 'Mensajes',
    'tenants_tab': 'Inquilinos',
    'owners_tab': 'Propietarios',
    'no_conversations': 'No hay conversaciones todavía',
    'select_conversation_hint': 'Selecciona una conversación de la izquierda para empezar a mensaje',
    'type_message_placeholder': 'Escribe un mensaje...',
    'your_inbox': 'Tu bandeja de entrada',
    'you_label': 'Tú: ',
    'mark_as_read': 'Marcar como leído',
    'failed_to_load_messages': 'Error al cargar los mensajes',
    'failed_to_load_chat_history': 'Error al cargar el historial de chat',
    'failed_to_send_message': 'Error al enviar el mensaje',

    // Expenses
    'expenses_title': 'Gastos',
    'expenses_subtitle': 'Seguimiento de gastos operativos con flujo de aprobación',
    'new_expense': 'Nuevo Gasto',
    'new_expense_subtitle': 'Registrar un gasto operativo',
    'total_expenses': 'Total de Gastos',
    'approved_amount': 'Aprobado',
    'how_it_works': 'Cómo funciona',
    'expense_hint1': 'Registre cualquier costo pagado por un edificio: reparaciones, limpieza, honorarios de gestión, etc.',
    'expense_hint2': 'Los gastos marcados como "Pendientes" necesitan aprobación antes de afectar el NOI',
    'expense_hint3': '"Cargar al propietario" registra el gasto directamente en el libro mayor del propietario',
    'expense_hint4': 'NOI = Alquiler cobrado - Gastos aprobados',
    'search_expenses': 'Buscar por descripción, proveedor, categoría...',
    'expense_records': 'Registros de Gastos',
    'no_expenses_found': 'No se encontraron gastos',

    // Storage / Inventory
    'storage_title': 'Almacén',
    'storage_subtitle': 'Controla los artículos en almacén y asígnalos a apartamentos — se registra automáticamente en Gastos',
    'add_stock': 'Agregar stock',
    'stock_value': 'Valor del stock',
    'items_in_storage': 'Artículos en almacén',
    'total_issued': 'Total asignado',
    'stock_on_hand': 'Stock disponible',
    'issuance_history': 'Historial de asignaciones',
    'quantity_on_hand': 'Disponible',
    'issue_to_apartment': 'Asignar a apartamento',
    'issue': 'Asignar',
    'storage_hint1': 'Registra primero los artículos en almacén: puertas, ventanas, accesorios, etc. — aún no se necesita un apartamento',
    'storage_hint2': '"Asignar a apartamento" traslada el stock a una unidad y registra el costo automáticamente',
    'storage_hint3': 'El costo asignado se registra como un gasto pendiente de aprobación',
    'storage_hint4': 'El resumen por apartamento muestra el costo total por unidad, según lo realmente asignado',
    'search_materials': 'Buscar por artículo, apartamento, proveedor...',
    'no_materials_found': 'Todavía no hay nada aquí',
    'spend_by_apartment': 'Gasto por apartamento',
    'apartment_label': 'Apartamento',
    'item_name': 'Artículo',
    'item_name_placeholder': 'ej. Puerta interior, ventana de doble panel',
    'items_logged': 'Artículos',
    'quantity': 'Cantidad',
    'quantity_required': 'La cantidad es obligatoria',
    'quantity_exceeds_stock': 'Solo hay {{available}} disponible(s) en stock',
    'available_short': '{{qty}} disponible(s)',
    'unit_cost': 'Costo unitario',
    'total_cost': 'Costo total',
    'select_apartment': 'Seleccionar apartamento',
    'stock_added': 'Stock agregado al almacén',
    'material_issued': 'Asignado al apartamento y registrado en gastos',
    'failed_to_load_materials': 'Error al cargar los datos del almacén',
    'failed_to_load_apartments': 'Error al cargar los apartamentos — verifica tu conexión e inténtalo de nuevo',

    'approve': 'Aprobar',
    'void': 'Anular',
    'confirm_void': '¿Anular este gasto? Esto no se puede deshacer.',
    'expense_description_placeholder': 'p. ej. Servicio mensual de control de plagas',
    'select_category': '— Seleccionar categoría —',
    'charge_to_owner': 'Cargar al propietario (se publicará en el libro mayor del propietario)',
    'create_expense': 'Crear Gasto',
    'expense_created': 'Gasto creado',
    'expense_approved': 'Gasto aprobado',
    'expense_voided': 'Gasto anulado',
    'invoice_number': 'Nº de factura',
    'all_statuses': 'Todos los estados',
    'failed_to_load_expenses': 'Error al cargar los gastos',
    'expense_rejected': 'Gasto rechazado',
    'confirm_reject': '¿Rechazar este gasto? Esta acción no se puede deshacer.',
    'date_from': 'Fecha desde',
    'date_to': 'Fecha hasta',
    'failed_to_load': 'Error al cargar los datos',
    'assign_failed': 'Error al asignar',
    'unavailable': 'No disponible',
    'filtered_by': 'Filtrado por:',
    'calendar': 'Calendario',
    'notes_placeholder': 'Notas adicionales…',
    'no_amenities_match_filter': 'Ningún servicio coincide con el filtro seleccionado.',
    'all_amenities': 'Todos los servicios',
    'no_bookings_on_day': 'No hay reservas en este día.',
    'parking_assigned': 'Aparcamiento asignado',
    'parking_unassigned': 'Asignación de aparcamiento eliminada',
    'parking_space_deleted': 'Plaza de aparcamiento eliminada',
    'parking_space_created': 'Plaza de aparcamiento creada',
    'parking_space_updated': 'Plaza de aparcamiento actualizada',
    'parking_spaces_generated': 'Plazas de aparcamiento generadas en bloque',
    'booking_deleted': 'Reserva eliminada',
    'parking_layout_hint': 'Asigna filas mediante Editar espacio para organizar la distribución del aparcamiento',
    'delete_amenity_title': 'Eliminar servicio',
    'confirm_delete_amenity': '¿Está seguro de que desea eliminar este servicio? Esta acción no se puede deshacer.',
    'delete_parking_space_title': 'Eliminar plaza de aparcamiento',
    'confirm_delete_parking': '¿Está seguro de que desea eliminar esta plaza de aparcamiento? Esta acción no se puede deshacer.',
    'delete_booking_title': 'Eliminar reserva',
    'confirm_delete_booking': '¿Está seguro de que desea eliminar esta reserva? Esta acción no se puede deshacer.',
    'unassign_parking_title': 'Desasignar aparcamiento',
    'confirm_unassign_parking': '¿Está seguro de que desea desasignar esta plaza de aparcamiento?',
    'start_end_required': 'Se requieren números de inicio y fin',
    'space_number_required': 'Se requiere el número de plaza',
    'row_zone': 'Fila / Zona',
    'row_zone_hint': 'para el diseño del mapa',
    'status_pending_approval': 'Pendiente',
    'status_approved': 'Aprobado',
    'status_voided': 'Anulado',
    'status_rejected': 'Rechazado',
    'owner_label': 'Propietario',
    'select_building': '— Seleccionar edificio —',
    'payment_method': 'Método de pago',
    'method_bank_transfer': 'Transferencia bancaria',
    'method_cash': 'Efectivo',
    'method_check': 'Cheque',
    'method_credit_card': 'Tarjeta de crédito',
    'method_stripe': 'Stripe',
    'method_wire': 'Transferencia cablegráfica',
    'method_other': 'Otro',
    'items_plural': 'elementos',
    'item_singular': 'elemento',
    'all_buildings': 'Todos los edificios',

    // Late Fees
    'late_fee_mgmt': 'Gestión de cargos por retraso',
    'pending_charges': 'Cargos pendientes',
    'history_tab': 'Historial',
    'fee_settings': 'Ajustes de cargos',
    'late_fees_disabled_hint': 'Los cargos por retraso están desactivados — actívelos en la configuración',
    'tenants_due_fee': 'Inquilinos con cargos por retraso pendientes',
    'next_cron_run': 'Próxima ejecución automática a las 10:00 AM (hora de la organización)',
    'apply_now': 'Aplicar ahora',
    'applying': 'Aplicando...',
    'waive': 'Exonerar',
    'waive_late_fee': 'Exonerar cargo por retraso',
    'waive_reason_label': 'Motivo',
    'waive_reason_placeholder': 'p. ej. Acuerdo de pago acordado, cortesía de primera vez, etc.',
    'confirm_waiver': 'Confirmar exoneración',
    'waiving': 'Exonerando...',
    'failed_to_load_pending': 'Error al cargar los cargos pendientes',
    'failed_to_load_history': 'Error al cargar el historial',
    'fee_waived': 'Cargo exonerado',
    'failed_to_waive': 'Error al exonerar',
    'late_fee_assessed': 'Cargo por retraso evaluado',
    'failed_to_assess': 'Error al evaluar',
    'days_overdue': 'Días de retraso',
    'projected_fee': 'Cargo proyectado',
    'last_fee': 'Último cargo',
    'waive_amount_label': 'Monto de exoneración ($)',
    'not_found': 'No encontrado',
    'never': 'Nunca',
    'balance': 'Saldo',
    'source': 'Fuente',
    'auto_label': 'Auto',
    'manual_label': 'Manual',
    'late_fees_disabled': 'Cargos por retraso desactivados',
    'of_rent': 'del alquiler',
    'day_grace': 'días de gracia',
    'no_pending_late_fees': 'Ningún inquilino tiene cargos por retraso pendientes en este momento.',
    'enable_late_fees_hint': 'Active los cargos por retraso en la configuración para comenzar el seguimiento.',
    'no_late_fee_records': 'No se encontraron registros de cargos por retraso.',
    'all_late_fee_charges': 'Todos los cargos por retraso',
    'failed_to_load_owner_balances': 'Error al cargar los saldos de los propietarios',
    'select_at_least_one_owner': 'Seleccione al menos un propietario',
    'confirm_bulk_payout': '¿Pagar a {{count}} propietario(s) un total de {{amount}}?',
    'bulk_payout_success': 'Pagado a {{count}} propietario(s) — {{amount}} en total',
    'bulk_payout_failed': 'Error en el pago masivo',
    'bulk_owner_payout': 'Pago masivo a propietarios',
    'bulk_payout_subtitle': 'Pague a todos los propietarios con saldos pendientes en un solo lote',
    'total_owed_all': 'Total adeudado (todos los propietarios)',
    'owners_with_balance': 'Propietarios con saldo',
    'selected_to_pay': 'Seleccionado para pagar',
    'balance_owed': 'Saldo adeudado',
    'last_payout': 'Último pago',
    'payout_settings': 'Configuración de pago',
    'period_month': 'Mes del período',
    'payout_notes_placeholder': 'p. ej. Distribución mensual',
    'pay_owners_btn': 'Pagar a {{count}} propietario(s) · {{amount}}',
    'last_batch_results': 'Resultados del último lote',
    'wire_transfer': 'Transferencia cablegráfica',
    'status_held': 'Retenido',
    'status_returned': 'Devuelto',
    'status_not_collected': 'No cobrado',
    'error_loading_deposits': 'Error al cargar los depósitos de seguridad',
    'deposit_collected': 'Depósito de seguridad cobrado',
    'deposit_returned': 'Depósito de seguridad devuelto',
    'security_deposits_subtitle': 'Seguimiento de depósitos conforme — legalmente separado del alquiler',
    'total_held': 'Total retenido',
    'active_deposits': 'Depósitos activos',
    'deposits_returned': 'Depósitos devueltos',
    'all_tenants_deposit_status': 'Todos los inquilinos — Estado del depósito',
    'paid_on': 'Pagado el',
    'collect': 'Cobrar',
    'return': 'Devolver',
    'collect_security_deposit': 'Cobrar depósito de seguridad',
    'return_security_deposit': 'Devolver depósito de seguridad',
    'damages_unpaid_rent': 'daños, alquiler impago, etc.',
    'optional_notes': 'Notas opcionales...',
    'record_collection': 'Registrar cobro',
    'record_return': 'Registrar devolución',
    'deposit_amount_placeholder': 'ej. 1500.00',
    'error_loading_utility_data': 'Error al cargar los datos de servicios públicos',
    'utility_account_created': 'Cuenta de servicios públicos creada',
    'reading_recorded_generate_bills': 'Lectura registrada — genere las facturas a continuación',
    'rubs_complete_msg': 'RUBS completado — se facturó a {{count}} inquilinos {{amount_each}} a cada uno (total {{total}})',
    'no_pending_bills_to_charge': 'No hay facturas pendientes para cobrar',
    'confirm_charge_all_bills': '¿Publicar {{count}} facturas pendientes en los libros mayores de los inquilinos?',
    'confirm_charge_all_bills_title': 'Cobrar todas las facturas pendientes',
    'charge_all_success_msg': '¡{{count}} facturas publicadas en los libros mayores!{{failed_msg}}',
    'generate_bills_btn': 'Generar facturas',
    'generate_from_meters': 'Generar desde medidores',
    'charge_all_btn': 'Cobrar todo ({{count}})',
    'bills_generated_msg': '{{count}} facturas de servicios generadas',
    'rubs_failed': 'Error en el cálculo RUBS',
    'failed_to_update_account': 'Error al actualizar la cuenta',
    'utility_management': 'Gestión de Servicios Públicos',
    'utility_subtitle': 'Seguimiento de medidores, lecturas y facturación de servicios a inquilinos',
    'add_account': 'Añadir cuenta',
    'utility_accounts': 'Cuentas de Servicios Públicos',
    'no_utility_accounts': 'No hay cuentas — añada una para comenzar',
    'provider': 'Proveedor',
    'account_number_label': 'N.º de cuenta',
    'meter_number_label': 'N.º de medidor',
    'utility_bills': 'Facturas de Servicios Públicos',
    'no_bills_found_msg': 'No se encontraron facturas — use "Generar facturas"',
    'period': 'Periodo',
    'usage': 'Consumo',
    'charge_tenant': 'Cobrar al inquilino',
    'add_utility_account': 'Añadir cuenta de servicios públicos',
    'add_utility_account_subtitle': 'Registrar un nuevo medidor o servicio',
    'utility_type': 'Tipo de servicio',
    'provider_name': 'Nombre del proveedor',
    'provider_placeholder': 'ej. Compañía Eléctrica',
    'shared_meter': 'Medidor compartido (cubre todo el edificio)',
    'add_meter_reading': 'Añadir lectura',
    'reading_value': 'Lectura actual',
    'reading_date': 'Fecha de lectura',
    'record_reading': 'Registrar lectura',
    'error_loading_kpi_data': 'Error al cargar los datos KPI',
    'snapshot_complete': 'Instantánea completada',
    'snapshot_failed': 'Error al tomar instantánea',
    'kpi_dashboard': 'Panel KPI',
    'kpi_subtitle': 'Rendimiento del portafolio en vivo — ocupación, NOI, tasa de capitalización, tasa de cobro',
    'capturing': 'Capturando...',
    'snapshot_now': 'Instantánea ahora',
    'occupancy_rate': 'Tasa de ocupación',
    'annual_gross_rent': 'Alquiler bruto anual',
    'portfolio_value': 'Valor del portafolio',
    'total_units': 'Unidades totales',
    'units_occupied_msg': '{{occupied}} de {{total}} unidades ocupadas',
    'per_month_suffix': '{{amount}} / mes',
    'equity_label_val': '{{amount}} de capital',
    'vacant_units_count': '{{count}} vacantes',
    'kpi_step1': 'Haga clic en "Instantánea ahora" para calcular las métricas de hoy para todos los edificios',
    'kpi_step2': 'La instantánea se ejecuta automáticamente cada noche',
    'kpi_step3': 'Registre tasaciones de propiedades en la página de Portafolio para desbloquear Cap Rate y rendimiento',
    'per_building_metrics': 'Métricas por edificio',
    'no_snapshots_yet': 'No hay instantáneas — haga clic en "Instantánea ahora" para generar',
    'collection_rate': 'Cobro',
    'monthly_noi': 'NOI mensual',
    'cap_rate': 'Cap Rate',
    'gross_yield': 'Rendimiento bruto',
    'overdue_tenants': 'Vencidos',
    'investment_summary': 'Resumen de inversión',
    'current_value': 'Valor actual',
    'purchase_cost': 'Costo de compra',
    'equity': 'Capital principal',
    'error_loading_portfolio_data': 'Error al cargar los datos del portafolio',
    'valuation_recorded': 'Tasación registrada',
    'investment_portfolio': 'Portafolio de inversión',
    'portfolio_subtitle': 'Valoración del portafolio, capital, cap rate y rendimiento por edificio',
    'record_valuation': 'Registrar tasación',
    'total_portfolio_value': 'Valor del portafolio',
    'annualized_amount': '{{amount}} anualizado',
    'avg_cap_rate': 'Cap Rate promedio',
    'annualized': 'Anualizado',
    'avg_gross_yield': 'Rendimiento bruto promedio',
    'gross_rent_on_value': 'Alquiler bruto / valor',
    'portfolio_step1': 'Haga clic en "Registrar tasación" para ingresar el valor de mercado actual de un edificio',
    'portfolio_step2': 'Cap Rate = NOI anual ÷ Valor de la propiedad × 100',
    'portfolio_step3': 'Rendimiento bruto = Alquiler bruto anual ÷ Valor de la propiedad × 100',
    'portfolio_step4': 'Los datos de NOI provienen del panel KPI — ejecute una instantánea primero',
    'per_building_breakdown': 'Desglose por edificio',
    'no_portfolio_data': 'Sin datos de portafolio — ejecute una instantánea de KPI primero, luego registre tasaciones',
    'last_valuation': 'Última tasación',
    'occupied_short': 'occ.',
    'no_valuation': 'Sin tasación',
    'update_value': 'Actualizar valor',
    'record_valuation_subtitle': 'Registrar el valor de mercado actual para un edificio',
    'appraised_value': 'Valor tasado',
    'valuation_date': 'Fecha',
    'method': 'Método',
    'record': 'Registrar',
    'error_loading_accounts': 'Error al cargar las cuentas',
    'error_loading_journal_entries': 'Error al cargar los asientos de diario',
    'error_loading_trial_balance': 'Error al cargar el balance de comprobación',
    'error_loading_pnl': 'Error al cargar el estado de resultados',
    'gl_account_required_fields': 'El código, el nombre y el tipo son obligatorios',
    'account_created': 'Cuenta creada',
    'journal_min_lines_error': 'Se requieren al menos 2 líneas',
    'entry_out_of_balance_error': 'Entrada fuera de balance: débitos {{debits}} ≠ créditos {{credits}}',
    'journal_account_required_error': 'Todas las líneas deben tener una cuenta seleccionada',
    'journal_entry_posted': 'Asiento de diario contabilizado',
    'reason_for_reversal_prompt': 'Motivo de la reversión:',
    'entry_reversed': 'Asiento revertido',
    'reversal_failed': 'Error al revertir',
    'chart_of_accounts': 'Plan de cuentas',
    'journal_entries': 'Asientos de diario',
    'trial_balance': 'Balance de comprobación',
    'pnl_statement': 'Estado de resultados',
    'general_ledger': 'Libro mayor',
    'gl_subtitle': 'Plan de cuentas, asientos, balance y resultados',
    'new_gl_account': 'Nueva cuenta mayor',
    'normal_balance': 'Saldo normal',
    'no_accounts_found': 'No se encontraron cuentas',
    'all_sources': 'Todas las fuentes',
    'new_entry': 'Nuevo asiento',
    'new_journal_entry': 'Nuevo asiento de diario',
    'select_account': 'Seleccionar cuenta...',
    'line_description_placeholder': 'Descripción de línea',
    'balanced_msg': '✓ Cuadrado',
    'out_of_balance_amount': 'Fuera de balance por {{amount}}',
    'add_line': '+ Añadir línea',
    'post_entry': 'Contabilizar asiento',
    'posting': 'Contabilizando...',
    'no_journal_entries_found': 'No se encontraron asientos de diario',
    'reversed': 'Revertido',
    'posted': 'Contabilizado',
    'draft': 'Borrador',
    'lines_count': '{{count}} líneas',
    'as_of_date': 'A la fecha',
    'balanced': 'Cuadrado',
    'out_of_balance': 'Descuadrado',
    'net': 'Neto',
    'total_revenue': 'Ingresos totales',
    'total_expenses': 'Gastos totales',
    'net_income': 'Ingresos netos',
    'no_revenue_entries': 'No hay entradas de ingresos',
    'no_expense_entries': 'No hay entradas de gastos',
    'select_date_range_run_msg': 'Seleccione un rango de fechas y haga clic en Ejecutar',
    'asset': 'Activo',
    'liability': 'Pasivo',
    'revenue': 'Ingreso',
    'expense': 'Gasto',
    'market': 'Mercado',
    'income': 'Ingresos',
    'cost': 'Costo',
    'broker_opinion': 'Opinión de corredor',
    'appraisal': 'Tasación',
    'waive_confirm_hint': 'Exonerando cargo por retraso para {{name}}. Esto agrega una entrada de crédito a su libro mayor — el cargo original se conserva para auditoría.',
    'enter_reason_error': 'Por favor ingrese un motivo',
    'enter_valid_amount_error': 'Ingrese un monto válido',
    'confirm_manual_assess': '¿Evaluar manualmente un cargo por retraso para {{name}}?',
    'search_late_fees': 'Buscar inquilino, unidad, edificio...',
    'page_info': 'Página {{current}} de {{total}}',

    'reports': 'Informes',
    'reports_dashboard': 'Panel de Informes',
    'revenue_report': 'Informe de Ingresos',
    'payment_logs': 'Registros de Pagos',
    'occupancy_report': 'Informe de Ocupación',
    'tenant_payments': 'Pagos de Inquilinos',
    'building_revenue': 'Ingresos por Edificio',
    'owner_revenue': 'Ingresos de Propietarios',

    'activity_logs': 'Registros de Actividad',
    'all_activities': 'Todas las Actividades',
    'tenant_activities': 'Actividades de Inquilinos',
    'monthly_revenue': 'Ingresos Mensuales',

    'settings': 'Configuración',
    'profile_settings': 'Configuración de Perfil',
    'system_settings': 'Configuración del Sistema',

    'logout': 'Cerrar Sesión',
    'sales': 'Ventas',
    'inspections': 'Inspecciones',
    'maintenance_hub': 'Centro de mantenimiento',
    'vendors': 'Proveedores',
    'finance': 'Finanzas',
    'transactions': 'Transacciones',
    'service_charges': 'Cargos de servicio',
    'owner_installments': 'Cuotas del propietario',
    'financial_matrix': 'Matriz financiera',
    'cash_flow_forecast': 'Pronóstico de 7 días',
    'receivables': 'Cuentas por cobrar',
    'receivables_sub': 'Dinero que le deben, por antigüedad.',
    'no_receivables': 'Nadie debe nada.',
    'books_need_attention': 'La contabilidad necesita atención',
    'books_tie_out': 'Las cuentas por cobrar cuadran con el libro mayor',
    'ar_gl_drift': 'Las cuentas por cobrar no cuadran con el libro mayor',
    'unmirrored_charges': 'cargos',
    'unmirrored_payments': 'pagos',
    'not_in_receivables': 'aún no están en Cuentas por cobrar',
    'closed_periods': 'período(s) cerrado(s)',
    'fix_now': 'Corregir ahora',
    'fixing': 'Corrigiendo…',
    'accounting_statement': 'Estado de cuenta →',
    'statement': 'estado de cuenta',
    'open_full_record': 'Abrir registro completo →',
    'credit_on_account': 'saldo a favor',
    'opening_balance': 'Saldo inicial',
    'closing_balance': 'Saldo final',
    'no_activity': 'Sin actividad en este período.',
    'charge': 'Cargo',
    'kind_rent': 'Alquiler',
    'kind_service': 'Cargo por servicio',
    'kind_late_fee': 'Recargo por mora',
    'kind_utility': 'Servicios',
    'kind_parking': 'Estacionamiento',
    'kind_deposit': 'Depósito',
    'kind_sale_installment': 'Cuota de venta',
    'kind_management_fee': 'Comisión de gestión',
    'kind_maintenance_fee': 'Cargo de mantenimiento',
    'kind_payment': 'Pago',
    'ledger_activity_report': 'Actividad del libro mayor',
    'management_fee_report': 'Comisiones de gestión',
    'messages': 'Mensajes',
    'announcements_manager': 'Gestor de anuncios',
    'all_announcements': 'Todos los anuncios',
    'subscription': 'Suscripción',
    'contract_templates': 'Plantillas de contrato',
    'whatsapp_and_sms': 'WhatsApp y SMS',
    'late_fees_org_config': 'Recargos por mora y Config Org',
    'building_amenities': 'Servicios del edificio',
    'parking_spaces': 'Plazas de aparcamiento',
    'amenity_bookings': 'Reservas de servicios',
    'pm_schedules': 'Horarios de PM',
    'work_orders': 'Órdenes de trabajo',
    'security_deposits': 'Depósitos de seguridad',
    'expenses': 'Gastos',
    'late_fees': 'Recargos por mora',
    'bulk_owner_payout': 'Pago masivo a propietarios',
    'utilities': 'Servicios públicos',
    'kpi_dashboard': 'Panel de KPI',
    'portfolio': 'Portafolio',
    'general_ledger': 'Libro mayor general',
    'reports_1099': 'Informes 1099',
    'notification_log': 'Registro de notificaciones',
    'all_messages': 'Todos los mensajes',
    'notification_log': 'Registro de notificaciones',

    // AI Intelligence & Sidebar
    'ai_intelligence': 'Inteligencia Artificial',
    'rent_pricing_ai': 'Precios de Alquiler IA',
    'churn_prediction': 'Predicción de Abandono',
    'showings': 'Visitas',
    'tenant_surveys': 'Encuestas de Inquilinos',
    'insurance': 'Seguro',
    'vendor_1099': 'Proveedor 1099',
    'rent_roll': 'Registro de Alquileres',
    'ar_aging': 'Antigüedad de Cuentas',
    'webhooks': 'Webhooks',

    // AI Rent Pricing Page
    'ai_rent_pricing': 'Precios de Alquiler IA',
    'ai_rent_pricing_desc': 'Obtenga sugerencias de alquiler de mercado basadas en IA según sus comparables de cartera, ocupación y tendencias de renovación',
    'select_unit_to_analyze': 'Seleccionar unidad para analizar',
    'choose_an_apartment': 'Elegir un apartamento...',
    'analyze': 'Analizar',
    'analyzing': 'Analizando...',
    'ai_recommended_rent': 'Alquiler Recomendado por IA',
    'range': 'Rango',
    'high_confidence': 'Alta',
    'medium_confidence': 'Media',
    'low_confidence': 'Baja',
    'confidence_suffix': 'confianza',
    'comparable_units_found': 'Unidades Comparables ({{count}} encontradas)',
    'avg_comparable_rent': 'Promedio: {{amount}}/mes',
    'vs_suggestion': 'vs sugerencia',
    'select_unit_analyze_desc': 'Seleccione una unidad y haga clic en Analizar',
    'claude_analyze_desc': 'La IA analizará comparables, ocupación y tendencias para sugerir el alquiler óptimo',

    // Churn Prediction Page
    'churn_prediction_desc': 'Probabilidad de renovación por IA para todos los inquilinos activos',
    'run_ai_scoring': 'Ejecutar Scoring IA',
    'running': 'Ejecutando...',
    'high_churn_risk': 'Alto Riesgo de Abandono',
    'medium_risk': 'Riesgo Medio',
    'likely_to_renew': 'Probable que Renueve',
    'no_churn_scores': 'Aún no hay puntuaciones de abandono',
    'run_scoring_desc': 'Haga clic en "Ejecutar Scoring IA" para analizar todos los inquilinos activos',
    'run_scoring_now': 'Ejecutar Scoring Ahora',
    'renewal_score': 'Puntuación de Renovación',
    'risk_level': 'Nivel de Riesgo',
    'lease_ends': 'Fin del Contrato',
    'key_factors': 'Factores Clave',
    'send_offer': 'Enviar Oferta',
    'late_payments_6m': '{{count}} pagos atrasados',
    'current_balance_factor': 'Saldo de ${{amount}}',
    'prior_renewals_factor': '{{count}} renovaciones previas',

    // Showings Page
    'showings_desc': 'Programar y seguir visitas a propiedades para prospectos',
    'schedule_showing': 'Programar Visita',
    'upcoming': 'Próximas',
    'today': 'Hoy',
    'no_shows': 'No Presentados',
    'all': 'Todo',
    'no_showings_found': 'No se encontraron visitas',
    'schedule_first_showing': 'Programar Primera Visita',
    'prospect': 'Prospecto',
    'unit': 'Unidad',
    'date_and_time': 'Fecha y Hora',
    'scheduled': 'Programada',
    'completed': 'Completada',
    'cancelled': 'Cancelada',
    'no_show': 'No Presentado',
    'edit_showing': 'Editar Visita',
    'prospect_name': 'Nombre del Prospecto',
    'prospect_phone': 'Teléfono',
    'prospect_email': 'Correo electrónico',
    'start_time': 'Hora de Inicio',
    'end_time': 'Hora de Fin',
    'assigned_to': 'Asignado a',
    'notes': 'Notas',

    // Insurance Page
    'insurance_tracking': 'Seguimiento de Seguros',
    'insurance_desc': 'Gestionar pólizas de seguro de inquilino, propietario y edificio',
    'add_policy': 'Agregar Póliza',
    'expiring_30d': 'Vence en 30d',
    'total_coverage': 'Cobertura Total',
    'all_status': 'Todos los Estados',
    'all_types': 'Todos los Tipos',
    'no_policies_found': 'No se encontraron pólizas',
    'add_first_policy': 'Agregar Primera Póliza',
    'entity': 'Entidad',
    'insurer': 'Aseguradora',
    'policy_type': 'Tipo de Póliza',
    'coverage': 'Cobertura',
    'expiry': 'Vencimiento',
    'expired_days_ago': 'Venció hace {{days}}d',
    'days_left': '{{days}}d restantes',
    'edit_policy': 'Editar Póliza',
    'entity_type': 'Tipo de Entidad',
    'policy_number': 'Número de Póliza',
    'coverage_amount': 'Monto de Cobertura',
    'annual_premium': 'Prima Anual',
    'start_date': 'Fecha de Inicio',
    'expiry_date': 'Fecha de Vencimiento',
    'document_url': 'URL del Documento (Enlace COI)',

    // Survey Results Page
    'tenant_surveys_desc': 'Calificaciones CSAT y comentarios de los inquilinos',
    'overall_rating': 'Calificación Global',
    'distribution': 'Distribución',
    'by_category': 'Por Categoría',
    'no_surveys_yet': 'Aún no hay encuestas',
    'tenants_submit_feedback_desc': 'Los inquilinos pueden enviar comentarios a través de su portal',

    // Financial Matrix
    'financial_matrix_subtitle': 'Vista unificada de toda la actividad financiera en cada unidad',
    'total_charged': 'Total Cargado',
    'total_collected': 'Total Recaudado',
    'overdue_balance': 'Saldo Atrasado',
    'partial_balance': 'Saldo Parcial',
    'all_floors': 'Todos los Pisos',
    'floor_label': 'Piso',
    'legend_paid': 'Pagado',
    'legend_partial': 'Parcial',
    'legend_overdue': 'Atrasado',
    'legend_upcoming': 'Próximo',
    'legend_no_charges': 'Sin cargos',
    'table_unit': 'Unidad',
    'table_now': 'ahora',
    'no_apartments_found_building': 'No se encontraron apartamentos para este edificio.',
    'view_all': 'Todo',
    'view_rent': 'Alquiler',
    'view_service': 'Servicio',
    'view_sales': 'Ventas',

    // Cash Flow Forecast
    'cash_flow_subtitle': 'Próximos pagos esperados de inquilinos y propietarios',
    'expected_this_period': 'Esperado en este período',
    'total_overdue_balance': 'Saldo total atrasado',
    'collected_today': 'Recaudado hoy',
    'no_upcoming_payments': 'No hay pagos próximos en este período.',
    'today': 'Hoy',
    'overdue_label': 'ATRASADO',
    'expected_label': 'esperado',

    // Quick Pay
    'quick_pay': 'Pago rápido',
    'recording': 'Registrando...',
    'record_payment_btn': 'Registrar pago de {{amount}}',
    'no_active_tenant_error': 'No hay inquilino activo — el pago no se puede registrar aquí.',
    'view_full_ledger': 'Ver libro mayor completo para {{name}}',
    'full_payment_form': 'Formulario de pago completo',
    'enter_valid_amount': 'Ingrese un monto válido',
    'no_active_tenant_found': 'No se encontró un inquilino activo para esta unidad',
    'payment_recorded_success': 'Pago registrado exitosamente',
    'treasury_quick_pay': 'Pago Rápido de Tesorería',
    'payment_amount': 'Monto del pago',
    'memo': 'Memorándum / Referencia',
    'add_a_note_about_this_treasury_event': 'Agregar una nota sobre este evento...',
    'view_owner_file_and_distribution': 'Ver expediente del propietario',
    'view_resident_ledger': 'Ver libro mayor del residente',
    'processing': 'Procesando...',
    'confirm_and_record': 'Confirmar y registrar',
    'no_entity_found': 'No se encontró inquilino ni propietario para esta unidad',
    'owner_view': 'Propietario',
    'tenant_view': 'Inquilino',
    'search_owner_unit_building': 'Buscar propietario, unidad, edificio...',
    'showing_all_installments': 'Mostrando todas las {{count}} cuotas',
    'showing_overdue_within_days': 'Mostrando vencidos + con vencimiento en {{days}} días · {{hidden}} cuotas futuras ocultas',
    'hide_future_count': 'Ocultar futuros ({{count}})',
    'show_all_future_count': 'Mostrar todos los futuros ({{count}})',
    'no_overdue_upcoming_all_clear': '¡Sin pagos vencidos o próximos — todo en orden!',
    'no_records_match_search': 'Ningún registro coincide con su búsqueda.',

    // Months Short
    'jan_short': 'Ene', 'feb_short': 'Feb', 'mar_short': 'Mar', 'apr_short': 'Abr', 'may_short': 'May', 'jun_short': 'Jun',
    'jul_short': 'Jul', 'aug_short': 'Ago', 'sep_short': 'Sep', 'oct_short': 'Oct', 'nov_short': 'Nov', 'dec_short': 'Dic',

    // Months Full
    'january': 'Enero', 'february': 'Febrero', 'march': 'Marzo', 'april': 'Abril', 'may': 'Mayo', 'june': 'Junio',
    'july': 'Julio', 'august': 'Agosto', 'september': 'Septiembre', 'october': 'Octubre', 'november': 'Noviembre', 'december': 'Diciembre',

    // AI Assistant
    'ai_assistant': 'Asistente de IA',
    'ask_ai': 'Preguntar a la IA',
    'ai_greeting': "¡Hola! Soy tu analista financiero de IA. ¿Cómo puedo ayudarte hoy?",
    'ai_error': "Lo siento, no pude procesar eso. Por favor, inténtalo de nuevo.",
    'analyzing_data': 'Analizando datos...',
    'ai_placeholder': '¿Qué te gustaría saber?',
    'overdue_tenants_q': '¿Qué inquilinos están atrasados?',
    'revenue_30d_q': '¿Ingresos de los últimos 30 días?',
    'expenses_month_q': '¿Gastos de este mes?',
    'utility_pending_q': '¿Facturas de servicios pendientes?',
    'kpi_noi_summary_q': '¿Resumen de KPI y NOI?',
    'security_deposits_q': '¿Depósitos de seguridad retenidos?',
    'late_fees_q': '¿Recargos por mora cobrados?',
    'owner_payouts_q': '¿Pagos a propietarios de este mes?',


    // Apartment Detail View
    'loading_apartment_details': 'Cargando detalles del apartamento...',
    'error_loading_apartment': 'Error al cargar detalles del apartamento',
    'try_again': 'Intentar de Nuevo',
    'back_to_apartments': 'Volver a Apartamentos',
    'apartment_not_found': 'Apartamento No Encontrado',
    'apartment_not_found_message': 'El apartamento que buscas no existe o ha sido eliminado.',

    'building_and_location': 'Edificio y Ubicación',
    'building': 'Edificio',
    'floor': 'Piso',
    'address': 'Dirección',

    'apartment_details': 'Detalles del Apartamento',
    'apartment_type': 'Tipo',
    'size': 'Tamaño',
    'furnished': 'Amueblado',

    'owner_information': 'Información del Propietario',
    'owner_name': 'Nombre',
    'owner_contact': 'Contacto',

    'additional_information': 'Información Adicional',
    'created_at': 'Creado El',
    'updated_at': 'Última Actualización',

    'status_management': 'Gestión de Estado',
    'status_vacant': 'Vacante',
    'status_occupied': 'Ocupado',
    'status_maintenance': 'En Mantenimiento',
    'status_vacant_description': 'Disponible para alquilar o arrendar',
    'status_occupied_description': 'Actualmente alquilado a un inquilino',
    'status_maintenance_description': 'En mantenimiento o renovación',
    'change_status': 'Cambiar Estado A',

    'quick_actions': 'Acciones Rápidas',
    'create_lease': 'Crear Contrato',
    'view_tenant_info': 'Ver Info del Inquilino',
    'mark_maintenance_complete': 'Marcar Mantenimiento Completado',
    'view_building': 'Ver Edificio',
    'edit_apartment': 'Editar Apartamento',

    'same_building_apartments': 'Mismo Edificio',
    'view_all_apartments_in_building': 'Ver Todos los Apartamentos en el Edificio',
    'view_vacant_apartments': 'Ver Apartamentos Vacantes',

    // Delete confirmation
    'delete_apartment_confirmation': '¿Estás seguro de que deseas eliminar el apartamento "{{name}}"? Esta acción no se puede deshacer.',

    // Apartment Form
    'loading_apartment_data': 'Cargando datos del apartamento...',
    'edit_apartment': 'Editar Apartamento',
    'add_new_apartment': 'Añadir Nuevo Apartamento',

    'basic_information': 'Información Básica',
    'apartment_number': 'Número de Apartamento',
    'enter_apartment_number': 'Ingresa el número de apartamento',
    'floor_number': 'Número de Piso',
    'enter_floor_number': 'Ingresa el número de piso',
    'size_sqm': 'Tamaño (m²)',
    'enter_size': 'Ingresa el tamaño en metros cuadrados',
    'apartment_type': 'Tipo de Apartamento',
    'select_apartment_type': 'Selecciona el tipo de apartamento',
    'select_building': 'Selecciona edificio',
    'furnished': 'Amueblado',

    // Validation messages
    'floor_required': 'El piso es requerido',
    'apartment_number_required': 'El número de apartamento es requerido',
    'size_required': 'El tamaño es requerido',
    'type_required': 'El tipo es requerido',
    'building_required': 'El edificio es requerido',
    'invalid_size': 'El tamaño debe ser mayor que 0',

    // Form actions
    'update': 'Actualizar',
    'save': 'Guardar',
    'saving': 'Guardando...',


    // Apartment List
    'apartments': 'Apartamentos',
    'search_apartments': 'Buscar apartamentos...',
    'filter': 'Filtrar',
    'grid_view': 'Cuadrícula',
    'list_view': 'Lista',
    'add_apartment': 'Añadir Apartamento',
    'all_buildings': 'Todos los Edificios',
    'all_types': 'Todos los Tipos',
    'all_statuses': 'Todos los Estados',
    'all': 'Todo',
    'vacant_apartments': 'Apartamentos Vacantes',
    'occupied_apartments': 'Apartamentos Ocupados',
    'maintenance_apartments': 'En Mantenimiento',
    'loading_apartments': 'Cargando apartamentos...',
    'error_loading_apartments': 'Error al cargar apartamentos',
    'no_apartments_found': 'No se encontraron apartamentos',
    'no_apartments_message': 'Aún no hay apartamentos en el sistema.',
    'create_first_apartment': 'Crear el Primer Apartamento',
    'showing_filtered_results': 'Mostrando {{showing}} de {{total}} apartamentos',

    // Statuses
    'vacant': 'Vacante',
    'occupied': 'Ocupado',
    'maintenance': 'En Mantenimiento',

    // Apartment card
    'furnished': 'Amueblado',

    // Delete confirmation
    'delete_apartment_confirmation': '¿Estás seguro de que deseas eliminar el apartamento "{{name}}"? Esta acción no se puede deshacer.',
    'deleting': 'Eliminando...',


    // Bulk Apartment Creator
    'bulk_apartment_creation': 'Creación Masiva de Apartamentos',
    'preview': 'Previsualizar',
    'apartment_number_format': 'Formato del Número de Apartamento',
    'format_pattern': 'Patrón de Formato',
    'format_pattern_help': 'Usa {floor} para número de piso y {unit} para número de unidad. Ejemplo: {floor}{unit} = 0201',
    'preview_example': 'Ejemplo de Previsualización',
    'floor_plans': 'Planos de Planta',
    'add_floor_plan': 'Añadir Plano de Planta',
    'floor_plan_number': 'Plano de Planta {number}',
    'floors_comma_separated': 'Pisos (separados por coma)',
    'unit_types': 'Tipos de Unidad',
    'add_unit_type': 'Añadir Tipo de Unidad',
    'unit_type_number': 'Tipo de Unidad {number}',
    'name': 'Nombre',
    'quantity': 'Cantidad',
    'type': 'Tipo',
    'area_sqm': 'Área (m²)',
    'furnished': 'Amueblado',
    'apartment_preview_count': 'Previsualización de Apartamentos ({count} unidades)',
    'floor_unit_type': 'Piso {floor} • {type}',
    'close': 'Cerrar',
    'create_apartments': 'Crear Apartamentos',
    'create_apartments_count': 'Crear {count} Apartamentos',
    'creating_apartments': 'Creando Apartamentos...',
    'add_at_least_one_floor_plan': 'Por favor añade al menos un plano de planta',
    'no_apartments_to_create': 'No hay apartamentos para crear',


    'building_name_required': 'El nombre del edificio es requerido',
    'building_address_required': 'La dirección del edificio es requerida',
    'invalid_floors': 'El total de pisos debe ser al menos 1',
    'invalid_apartments': 'El total de apartamentos debe ser al menos 0',
    'loading_building_data': 'Cargando datos del edificio...',
    'edit_building': 'Editar Edificio',
    'add_new_building': 'Añadir Nuevo Edificio',
    'basic_information': 'Información Básica',
    'building_name': 'Nombre del Edificio',
    'enter_building_name': 'Ingresa el nombre del edificio',
    'total_floors': 'Total de Pisos',
    'number_of_floors': 'Número de pisos',
    'total_apartments': 'Total de Apartamentos',
    'number_of_apartments': 'Número de apartamentos',
    'address': 'Dirección',
    'enter_complete_building_address': 'Ingresa la dirección completa del edificio',
    'cancel': 'Cancelar',
    'saving': 'Guardando...',
    'update': 'Actualizar',
    'save': 'Guardar',


    'buildings': 'Edificios',
    'search_buildings': 'Buscar edificios...',
    'bulk_add_apartments': 'Añadir Apartamentos Masivamente',
    'add_building': 'Añadir Edificio',
    'loading_buildings': 'Cargando edificios...',
    'error_loading_buildings': 'Error al Cargar Edificios',
    'try_again': 'Intentar de Nuevo',
    'no_buildings_found': 'No se encontraron edificios',
    'no_buildings_yet': 'Sin Edificios Todavía',
    'no_buildings_match_search': 'Ningún edificio coincide con "{{search}}"',
    'no_buildings_message': 'Aún no hay edificios en el sistema. Añade tu primer edificio para empezar.',
    'create_first_building': 'Crear el Primer Edificio',
    'showing_filtered_results': 'Mostrando {{showing}} de {{total}} edificios',
    'floors': 'Pisos',
    'apartments': 'Apartamentos',
    'occupancy': 'Ocupación',
    'vacant': 'Vacante',
    'occupied': 'Ocupado',
    'no_apartments_yet': 'Aún no hay apartamentos',
    'add_apartments': '+ Añadir Apartamentos',
    'confirm_deletion': 'Confirmar Eliminación',
    'delete_building_confirmation': '¿Estás seguro de que deseas eliminar el edificio "{{name}}"? Esta acción no se puede deshacer.',
    'cancel': 'Cancelar',
    'deleting': 'Eliminando...',
    'delete': 'Eliminar',
    'create_building_first': 'Por favor crea un edificio primero',
    'create': 'Crear Apartamentos',
    'unnamed_building': 'Edificio sin Nombre',
    'no_address_provided': 'No se proporcionó dirección',

    'select_building_for_bulk_creation': 'Selecciona Edificio para Creación Masiva de Apartamentos',

    'loading_building_details': 'Cargando detalles del edificio...',
    'error_loading_building': 'Error al cargar edificio',
    'try_again': 'Intentar de Nuevo',
    'back_to_buildings': 'Volver a Edificios',
    'building_not_found': 'Edificio No Encontrado',
    'building_not_found_message': 'El edificio que buscas no existe o ha sido eliminado.',
    'add_apartment': 'Añadir Apartamento',
    'edit_building': 'Editar Edificio',
    'generate_reports': 'Generar Informes',
    'total_apartments': 'Total de Apartamentos',
    'units': 'unidades',
    'across_floors': 'En {{floors}} pisos',
    'vacant_apartments': 'Vacante',
    'available_for_rent': 'Disponible para alquilar',
    'no_vacancies': 'Sin vacantes',
    'occupancy_rate': 'Tasa de Ocupación',
    'occupied_units': 'unidades ocupadas',
    'maintenance_apartments': 'Mantenimiento',
    'needs_attention': 'Necesita atención',
    'average_apartment_size': 'Tamaño Promedio',
    'furnished_apartments': 'Amueblado',
    'utility_status': 'Estado de Servicios Públicos',
    'water': 'Agua',
    'electricity': 'Electricidad',
    'internet': 'Internet',
    'hide_details': 'Ocultar Detalles',
    'show_details': 'Mostrar Detalles',
    'search_apartments': 'Buscar apartamentos, propietarios, inquilinos...',
    'all_statuses': 'Todos los Estados',
    'vacant': 'Vacante',
    'occupied': 'Ocupado',
    'maintenance': 'Mantenimiento',
    'top_floor_first': 'Piso Superior Primero',
    'ground_floor_first': 'Planta Baja Primera',
    'showing_results': 'Mostrando {{count}} de {{total}} apartamentos',
    'matching': 'coincidentes',
    'with_status': 'con estado',
    'no_apartments_found': 'No se encontraron apartamentos',
    'no_apartments_match_filters': 'No hay apartamentos que coincidan con tus filtros actuales.',
    'clear_filters': 'Limpiar Filtros',
    'floor_number': 'Piso {{number}}',
    'apartments': 'apartamentos',
    'owner': 'Propietario',
    'status': 'Estado',
    'vacant_status': 'Disponible',
    'maintenance_status': 'En Mantenimiento',
    'furnished': 'Amueblado',
    'unfurnished': 'Sin amueblar',
    'no_matching_apartments_on_floor': 'No hay apartamentos en el piso {{floor}} que coincidan con tus filtros actuales.',
    'construction_year': 'Año de Construcción: {{year}}',

    'activity_logs': 'Registros de Actividad',
    'track_all_system_activities': 'Rastrea todas las actividades y cambios del sistema',
    'filter': 'Filtrar',
    'export_to_excel': 'Exportar a Excel',
    'exporting': 'Exportando...',
    'filter_logs': 'Filtrar Registros',
    'action_type': 'Tipo de Acción',
    'all_actions': 'Todas las Acciones',
    'entity_type': 'Tipo de Entidad',
    'all_entities': 'Todas las Entidades',
    'entries_per_page': 'Entradas por Página',
    'start_date': 'Fecha de Inicio',
    'end_date': 'Fecha de Fin',
    'reset': 'Restablecer',
    'apply_filter': 'Aplicar Filtro',
    'previous': 'Anterior',
    'next': 'Siguiente',
    'tenant_activity_logs': 'Registros de Actividad de Inquilinos',
    'payment_activity_logs': 'Registros de Actividad de Pagos',
    'building_activity_logs': 'Registros de Actividad de Edificios',
    'apartment_activity_logs': 'Registros de Actividad de Apartamentos',
    'owner_activity_logs': 'Registros de Actividad de Propietarios',
    'user_activity_logs': 'Registros de Actividad de Usuarios',
    'system_activity_logs': 'Registros de Actividad del Sistema',

    'monthly_revenue_by_user': 'Ingresos Mensuales por Usuario',
    'export_to_excel': 'Exportar a Excel',
    'exporting': 'Exportando...',
    'total_revenue': 'Ingresos Totales',
    'total_payments': 'Total de Pagos',
    'recorded_by': 'Registrado por',
    'average_payment': 'Pago Promedio',
    'per_transaction': 'Por transacción',
    'revenue_by_user': 'Ingresos por Usuario',
    'no_revenue_data': 'Sin Datos de Ingresos',
    'no_revenue_data_message': 'No se encontraron registros de pago para {{month}} {{year}}. Intenta seleccionar un mes o año diferente.',


    'loading_owner_data': 'Cargando datos del propietario...',
    'error_loading_owner': 'Error al cargar propietario',
    'back_to_owners': 'Volver a Propietarios',
    'send_reminder': 'Enviar Recordatorio',
    'edit': 'Editar',
    'overview': 'Resumen',
    'properties': 'Apartamentos',
    'payments': 'Pagos',
    'contracts': 'Contratos',
    'outstanding': 'Pendiente',
    'financial_overview': 'Resumen Financiero',
    'portfolio_summary': 'Resumen de Cartera',
    'financial_ledger': 'Libro Mayor Financiero',
    'no_installments': 'No se encontraron pagos a plazos en tu libro mayor.',
    'total_outstanding': 'Total Pendiente',
    'management_agreement': 'Acuerdo de Gestión',
    'my_agreements': 'Mis Acuerdos',
    'active_agreements': 'Acuerdos Activos',
    'no_active_agreements': 'Sin Acuerdos Activos',
    'remaining': 'Restante',
    'total_value': 'Valor Total',
    'contact_information': 'Información de Contacto',
    'property_overview': 'Resumen de Propiedad',
    'add_apartment': 'Añadir Apartamento',
    'no_properties': 'Sin Apartamentos',
    'no_properties_message': 'Este propietario no tiene apartamentos aún.',
    'add_first_property': 'Añadir el Primer Apartamento',
    'view_details': 'Ver Detalles',
    'payment_history': 'Historial de Pagos',
    'no_payments': 'Sin Pagos',
    'no_payments_message': 'No se han registrado pagos aún.',
    'outstanding_fees': 'Cuotas Pendientes',
    'no_outstanding_fees': 'Sin Cuotas Pendientes',
    'all_fees_paid': 'Todas las cuotas están al día.',
    'total_outstanding': 'Total Pendiente',
    'add_payment': 'Añadir Pago',
    'property': 'Apartamento',
    'select_property': 'Seleccionar Apartamento',
    'amount': 'Monto',
    'payment_date': 'Fecha de Pago',
    'payment_method': 'Método de Pago',
    'cash': 'Efectivo',
    'bank_transfer': 'Transferencia Bancaria',
    'check': 'Cheque',
    'credit_card': 'Tarjeta de Crédito',
    'online_payment': 'Pago en Línea',
    'reference_number': 'Número de Referencia',
    'notes': 'Notas',
    'cancel': 'Cancelar',

    'owner_information': 'Información del Propietario',
    'name': 'Nombre',
    'phone': 'Teléfono',
    'owner_lives_property': 'El propietario vive en la propiedad',
    'select_apartments': 'Seleccionar Apartamentos',
    'available_apartments': 'apartamentos disponibles',
    'no_apartments_available': 'No hay apartamentos disponibles. Todos los apartamentos ya tienen propietarios.',
    'apartment_number': 'Apartamento {{number}}',
    'floor': 'Piso',
    'size': 'Tamaño',
    'type': 'Tipo',
    'status': 'Estado',
    'cancel': 'Cancelar',
    'saving': 'Guardando...',
    'update_owner': 'Actualizar Propietario',
    'create_owner': 'Crear Propietario',
    'edit_property_owner': 'Editar Propietario de Propiedad',
    'add_property_owner': 'Añadir Propietario de Propiedad',

    'property_owners': 'Propietarios',
    'add_owner': 'Añadir Propietario',
    'search_owners': 'Buscar propietarios...',
    'filter': 'Filtrar',
    'list_view': 'Lista',
    'grid_view': 'Cuadrícula',
    'export': 'Exportar',
    'exporting': 'Exportando...',

    // Owner Contracts & Installments - NEW
    'owner_contracts': 'Contratos de Propietarios',
    'contracts': 'Contratos',
    'add_contract': 'Añadir Contrato',
    'contract_details': 'Detalles del Contrato',
    'installments': 'Plazos',
    'installment_details': 'Detalles del Plazo',
    'pay_now': 'Pagar Ahora',
    'contract_type': 'Tipo de Contrato',
    'purchase_agreement': 'Acuerdo de Compra',
    'service_agreement': 'Acuerdo de Servicio',
    'next_installment': 'Próximo Plazo',
    'outstanding_balance': 'Saldo Pendiente',
    'total_contract_value': 'Valor Total del Contrato',
    'installment_plan': 'Plan de Pagos a Plazos',
    'payment_successful': '¡Pago exitoso! Tus registros se actualizarán en breve.',
    'payment_canceled': 'El pago fue cancelado.',
    'redirecting_to_payment': 'Redirigiendo a pago seguro...',
    'no_contracts_found': 'No se encontraron contratos.',
    'no_installments_found': 'No se encontraron plazos.',

    'living_status': 'Estado de Residencia',
    'all': 'Todos',
    'living_on_property': 'Viviendo en la Propiedad',
    'not_living_on_property': 'No Viviendo en la Propiedad',
    'country': 'País',
    'all_countries': 'Todos los Países',
    'apartment_status': 'Estado del Apartamento',
    'all_statuses': 'Todos los Estados',
    'with_vacant': 'Con Apartamentos Vacantes',
    'fully_occupied': 'Totalmente Ocupado',
    'with_maintenance': 'Con Mantenimiento',
    'min_apartments': 'Mín. Apartamentos',
    'max_apartments': 'Máx. Apartamentos',
    'min_occupancy_rate': 'Tasa de Ocupación Mín. (%)',
    'clear_filters': 'Limpiar Filtros',
    'apply_filters': 'Aplicar Filtros',
    'total_owners': 'Total de Propietarios',
    'resident_owners': 'Propietarios Residentes',
    'with_apartments': 'Con Apartamentos',
    'without_apartments': 'Sin Apartamentos',
    'loading_owners': 'Cargando propietarios...',
    'error_loading_owners': 'Error al cargar propietarios',
    'try_again': 'Intentar de Nuevo',
    'no_owners_found': 'No Se Encontraron Propietarios',
    'no_owners_message': 'Aún no hay propietarios en el sistema. Haz clic en el botón \'Añadir Propietario\' para crear tu primer propietario.',
    'create_first_owner': 'Crear Primer Propietario',
    'showing_filtered_results': 'Mostrando {showing} de {total} propietarios',
    'confirm_deletion': 'Confirmar Eliminación',
    'delete_owner_confirmation': '¿Estás seguro de que deseas eliminar al propietario "{name}"? Esta acción no se puede deshacer.',
    'cancel': 'Cancelar',
    'delete': 'Eliminar',
    'deleting': 'Eliminando...',

    'resident_owner': 'Propietario Residente',
    'apartments_count': 'Cantidad de Apartamentos',
    'show_apartments': 'Mostrar Apartamentos',
    'hide_apartments': 'Ocultar Apartamentos',
    'size_unit_sqm': 'Tamaño de unidad en metros cuadrados',

    "loading": "Cargando...",
    "edit_property_owner": "Editar Propietario de Propiedad",
    "add_property_owner": "Añadir Propietario de Propiedad",
    "owner_information": "Información del Propietario",
    "name": "Nombre",
    "phone": "Teléfono",
    "owner_lives_on_property": "El propietario vive en la propiedad",
    "select_apartments": "Seleccionar Apartamentos ({{count}})",
    "available_apartments": "{{count}} apartamentos disponibles",
    "no_apartments_available": "No hay apartamentos disponibles. Todos los apartamentos ya tienen propietarios.",
    "floor": "Piso",
    "size": "Tamaño",
    "size_unit_sqm": "m²",
    "type": "Tipo",
    "status": "Estado",
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "update_owner": "Actualizar Propietario",
    "create_owner": "Crear Propietario",
    "failed_to_load_data": "Error al cargar datos",
    "failed_to_save_owner": "Error al guardar el propietario",


    "activity_logs": "Registros de Actividad",
    "tenant_activity_logs": "Registros de Actividad de Inquilinos",
    "payment_activity_logs": "Registros de Actividad de Pagos",
    "building_activity_logs": "Registros de Actividad de Edificios",
    "apartment_activity_logs": "Registros de Actividad de Apartamentos",
    "owner_activity_logs": "Registros de Actividad de Propietarios",
    "user_activity_logs": "Registros de Actividad de Usuarios",
    "system_activity_logs": "Registros de Actividad del Sistema",
    "track_all_system_activities": "Rastrea todas las actividades y cambios del sistema",
    "filter": "Filtrar",
    "export_to_excel": "Exportar a Excel",
    "exporting": "Exportando...",
    "search_logs_placeholder": "Buscar registros por nombre, usuario o detalles...",
    "showing_entries": "Mostrando {{showing}} de {{total}} entradas",
    "filter_logs": "Filtrar Registros",
    "action_type": "Tipo de Acción",
    "all_actions": "Todas las Acciones",
    "entity_type": "Tipo de Entidad",
    "all_entities": "Todas las Entidades",
    "entries_per_page": "Entradas Por Página",
    "start_date": "Fecha de Inicio",
    "end_date": "Fecha de Fin",
    "reset": "Restablecer",
    "apply_filter": "Aplicar Filtro",
    "time": "Hora",
    "user": "Usuario",
    "action": "Acción",
    "entity": "Entidad",
    "details": "Detalles",
    "view": "Ver",
    "system": "Sistema",
    "view_entity_details": "Ver detalles de {{type}}",
    "no_logs_matching_search": "No hay registros de actividad que coincidan con tu búsqueda",
    "no_logs_for_filters": "No se encontraron registros de actividad para los filtros seleccionados",
    "showing_range": "Mostrando {{start}} a {{end}} de {{total}} entradas",
    "previous": "Anterior",
    "next": "Siguiente",
    "failed_to_load_logs": "Error al cargar registros de actividad",
    "failed_to_export_logs": "Error al exportar registros a Excel",

    "tenant": "Inquilino",
    "payment": "Pago",
    "building": "Edificio",
    "apartment": "Apartamento",
    "owner": "Propietario",
    "user": "Usuario",
    "system": "Sistema",

    "created": "Creado",
    "updated": "Actualizado",
    "deleted": "Eliminado",
    "viewed": "Visto",
    "login": "Inicio de Sesión",
    "logout": "Cierre de Sesión",
    "payment_made": "Pago Realizado",
    "payment_received": "Pago Recibido",
    "status_changed": "Estado Cambiado",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "maintenance_request": "Solicitud de Mantenimiento",
    "maintenance_completed": "Mantenimiento Completado",

    "loading_payment_data": "Cargando datos de pago...",
    "error_loading_payment": "Error al Cargar Pago",
    "payment_not_found": "Pago no encontrado",
    "back_to_payments": "Volver a Pagos",
    "confirm_deletion": "Confirmar Eliminación",
    "delete_payment_confirmation": "¿Estás seguro de que deseas eliminar este pago de {{amount}}? Esta acción no se puede deshacer.",
    "cancel": "Cancelar",
    "deleting": "Eliminando...",
    "delete": "Eliminar",
    "print_receipt": "Imprimir Recibo",
    "edit": "Editar",
    "tenant": "Inquilino",
    "unknown_tenant": "Inquilino Desconocido",
    "apartment": "Apartamento",
    "apt": "Apt",
    "none": "Ninguno",
    "payment_period": "Período de Pago",
    "payment_details": "Detalles del Pago",
    "tenant_information": "Información del Inquilino",
    "payment_information": "Información del Pago",
    "amount": "Monto",
    "payment_date": "Fecha de Pago",
    "payment_type": "Tipo de Pago",
    "created": "Creado",
    "last_updated": "Última Actualización",
    "notes": "Notas",
    "view_tenant": "Ver Inquilino",
    "unknown_period": "Período desconocido",
    "to": "a",
    "invalid_period_data": "Datos de período no válidos",
    "unknown_type": "Tipo Desconocido",
    "unknown": "Desconocido",
    "failed_to_load_payment_data": "Error al cargar los datos de pago",
    "failed_to_delete_payment": "Error al eliminar el pago",

    "rent": "Alquiler",
    "service": "Cuota de Servicio",
    "deposit": "Depósito",
    "maintenance": "Mantenimiento",
    "other": "Otro",


    "generate": "Generar",
    "generated": "Generado",
    "generate_payment_for": "Generar Pago para",
    "payment_amount": "Monto del Pago",
    "enter_amount": "Ingresa el monto",
    "mark_as_paid_immediately": "Marcar como pagado de inmediato",
    "notes": "Notas",
    "payment_notes": "Notas del pago",
    "required_fields": "Campos requeridos",
    "cancel": "Cancelar",
    "generate_payment": "Generar Pago",

    "loading": "Cargando...",
    "edit_payment": "Editar Pago",
    "record_payment": "Registrar Pago",
    "payment_information": "Información de Pago",
    "tenant": "Inquilino",
    "select_tenant": "Seleccionar Inquilino",
    "apt": "Apt",
    "no_apartment": "Sin Apartamento",
    "amount": "Monto",
    "payment_date": "Fecha de Pago",
    "payment_type": "Tipo de Pago",
    "payment_period": "Período de Pago",
    "period_start": "Inicio de Período",
    "period_end": "Fin de Período",
    "additional_information": "Información Adicional",
    "notes": "Notas",
    "notes_placeholder": "Cualquier nota adicional sobre este pago...",
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "update_payment": "Actualizar Pago",
    "failed_to_load_tenants_format": "Error al cargar inquilinos: formato de datos inesperado",
    "failed_to_load_tenants": "Error al cargar inquilinos. Por favor inténtalo de nuevo.",
    "failed_to_load_payment_data": "Error al cargar datos del pago",
    "failed_to_save_payment": "Error al guardar el pago",

    "rent": "Alquiler",
    "service": "Cuota de Servicio",
    "deposit": "Depósito",
    "maintenance": "Mantenimiento",
    "other": "Otro",

    "payments": "Pagos",
    "refresh": "Actualizar",
    "refresh_payments": "Actualizar pagos",
    "stats": "Estadísticas",
    "toggle_statistics": "Alternar vista de estadísticas",
    "search_payments": "Buscar pagos...",
    "filter": "Filtrar",
    "record_payment": "Registrar Pago",
    "confirm_deletion": "Confirmar Eliminación",
    "confirm_delete_payment": "¿Estás seguro de que deseas eliminar el pago de {amount} para {tenantName}? Esta acción no se puede deshacer.",
    "cancel": "Cancelar",
    "deleting": "Eliminando...",
    "delete": "Eliminar",
    "filter_payments": "Filtrar Pagos",
    "reset_all": "Restablecer Todo",
    "payment_type": "Tipo de Pago",
    "all_types": "Todos los Tipos",
    "payment_type_rent": "Alquiler",
    "payment_type_service": "Servicio",
    "payment_type_deposit": "Depósito",
    "payment_type_other": "Otro",

    "payment_type_commission": "Comisión",
    "payment_type_security_deposit": "Depósito de seguridad",    "building": "Edificio",
    "all_buildings": "Todos los Edificios",
    "from_date": "Desde Fecha",
    "to_date": "Hasta Fecha",
    "total_payments": "Pagos Totales",
    "payment": "pago",
    "payments": "pagos",
    "recorded": "registrados",
    "rent_payments": "Pagos de Alquiler",
    "service_payments": "Pagos de Servicios",
    "payment_statistics": "Estadísticas de Pagos",
    "payments_by_month": "Pagos por Mes",
    "payment_types_distribution": "Distribución de Tipos de Pago",
    "recent_activity": "Actividad Reciente",
    "close_statistics": "Cerrar Estadísticas",
    "loading_payments": "Cargando pagos...",
    "this_may_take_moment": "Esto puede tardar un momento",
    "error_loading_payments": "Error al Cargar Pagos",
    "try_again": "Intentar de Nuevo",
    "no_payments_found": "No se encontraron pagos",
    "no_payments_match_filters": "No hay pagos que coincidan con tus filtros actuales. Intenta ajustar tus criterios de filtro para ver más resultados.",
    "no_payments_in_system": "Aún no hay pagos en el sistema. Empieza registrando tu primer pago.",
    "reset_filters": "Restablecer Filtros",
    "record_first_payment": "Registrar Primer Pago",
    "unknown_period": "Período desconocido",
    "to": "a",
    "invalid_period_data": "Datos de período no válidos",
    "unknown_type": "Tipo Desconocido",
    "apt": "Apt",
    "print_receipt": "Imprimir recibo",
    "view_details": "Ver detalles",
    "edit_payment": "Editar pago",
    "delete_payment": "Eliminar pago",
    "showing_payments": "Mostrando pagos {{start}}-{{end}} de {{total}}",
    "showing_filtered_payments": "Mostrando {{filtered}} de {{total}} pagos basados en tu búsqueda",
    "authentication_required": "Autenticación requerida",
    "failed_load_payments": "Error al cargar datos de pagos",
    "auth_failed_login_again": "Error de autenticación. Por favor inicia sesión de nuevo.",
    "access_denied_admin_required": "Acceso denegado. Se requiere el rol de Administrador.",
    "server_error_check_backend": "Error del servidor. Por favor comprueba si el backend se está ejecutando.",
    "cannot_connect_server": "No se puede conectar al servidor. Por favor comprueba si el backend se está ejecutando.",
    "error_fetching_payments": "Error al obtener pagos",
    "error_deleting_payment": "Error al eliminar pago",
    "failed_delete_payment": "Error al eliminar el pago",

    "occupancy_report": "Informe de Ocupación",
    "loading": "Cargando...",
    "refresh": "Actualizar",
    "back": "Atrás",
    "error_fetching_occupancy": "Error al obtener datos de ocupación",
    "failed_load_occupancy": "Error al cargar datos de ocupación",
    "occupied": "Ocupado",
    "vacant": "Vacante",
    "maintenance": "Mantenimiento",
    "apartments": "apartamentos",
    "occupancy_rate": "Tasa de Ocupación",
    "of": "de",
    "vacant_apartments": "Apartamentos Vacantes",
    "of_total": "del total",
    "maintenance_apartments": "En Mantenimiento",
    "potential_income": "Ingreso Mensual Potencial",
    "buildings": "edificios",
    "occupancy_distribution": "Distribución de Ocupación",
    "occupancy_by_building": "Ocupación por Edificio",
    "building": "Edificio",
    "total_apartments": "Total de Apartamentos",
    "print_report": "Imprimir Informe",
    "export_report": "Exportar Informe",

    "rent": "Alquiler",
    "service": "Servicio",
    "commission": "Comisión",
    "insurance": "Seguro",
    "total": "Total",
    "occupied": "Ocupado",
    "vacant": "Vacante",
    "maintenance": "Mantenimiento",
    "apartments": "apartamentos",
    "of": "de",
    "excellent": "Excelente",
    "good": "Bueno",
    "needs_improvement": "Necesita Mejorar",
    "error_fetching_occupancy": "Error al obtener datos de ocupación",
    "failed_load_occupancy": "Error al cargar datos de ocupación",

    "overdue": "Atrasado",
    "pending": "Pendiente",
    "paid": "Pagado",
    "no_overdue_payments": "No se encontraron pagos atrasados",
    "apt": "Apt",
    "days_overdue": "días de retraso",
    "more_overdue_tenants": "más inquilinos con retraso...",
    "error_fetching_tenant_status": "Error al obtener el estado de pago del inquilino",
    "failed_load_tenant_status": "Error al cargar el estado de pago del inquilino",

    "rent": "Alquiler",
    "service": "Servicio",
    "deposit": "Depósito",
    "no_recent_payments": "No se encontraron pagos recientes",
    "error_fetching_payments": "Error al obtener pagos recientes",
    "failed_load_payments": "Error al cargar pagos recientes",

    "payment_logs": "Registros de Pagos",
    "filter": "Filtrar",
    "back": "Atrás",
    "search_payment_logs_placeholder": "Buscar en registros de pagos...",
    "showing_entries": "Mostrando {{showing}} de {{total}} entradas",
    "filter_payments": "Filtrar Pagos",
    "time_period": "Período de Tiempo",
    "start_date": "Fecha de Inicio",
    "end_date": "Fecha de Fin",
    "payment_type": "Tipo de Pago",
    "all_types": "Todos los Tipos",
    "entries_per_page": "Entradas Por Página",
    "reset": "Restablecer",
    "apply_filter": "Aplicar Filtro",
    "payment_id": "ID de Pago",
    "date": "Fecha",
    "tenant": "Inquilino",
    "building": "Edificio",
    "type": "Tipo",
    "amount": "Monto",
    "actions": "Acciones",
    "print_receipt": "Imprimir Recibo",
    "view_details": "Ver Detalles",
    "no_logs_matching_search": "No hay registros de pago que coincidan con tus criterios de búsqueda",
    "no_logs_for_period": "No hay registros de pago disponibles para el período de tiempo seleccionado",
    "showing_range": "Mostrando {{start}} a {{end}} de {{total}} entradas",
    "previous": "Anterior",
    "next": "Siguiente",
    "print_report": "Imprimir Informe",
    "export_to_excel": "Exportar a Excel",
    "failed_to_load_payment_logs": "Error al cargar registros de pagos",

    "current_month": "Mes Actual",
    "last_month": "Mes Pasado",
    "current_quarter": "Trimestre Actual",
    "current_year": "Año Actual",
    "custom": "Rango Personalizado",

    "rent": "Alquiler",
    "service": "Servicio",
    "commission": "Comisión",
    "insurance": "Seguro",
    "other": "Otro",

    "reports_dashboard": "Panel de Informes",
    "overview_of_financial_performance": "Resumen del rendimiento financiero y estadísticas de propiedades",
    "view_all_reports": "Ver Todos los Informes",
    "failed_to_load_report_data": "Error al cargar datos del informe",
    "total_revenue": "Ingresos Totales",
    "total_payments_count": "{{count}} pagos",
    "total_tenants": "Total de Inquilinos",
    "new_tenants_this_year": "{{count}} nuevos este año",
    "total_properties": "Total de Propiedades",
    "total_buildings_count": "{{count}} edificios",
    "total_owners": "Total de Propietarios",
    "ended_contracts_count": "{{count}} contratos terminados",
    "monthly_revenue_year": "Ingresos Mensuales - {{year}}",
    "view_details": "Ver Detalles",
    "occupancy_rate": "Tasa de Ocupación",
    "recent_payments": "Pagos Recientes",
    "view_all": "Ver Todo",
    "overdue_payments": "Pagos Atrasados",
    "quick_reports": "Informes Rápidos",
    "annual_revenue": "Ingresos Anuales",
    "yearly_breakdown": "Desglose anual de todos los ingresos",
    "building_revenue": "Ingresos por Edificio",
    "revenue_by_building": "Desglose de ingresos por edificio",
    "owner_revenue": "Ingresos de Propietarios",
    "revenue_by_owner": "Desglose de ingresos por propietario",
    "payment_logs": "Registros de Pagos",
    "detailed_payment_history": "Historial detallado de pagos y registros",

    "revenue_report": "Informe de Ingresos",
    "filter": "Filtrar",
    "loading": "Cargando...",
    "refresh": "Actualizar",
    "back": "Atrás",
    "filter_report": "Filtrar Informe",
    "time_period": "Período de Tiempo",
    "start_date": "Fecha de Inicio",
    "end_date": "Fecha de Fin",
    "cancel": "Cancelar",
    "apply_filter": "Aplicar Filtro",
    "failed_to_load_revenue_data": "Error al cargar datos de ingresos",
    "total_revenue": "Ingresos Totales",
    "total_payments_count": "{{count}} pagos",
    "rent_revenue": "Ingresos por Alquiler",
    "percent_of_total": "{{percent}}% del total",
    "service_revenue": "Ingresos por Servicio",
    "unique_tenants": "Inquilinos Únicos",
    "avg_per_tenant": "Promedio de {{amount}} por inquilino",
    "revenue_by_building": "Ingresos por Edificio",
    "view_details": "Ver Detalles",
    "building": "Edificio",
    "tenants": "Inquilinos",
    "no_building_revenue_data": "No hay datos de ingresos por edificio disponibles",
    "revenue_by_owner": "Ingresos por Propietario",
    "owner": "Propietario",
    "apartments": "Apartamentos",
    "no_owner_revenue_data": "No hay datos de ingresos por propietario disponibles",
    "print_report": "Imprimir Informe",
    "export_report": "Exportar Informe",

    "current_month": "Mes Actual",
    "last_month": "Mes Pasado",
    "current_quarter": "Trimestre Actual",
    "current_year": "Año Actual",
    "custom": "Rango Personalizado",

    "service_payments_management": "Gestión de Pagos de Servicios",
    "refresh": "Actualizar",
    "back_to_dashboard": "Volver al Panel",
    "building": "Edificio",
    "select_building": "Seleccionar Edificio",
    "year": "Año",
    "search": "Buscar",
    "search_apartments_tenants": "Buscar apartamentos, inquilinos...",
    "generate_payments": "Generar Pagos",
    "view_statistics": "Ver Estadísticas",
    "filter_by_status": "Filtrar por estado",
    "all": "Todo",
    "paid": "Pagado",
    "unpaid": "No Pagado",
    "clear_filters": "Limpiar Filtros",
    "loading_service_data": "Cargando datos de pagos de servicios...",
    "no_building_selected": "No se Seleccionó Edificio",
    "please_select_building": "Por favor selecciona un edificio para ver los pagos de servicios.",
    "no_search_results": "Sin Resultados de Búsqueda",
    "no_matching_apartments": "No hay apartamentos o inquilinos que coincidan con tu búsqueda.",
    "service_payments_for_building_year": "Pagos de Servicios para {{building}} - {{year}}",
    "floor_number": "Piso {{number}}",
    "apartments": "Apartamentos",
    "rate": "Tasa",
    "tenant_owner": "Inquilino/Propietario",
    "vacant": "Vacante",
    "mark_as_paid": "Marcar como Pagado",
    "mark_as_unpaid": "Marcar como No Pagado",
    "view_details": "Ver Detalles",
    "summary": "Resumen",
    "floor_apartment_count": "{{floors}} pisos, {{apartments}} apartamentos",
    "no_floors_available": "No Hay Pisos Disponibles",
    "no_floors_message": "No hay pisos con apartamentos en este edificio, o aún no se han generado pagos de servicios.",
    "failed_to_load_buildings": "Error al cargar edificios. Por favor inténtalo de nuevo.",
    "failed_to_load_floors": "Error al cargar pisos",
    "failed_to_load_building_floors": "Error al cargar pisos del edificio",
    "failed_to_load_floor_data": "Error al cargar datos del piso",
    "data_refreshed_successfully": "Datos actualizados exitosamente.",
    "failed_to_refresh_data": "Error al actualizar los datos",
    "marked_as_paid_via_service_management": "Marcado como pagado a través de la gestión de servicios",
    "marked_as_unpaid_via_service_management": "Marcado como no pagado a través de la gestión de servicios",
    "payment_marked_as_paid": "Pago marcado como pagado exitosamente.",
    "payment_marked_as_unpaid": "Pago marcado como no pagado exitosamente.",
    "failed_to_update_payment": "Error al actualizar el pago",
    "payment_details": "Detalles del Pago",
    "payment_due": "Pago Vencido",
    "amount": "Monto",
    "status": "Estado",
    "paid_on": "Pagado el",
    "no_apartments_on_floor": "No se encontraron apartamentos en este piso.",

    "month_1": "Enero",
    "month_2": "Febrero",
    "month_3": "Marzo",
    "month_4": "Abril",
    "month_5": "Mayo",
    "month_6": "Junio",
    "month_7": "Julio",
    "month_8": "Agosto",
    "month_9": "Septiembre",
    "month_10": "Octubre",
    "month_11": "Noviembre",
    "month_12": "Diciembre",


    "service_payment_details": "Detalles del Pago de Servicio",
    "print_receipt": "Imprimir Recibo",
    "loading": "Cargando...",
    "failed_to_load_payment_details": "Error al cargar detalles del pago",
    "api_endpoint_missing_message": "Este error indica que falta un punto de conexión API en tu servidor backend. Para solucionarlo, añade una ruta para GET /api/services/:id en tu archivo serviceRoutes.js.",
    "payment_information": "Información del Pago",
    "apartment": "Apartamento",
    "period": "Período",
    "amount": "Monto",
    "status": "Estado",
    "tenant": "Inquilino",
    "owner": "Propietario",
    "payment_date": "Fecha de Pago",
    "paid_by": "Pagado Por",
    "notes": "Notas",
    "update_payment": "Actualizar Pago",
    "mark_as_paid": "Marcar como Pagado",
    "currency": "Moneda",
    "select_payer": "Seleccionar Pagador",
    "management": "Gestión",
    "other": "Otro",
    "payment_notes_placeholder": "Ingresa cualquier nota adicional sobre este pago...",
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "payment_history": "Historial de Pagos",
    "date": "Fecha",
    "action": "Acción",
    "by": "Por",
    "paid": "Pagado",
    "unpaid": "No Pagado",
    "payment_marked_as_paid": "Pago marcado exitosamente como pagado.",
    "payment_marked_as_unpaid": "Pago marcado exitosamente como no pagado.",
    "failed_to_update_payment": "Error al actualizar el pago",
    "service_payment_receipt": "Recibo de Pago de Servicio",
    "property_management": "Gestión de Propiedades",
    "receipt_generated": "Este recibo fue generado el {{date}} a las {{time}}",
    "automated_receipt_notice": "Este es un recibo generado automáticamente y no requiere firma.",
    "us_dollar": "Dólar Estadounidense",
    "iraqi_dinar": "Dinar Iraquí",
    "euro": "Euro",

    "month_1": "Enero",
    "month_2": "Febrero",
    "month_3": "Marzo",
    "month_4": "Abril",
    "month_5": "Mayo",
    "month_6": "Junio",
    "month_7": "Julio",
    "month_8": "Agosto",
    "month_9": "Septiembre",
    "month_10": "Octubre",
    "month_11": "Noviembre",
    "month_12": "Diciembre",

    "tenant": "inquilino",
    "owner": "propietario",
    "management": "gestión",
    "other": "otro",

    "generate_service_payments": "Generar Pagos de Servicios",
    "recipients": "Destinatarios",
    "entire_building": "Edificio Entero",
    "generate_for_all_apartments": "Generar para todos los apartamentos en un edificio",
    "specific_tenants": "Inquilinos Específicos",
    "generate_for_selected_tenants": "Generar solo para inquilinos seleccionados",
    "specific_owners": "Propietarios Específicos",
    "generate_for_selected_owners": "Generar solo para propietarios seleccionados",
    "select_building": "Seleccionar Edificio",
    "include_vacant_apartments": "Incluir apartamentos vacants",
    "selected_tenants": "Inquilinos Seleccionados",
    "selected_owners": "Propietarios Seleccionados",
    "select_tenants": "Seleccionar Inquilinos",
    "select_owners": "Seleccionar Propietarios",
    "no_tenants_selected": "No se seleccionaron inquilinos",
    "no_owners_selected": "No se seleccionaron propietarios",
    "payment_details": "Detalles del Pago",
    "amount": "Monto",
    "currency": "Moneda",
    "us_dollar": "Dólar Estadounidense",
    "iraqi_dinar": "Dinar Iraquí",
    "euro": "Euro",
    "initial_status": "Estado Inicial",
    "unpaid": "No Pagado",
    "paid": "Pagado",
    "notes": "Notas",
    "payment_notes_placeholder": "Ingresa cualquier nota adicional sobre estos pagos...",
    "time_period": "Período de Tiempo",
    "generation_type": "Tipo de Generación",
    "single_month": "Mes Único",
    "multiple_months": "Múltiples Meses",
    "month_range": "Rango de Meses",
    "year": "Año",
    "month": "Mes",
    "select_months": "Seleccionar Meses",
    "from": "De",
    "to": "A",
    "selected_months": "Meses Seleccionados",
    "payment_generation_summary": "Resumen de Generación de Pagos",
    "all_apartments_in": "Todos los apartamentos en",
    "selected_building": "edificio seleccionado",
    "tenants": "inquilinos",
    "owners": "propietarios",
    "cancel": "Cancelar",
    "generating": "Generando...",
    "generate_payments": "Generar Pagos",
    "search": "Buscar",
    "search_by_tenant_name_or_phone": "Buscar por nombre del inquilino, teléfono o número de apto...",
    "search_by_owner_name_or_phone": "Buscar por nombre de propietario o teléfono...",
    "no_results_found": "No se encontraron resultados",
    "selected": "seleccionado/s",
    "done": "Hecho",
    "no_tenants_available": "No hay inquilinos disponibles. Por favor añade inquilinos primero.",
    "no_owners_available": "No hay propietarios disponibles. Por favor añade propietarios primero.",
    "apt": "Apt",
    "january": "Enero",
    "february": "Febrero",
    "march": "Marzo",
    "april": "Abril",
    "may": "Mayo",
    "june": "Junio",
    "july": "Julio",
    "august": "Agosto",
    "september": "Septiembre",
    "october": "Octubre",
    "november": "Noviembre",
    "december": "Diciembre",
    "failed_to_load_buildings": "Error al cargar edificios. Por favor inténtalo de nuevo.",
    "failed_to_load_tenants": "Error al cargar inquilinos. Por favor inténtalo de nuevo.",
    "failed_to_load_owners": "Error al cargar propietarios. Por favor inténtalo de nuevo.",
    "please_select_building": "Por favor selecciona un edificio",
    "please_select_at_least_one_recipient": "Por favor selecciona al menos un {{recipient}}",
    "please_enter_valid_amount": "Por favor ingresa un monto válido",
    "please_select_month": "Por favor selecciona un mes",
    "please_select_at_least_one_month": "Por favor selecciona al menos un mes",
    "end_month_must_be_after_start_month": "El mes de fin debe ser posterior al mes de inicio",
    "successfully_generated_payments": "Se generaron con éxito {{count}} pagos de servicios durante {{months}} mes(es). {{skipped}} pagos ya estaban generados.",
    "failed_to_generate_service_payments": "Error al generar pagos de servicios",
    "tenant": "inquilino",
    "owner": "propietario",

    "service_payment_statistics": "Estadísticas de Pagos de Servicios",
    "back_to_services": "Volver a Servicios",
    "building": "Edificio",
    "year": "Año",
    "loading_statistics": "Cargando estadísticas...",
    "no_building_selected": "No se Seleccionó Edificio",
    "please_select_building_statistics": "Por favor selecciona un edificio para ver las estadísticas de pagos de servicios.",
    "overall_statistics": "Estadísticas Generales",
    "total_collection": "Recaudación Total",
    "of": "de",
    "payment_rate": "Tasa de Pago",
    "payments": "pagos",
    "outstanding_amount": "Monto Pendiente",
    "unpaid_payments": "pagos no pagados",
    "monthly_statistics": "Estadísticas Mensuales",
    "no_monthly_data": "No hay datos mensuales disponibles para el año seleccionado.",
    "month": "Mes",
    "total_amount": "Monto Total",
    "collected": "Recaudado",
    "outstanding": "Pendiente",
    "progress": "Progreso",
    "failed_to_load_service_statistics": "Error al cargar las estadísticas de servicios",

    "loading_tenant_data": "Cargando datos del inquilino...",
    "error_loading_tenant": "Error al Cargar Inquilino",
    "tenant_not_found": "Inquilino no encontrado",
    "back_to_tenants": "Volver a Inquilinos",
    "record_payment": "Registrar Pago",
    "edit": "Editar",
    "status_unknown": "Estado Desconocido",
    "apartment": "Apartamento",
    "apt": "Apt",
    "none": "Ninguno",
    "monthly_rent": "Alquiler Mensual",
    "payment_date": "Fecha de Pago",
    "overview": "Resumen",
    "leases": "Contratos",
    "payments": "Pagos",
    "contact_information": "Información de Contacto",
    "lease_information": "Información del Contrato",
    "contract_period": "Período del Contrato",
    "rent": "Alquiler",
    "discount": "Descuento",
    "rent_after_discount": "Alquiler Después de Descuento",
    "additional_fees": "Cuotas Adicionales",
    "service_fee": "Cuota de Servicio",
    "office_commission": "Comisión de Oficina",
    "insurance": "Seguro",
    "notes": "Notas",
    "no_leases": "Sin Contratos",
    "no_leases_message": "Este inquilino aún no tiene asignado un apartamento.",
    "active_leases": "Contratos Activos",
    "inactive_leases": "Contratos Inactivos",
    "active": "Activo",
    "ended": "Finalizado",
    "expiring_soon": "Vence pronto",
    "end_lease": "Finalizar contrato",
    "start_date": "Fecha de Inicio",
    "end_date": "Fecha de Fin",
    "duration": "Duración",
    "remaining": "Restante",
    "months": "meses",
    "security_deposit": "Depósito de Seguridad",
    "total_value": "Valor Total",
    "no_payments": "Sin Pagos",
    "no_payments_message": "Este inquilino aún no tiene pagos registrados.",
    "record_first_payment": "Registrar Primer Pago",
    "payment_period": "Período de Pago",
    "reference": "Referencia",
    "payment_type": "Tipo de Pago",
    "rent_payment": "Pago de Alquiler",
    "additional_fee": "Cuota Adicional",
    "utility_payment": "Pago de Servicios Públicos",
    "other_payment": "Otro Pago",
    "start": "Inicio",
    "end": "Fin",
    "reference_number": "Número de Referencia",
    "cancel": "Cancelar",
    "unknown_period": "Período desconocido",
    "invalid_period_format": "Formato de período no válido",
    "to": "a",
    "invalid_period_data": "Datos de período no válidos",
    "please_enter_valid_payment_amount": "Por favor ingresa un monto de pago válido",
    "end_date_must_be_after_start_date": "La fecha de fin debe ser posterior a la fecha de inicio",
    "failed_to_add_payment": "Error al añadir el pago",
    "maintenance_requests_not_supported": "Las solicitudes de mantenimiento no son compatibles en la estructura de base de datos actual",
    "failed_to_create_maintenance_request": "Error al crear la solicitud de mantenimiento",
    "confirm_end_lease": "¿Estás seguro de que deseas finalizar este contrato? Esta acción no se puede deshacer.",
    "lease_ended_by_administrator": "Contrato finalizado por el administrador",
    "failed_to_end_lease": "Error al finalizar el contrato",
    "failed_to_load_tenant_data": "Error al cargar los datos del inquilino",
    "actual_end_date": "Fecha de Fin Real",

    "edit_tenant": "Editar Inquilino",
    "add_tenant": "Añadir Inquilino",
    "basic_information": "Información Básica",
    "first_name": "Nombre",
    "last_name": "Apellido",
    "email": "Correo Electrónico",
    "phone": "Teléfono",
    "apartment": "Apartamento",
    "select_apartment": "Seleccionar Apartamento",
    "floor": "Piso",
    "rent_amount": "Monto de Alquiler",
    "discount": "Descuento",
    "service_fee": "Cuota de Servicio",
    "office_commission": "Comisión de Oficina",
    "insurance": "Seguro",
    "contract_start_date": "Fecha de Inicio del Contrato",
    "contract_end_date": "Fecha de Fin del Contrato",
    "payment_date": "Fecha de Pago",
    "payment_end_date": "Fecha de Fin de Pago",
    "rent_status": "Estado de Alquiler",
    "additional_information": "Información Adicional",
    "notes": "Notas",
    "tenant_notes_placeholder": "Cualquier nota adicional sobre este inquilino...",
    "cancel": "Cancelar",
    "saving": "Guardando...",
    "update_tenant": "Actualizar Inquilino",
    "create_tenant": "Crear Inquilino",
    "loading": "Cargando...",
    "failed_to_load_tenant_data": "Error al cargar los datos del inquilino",
    "failed_to_save_tenant": "Error al guardar el inquilino",
    "pending": "Pendiente",
    "paid": "Pagado",
    "late": "Tarde",
    "overdue": "Atrasado",
    "unpaid": "No Pagado",

    "tenants": "Inquilinos",
    "refresh_tenants": "Actualizar inquilinos",
    "selected": "seleccionado",
    "delete_selected_tenants": "Eliminar inquilinos seleccionados",
    "search_tenants": "Buscar inquilinos...",
    "filter": "Filtrar",
    "switch_to_list_view": "Cambiar a Vista de Lista",
    "switch_to_grid_view": "Cambiar a Vista de Cuadrícula",
    "list_view": "Lista",
    "grid_view": "Cuadrícula",
    "hide_inactive_tenants": "Ocultar inquilinos inactivos",
    "show_inactive_tenants": "Mostrar inquilinos inactivos",
    "hide_inactive": "Ocultar Inactivos",
    "show_inactive": "Mostrar Inactivos",
    "add_tenant": "Añadir Inquilino",
    "rent_status": "Estado del Alquiler",
    "all_statuses": "Todos los Estados",
    "all_buildings": "Todos los Edificios",
    "all_apartments": "Todos los Apartamentos",
    "min_rent": "Alquiler Mín.",
    "max_rent": "Alquiler Máx.",
    "unlimited": "Ilimitado",
    "contracts_ending_before": "Contratos Terminando Antes",
    "clear_filters": "Limpiar Filtros",
    "apply_filters": "Aplicar Filtros",
    "active_tenants": "Inquilinos Activos",
    "inactive_tenants": "Inquilinos Inactivos",
    "with_apartments": "Con Apartamentos",
    "without_apartments": "Sin Apartamentos",
    "loading_tenants": "Cargando inquilinos...",
    "error_loading_tenants": "Error al Cargar Inquilinos",
    "try_again": "Intentar de Nuevo",
    "no_tenants_found": "No Se Encontraron Inquilinos",
    "no_tenants_message": "Aún no hay inquilinos en el sistema. Haz clic en el botón 'Añadir Inquilino' para crear tu primer inquilino.",
    "create_first_tenant": "Crear Primer Inquilino",
    "page": "página",
    "showing_items": "Mostrando {start}-{end} de {total}",
    "first_page": "Primera Página",
    "previous_page": "Página Anterior",
    "next_page": "Página Siguiente",
    "last_page": "Última Página",
    "showing_filtered_results": "Mostrando {showing} de {total} inquilinos",
    "confirm_deletion": "Confirmar Eliminación",
    "delete_tenant_confirmation": "¿Estás seguro de que deseas eliminar al inquilino \"{name}\"? Esta acción no se puede deshacer.",
    "cancel": "Cancelar",
    "deleting": "Eliminando...",
    "delete": "Eliminar",
    "tenant": "Inquilino",
    "apartment": "Apartamento",
    "rent": "Alquiler",
    "contract": "Contrato",
    "status": "Estado",
    "actions": "Acciones",
    "apt": "Apt",
    "unknown_building": "Edificio Desconocido",
    "no_apartment_assigned": "No hay apartamento asignado",
    "status_unknown": "Estado Desconocido",
    "monthly_rent": "Alquiler Mensual",
    "after_discount": "Después del Descuento",
    "payment_date": "Fecha de Pago",
    "not_set": "No establecido",
    "contract_start": "Inicio de Contrato",
    "contract_end": "Fin de Contrato",
    "service": "Servicio",
    "commission": "Comisión",
    "insurance": "Seguro",
    "hide_owner_details": "Ocultar Detalles del Propietario",
    "show_owner_details": "Mostrar Detalles del Propietario",
    "apartment_owner": "Propietario del Apartamento",
    "loading_owner_details": "Cargando detalles del propietario...",
    "no_owner_information": "No hay información del propietario disponible",
    "lives_on_property": "Vive en la Propiedad",
    "yes": "Sí",
    "no": "No",
    "total_apartments": "Total de Apartamentos",
    "apartment_details": "Detalles del Apartamento",
    "apartment_number": "Apt #",
    "unknown": "Desconocido",
    "floor": "Piso",
    "apartment_type": "Tipo de Apartamento",
    "standard": "Estándar",
    "furnished": "Amueblado",
    "view_owner_profile": "Ver Perfil del Propietario",
    "mark_as_inactive": "Marcar como inactivo",
    "mark_as_active": "Marcar como activo",
    "record_payment": "Registrar pago",
    "view_details": "Ver detalles",
    "edit_tenant": "Editar inquilino",
    "delete_tenant": "Eliminar inquilino",
    "to": "A",
    "payment": "Pago",
    "apartment_financial_details": "Detalles del Apartamento y Financieros",
    "not_authenticated": "No autenticado. Por favor inicia sesión.",
    "authentication_required": "Autenticación requerida",
    "authentication_failed": "Fallo de autenticación. Por favor inicia sesión de nuevo.",
    "access_denied": "Acceso denegado. Se requiere el rol de Administrador.",
    "server_error": "Error del servidor. Por favor verifica si el backend se está ejecutando.",
    "cannot_connect_to_server": "No se puede conectar al servidor. Verifica si el backend se está ejecutando en el puerto 3000.",
    "failed_to_load_tenants_data": "Error al cargar los datos de los inquilinos",
    "unknown_error": "Error desconocido",
    "failed_to_delete_tenant": "Error al eliminar el inquilino",
    "confirm_bulk_delete": "¿Estás seguro de que deseas eliminar {count} inquilinos? Esta acción no se puede deshacer.",
    "failed_to_delete_tenants": "Error al eliminar los inquilinos",
    "failed_to_update_tenant_status": "Error al actualizar el estado del inquilino",
    "pending": "Pendiente",
    "paid": "Pagado",
    "late": "Tarde",
    "overdue": "Atrasado",

    'add_new_user': 'Añadir Nuevo Usuario',
    'search_users': 'Buscar Usuarios',
    'total_users': 'Total de Usuarios',
    'active_users': 'Usuarios Activos',
    'inactive_users': 'Usuarios Inactivos',
    'financial_summary': 'Resumen Financiero',
    'filters': 'Filtros',
    'search_tenants_by_name_phone_or_apartment': 'Buscar Inquilino por Nombre, Teléfono o Apartamento',
    'view_profile': 'Ver Perfil',

    // WhatsApp Settings
    'whatsapp_settings': 'Configuración de WhatsApp',
    'whatsapp_settings_description': 'Notificaciones automatizadas de WhatsApp para inquilinos y propietarios',
    'whatsapp_enable': 'Habilitar Notificaciones de WhatsApp',
    'whatsapp_enable_sub': 'Activa o desactiva todos los mensajes automatizados de WhatsApp',
    'general_settings': 'Configuración General',
    'default_country_code': 'Código de País por Defecto',
    'tenant_rent_reminder': 'Recordatorio de Alquiler del Inquilino',
    'tenant_rent_reminder_sub': 'Enviar recordatorio a los inquilinos antes o después de la fecha de vencimiento del pago',
    'days_before_due': 'Días Antes del Vencimiento',
    'reminder_message_template': 'Plantilla de Mensaje',
    'service_fee_reminder': 'Recordatorio de Cuota de Servicio',
    'enable_service_fee_reminder': 'Habilitar Recordatorio de Cuota de Servicio',
    'service_fee_reminder_sub': 'Notificar a los inquilinos sobre próximos pagos de cuotas de servicio',
    'owner_reminder': 'Recordatorio para Propietarios',
    'enable_owner_reminders': 'Habilitar Recordatorios para Propietarios',
    'owner_reminder_sub': 'Notificar a los propietarios cuando sus inquilinos tengan pagos atrasados',
    'owner_message_template': 'Plantilla de Mensaje para Propietario',
    'payment_confirmation': 'Confirmación de Pago',
    'send_on_payment': 'Enviar confirmación cuando se registre el pago',
    'payment_confirmation_sub': 'Se envía automáticamente al inquilino cuando se registra un pago',
    'payment_confirmation_template': 'Plantilla de Mensaje de Confirmación',
    'whatsapp_test_send': 'Enviar Mensaje de Prueba',
    'test_message': 'Mensaje',
    'send_test_message': 'Enviar Mensaje de Prueba',
    'whatsapp_test_sent': '¡Mensaje de prueba enviado!',
    'whatsapp_test_default_message': 'Mensaje de prueba del sistema de gestión de propiedades',
    'send_reminders_now': 'Enviar Recordatorios Ahora',
    'send_reminders_now_description': 'Envía recordatorios de inmediato a todos los inquilinos y propietarios que necesiten uno ahora mismo.',
    'whatsapp_must_be_enabled': 'WhatsApp debe estar habilitado primero',
    'failed_to_load_settings': 'Error al cargar la configuración',
    'settings_saved': 'Configuración guardada exitosamente',
    'failed_to_save': 'Error al guardar',
    'failed_to_send': 'Error al enviar',
    'server_error': 'Error de conexión al servidor',
    'sent': 'Enviado',
    'errors': 'Errores',
    'skipped': 'Omitido',

    // Bookings
    'bookings': 'Reservas',
    'booking_management': 'Gestión de Reservas',
    'new_booking': 'Nueva Reserva',
    'create_booking': 'Crear Reserva',
    'edit_booking': 'Editar Reserva',
    'booking_details': 'Detalles de la Reserva',
    'prospect': 'Prospecto',
    'prospect_name': 'Nombre del Prospecto',
    'prospect_phone': 'Número de Teléfono',
    'prospect_email': 'Dirección de Correo',
    'move_in_date': 'Fecha de Mudanza',
    'move_out_date': 'Fecha de Salida',
    'hold_duration': 'Duración de Reserva (Retención)',
    'hold_hours': 'Horas de Retención',
    'hold_expiration': 'Vencimiento de Retención',
    'internal_notes': 'Notas Internas',
    'check_availability': 'Comprobar Disponibilidad',
    'checking_availability': 'Comprobando disponibilidad...',
    'no_bookings_found': 'No se encontraron reservas',
    'calendar_view': 'Vista de Calendario',
    'waitlist': 'Lista de Espera',
    'new_booking_hold': 'Nueva Retención de Reserva',
    'property_information': 'Información de la Propiedad',
    'prospect_details': 'Detalles del Prospecto',
    'requested_dates': 'Fechas Solicitadas',
    'conflict_detected': 'Conflicto Detectado',
    'booking_timeline': 'Cronología de la Reserva',
    'monthly_view_holds': 'Vista mensual de reservas de apartamentos activas',
    'confirmed_hold': 'Retención Confirmada',
    'pending_payment': 'Pago Pendiente',
    'move_in': 'Mudanza',
    'move_out': 'Salida',
    'convert_to_tenant': 'Convertir en Inquilino',
    'confirm_booking': 'Confirmar Reserva',
    'cancel_booking': 'Cancelar Reserva',
    'booking_confirmed': 'Reserva confirmada',
    'booking_cancelled': 'Reserva cancelada',
    'booking_converted': '¡Reserva convertida en inquilino con éxito!',
    'process_to_booking': 'Procesar a Reserva',
    'waitlist_management': 'Gestión de Lista de Espera',
    'waitlist_empty': 'La lista de espera está vacía',
    'search_waitlist': 'Buscar en lista de espera...',
    'priority': 'Prioridad',
    'desired_unit': 'Unidad Deseada',
    'move_in_preference': 'Preferencia de Mudanza',
    'added': 'Añadido',
    'rank': 'Rango',
    'process_waitlist_success': '¡Convertido a reserva pendiente con éxito!',
    'remove_from_waitlist': '¿Estás seguro de que deseas eliminar esta entrada de la lista de espera?',
    'entry_removed': 'Entrada eliminada',
    'hold_expires': 'La Retención Vence',
    'hours': 'Horas',
    'optional': 'Opcional',
    'apartment_element': 'Elemento Apartamento',
    'select_unit': 'Seleccionar Unidad',
    'error_loading_data': 'Error al cargar los datos',
    'error_saving_booking': 'Error al guardar la reserva',
    'save_changes': 'Guardar Cambios',
    'select_apartment_move_in_date_error': 'Por favor selecciona un apartamento y la fecha de mudanza para comprobar la disponibilidad',
    'apartment_available': '¡El apartamento está disponible para estas fechas!',
    'error_checking_availability': 'Error al comprobar disponibilidad',
    'confirm_conflict_booking': 'Hay conflictos de fechas. ¿Estás seguro de que deseas continuar?',
    'booking_updated': 'Reserva actualizada con éxito',
    'booking_number': 'Reserva #{{id}}',
    'created_at': 'Creado el {{date}}',
    'created_by': 'por {{name}}',
    'system': 'Sistema',
    'confirm': 'Confirmar',
    'target_property': 'Propiedad de Destino',
    'furnished': 'Amueblado',
    'unfurnished': 'Sin amueblar',
    'booking_window': 'Ventana de Reserva',
    'indefinite': 'Indefinido',
    'created_source': 'Creado ({{source}})',
    'view_tenant_profile': 'Ver Perfil del Inquilino',
    'convert_to_active_tenant': 'Convertir a Inquilino Activo',
    'lease_details_move_in_instruction': 'Completa los siguientes detalles del contrato para mudar a {{name}} a la Unidad {{unit}}.',
    'monthly_rent': 'Alquiler Mensual',
    'first_payment_date': 'Fecha del Primer Pago',
    'contract_start': 'Inicio del Contrato',
    'contract_end': 'Fin del Contrato',
    'confirm_convert': 'Confirmar y Convertir',
    'confirm_booking_question': 'Finalizar Reserva: ¿Estás seguro de que deseas confirmar esta reserva y bloquear la unidad para este prospecto?',
    'confirm_booking_question_ar': 'تأكيد الحجز: هل أنت متأكد من رغبتك في تثبيت هذا الحجز وحجز الوحدة لهذا العميل؟',
    'confirm_booking_question_ku': 'پشتڕاستکردنەوەی حجز: ئایا دڵنیایت کە دەتەوێت ئەم حجزە پشتڕاست بکەیتەوە و یەکەکە بۆ ئەم کڕیارە دابنێیت؟',
    'reason_optional': 'Por favor proporciona una razón (opcional):',
    'amount': 'Monto',
    'today': 'Hoy',
    'sun': 'Dom',
    'mon': 'Lun',
    'tue': 'Mar',
    'wed': 'Mié',
    'thu': 'Jue',
    'fri': 'Vie',
    'sat': 'Sáb',
    'more': 'Más',
    'close': 'Cerrar',
    'hold_expiration': 'Vencimiento de Retención',
    'view_details': 'Ver Detalles',
    'waitlist_management': 'Gestión de Lista de Espera',
    'search_waitlist': 'Buscar en lista de espera...',
    'waitlist_empty': 'La lista de espera está vacía',
    'no_prospective_tenants_waiting': 'Ningún posible inquilino está esperando por disponibilidad de apartamentos en este momento.',
    'priority': 'Prioridad',
    'rank': 'Rango: {{priority}}',
    'desired_unit': 'Unidad Deseada',
    'move_in_preference': 'Preferencia de Mudanza',
    'process_to_booking': 'Procesar a Reserva',
    'remove': 'Eliminar',
    'remove_waitlist_confirm': '¿Estás seguro de que deseas eliminar esta entrada de la lista de espera?',
    'waitlist_processed': '¡Convertido a reserva pendiente con éxito!',
    'entry_removed': 'Entrada eliminada',
    'failed_process_waitlist': 'Error al procesar la entrada de la lista de espera',
    'failed_remove_entry': 'Error al eliminar entrada',
    'booking_analytics': 'Análisis de Reservas',
    'track_conversion_and_holds': 'Rastrea las tasas de conversión y las duraciones de las retenciones',
    'last_7_days': 'Últimos 7 Días',
    'last_30_days': 'Últimos 30 Días',
    'last_90_days': 'Últimos 90 Días',
    'last_year': 'Último Año',
    'total_bookings': 'Total de Reservas',
    'in_selected_period': 'En el período seleccionado',
    'conversion_rate': 'Tasa de Conversión',
    'converted_to_tenants': '{{count}} convertidos en inquilinos',
    'cancellation_rate': 'Tasa de Cancelación',
    'cancelled_holds': '{{count}} retenciones canceladas',
    'avg_hold_time': 'Tiempo de Retención Prom.',
    'before_conversion_cancel': 'Antes de la conversión/cancelación',
    'volume_trends': 'Tendencias de Volumen',
    'no_trend_data': 'No hay datos de tendencias disponibles',
    'total_holds': 'Total de Retenciones',
    'status_breakdown': 'Desglose por Estado',
    'no_status_data': 'No hay datos de estado disponibles',
    'active_holds': 'Retenciones Activas',
    'overdue_rent': 'Alquiler Atrasado',
    'subscription': 'Suscripción',
    'whatsapp': 'WhatsApp',
    'apartment_unit_display': 'Apartamento {{number}} - Piso {{floor}}',
    'building_view': 'Vista del Edificio',
    'showing_all_apartments': 'Mostrando todos los apartamentos',
    'expand_all_floors': 'Desplegar todos los pisos',
    'collapse_all_floors': 'Contraer todos los pisos',
    'pending_move_in': 'Mudanza Pendiente',
    'tenant_name': 'Nombre',
    'tenant_phone': 'Teléfono',
    'tenant_email': 'Correo Electrónico',
    'lease_details': 'Detalles del Contrato',
    'start_date': 'Fecha de Inicio',
    'end_date': 'Fecha de Fin',
    'monthly_pay_date': 'Día de Pago Mensual',
    'day_number': 'Día {{number}}',
    'duration': 'Duración',
    'months': 'Meses',
    'remaining_time': 'Tiempo Restante',
    'financial_summary': 'Resumen Financiero',
    'monthly_rent': 'Alquiler Mensual',
    'effective_rent': 'Alquiler Efectivo',
    'rent_status': 'Estado de Alquiler',
    'future_tenant_upcoming_move_in': 'Futuro Inquilino (Próxima Mudanza)',
    'move_in_date': 'Fecha de Mudanza',
    'contract_end': 'Fin del Contrato',
    'recent_bookings': 'Reservas y Retenciones Recientes',
    'new_hold': 'Nueva Retención',
    'available_now': 'Disponible Ahora',
    'lease_ending_soon': 'El contrato termina pronto',
    'no_apartments_found': 'No se encontraron apartamentos adecuados',
    'ready': 'Listo',
    'ends_in_days': 'Termina en {{count}}d',
    'search_unit': 'Buscar apartamento...',
    'currently_occupied': 'Actualmente Ocupado',
    'occupied': 'Ocupado',
    'all_service_payments': 'Todos los Pagos de Servicios',
    'manage_all_service_payments_across_buildings': 'Gestiona todos los pagos de servicios en todos los edificios',
    'tenants_management': 'Gestión de Inquilinos',
    'manage_tenants_and_leases': 'Gestiona inquilinos y contratos',
    'past_tenants': 'Inquilinos Anteriores',
    'lease_ended': 'Contrato Terminado',
    'end_lease_confirm_title': 'Confirmar Fin de Contrato',
    'end_lease_confirm_body': '¿Estás seguro de que deseas finalizar este contrato?',
    'no_past_tenants': 'No hay inquilinos anteriores',
    'sign_up_to_get_started': 'Regístrate para empezar',
    'company_name': 'Nombre de la Empresa',
    'already_have_account': '¿Ya tienes una cuenta?',
    'status_expired_description': 'Este contrato ha caducado. No se pueden aplicar más pagos.',
    'lease_expired_warning': 'Este contrato ha caducado.',
    'tenant_lease_expired_message': 'No se pueden aplicar más pagos.',
    'expired_on': 'Caducó el',
    'manage_tenant': 'Gestionar Inquilino',
    'move_in_pending': 'Mudanza Pendiente',
    'lease_expired': 'Contrato Caducado',
    'create_hold': 'Crear Retención',
    'billing_subscription': 'Facturación y Suscripción',
    'current_plan': 'Plan Actual',
    'subscribe_now': 'Suscribirse Ahora',
    'manage_your_subscription_and_billing': 'Gestiona tu suscripción y facturación',
    'view_payment_logs': 'Ver Registros de Pagos',
    'view_activity_logs': 'Ver Registros de Actividad',
    'view_revenue_report': 'Ver Informe de Ingresos',
    'view_occupancy_report': 'Ver Informe de Ocupación',
    'view_tenant_logs': 'Ver Registros de Inquilinos',
    'login_success': 'Inicio de Sesión Exitoso',
    'logout_success': 'Cierre de Sesión Exitoso',
    'record_payment': 'Registrar Pago',
    'occupied_status': 'Ocupado',
    'financial_status': 'Estado Financiero',
    'occupancy_physical': 'Ocupación Física',
    'unit_indicators': 'Indicadores de Unidad',
    'furnished_unit': 'Unidad Amueblada',
    'lease_expired_short': 'Contrato Caducado',
    'lease_ended_short': 'Contrato Terminado',
    'expired_label': 'Caducado',
    'scheduled_tenants': 'Inquilinos Programados',
    'multiple_leases': 'Múltiples Contratos',

    // Portal Common
    'owner_portal': 'Portal del Propietario',
    'tenant_portal': 'Portal del Inquilino',
    'sign_out': 'Cerrar Sesión',
    'indefinite': 'Indefinido',
    'total_value': 'Valor Total',
    'remaining_balance': 'Saldo Restante',

    // Portal Navigation
    'lease_details': 'Detalles del Contrato',
    'installments': 'Plazos',
    'documents': 'Documentos',
    'announcements': 'Anuncios',

    // Owner Portal / Admin
    'management_fees': 'Comisiones de Gestión',
    'management_fees_subtitle': 'Resumen de todos los ingresos de gestión del arrendador y calendarios.',
    'ledger_subtitle': 'Desglose detallado de tus cuotas de gestión y saldos pendientes.',
    'agreements_subtitle': 'Mira todos tus contratos de gestión y registros de propiedad.',

    // Tenant Portal
    'welcome_back_user': '¡Bienvenido/a de nuevo, {{name}}!',
    'tenancy_overview': "Esto es lo que está pasando hoy con tu arrendamiento.",
    'current_balance': 'Saldo Actual',
    'action_required': 'Acción requerida',
    'account_good_standing': 'Cuenta al día',
    'view_lease_short': 'Ver detalles del contrato',
    'need_repairs': '¿Necesitas Reparaciones?',
    'repairs_subtitle': 'Envía un ticket de mantenimiento en línea rápidamente.',
    'create_request': 'Crear Solicitud',
    'building_news': 'Noticias y Avisos del Edificio',
    'payments_billing': 'Pagos y Facturación',
    'payments_subtitle': 'Gestiona los pagos de tu alquiler y mira tu historial de transacciones.',
    'download_statement': 'Descargar Estado de Cuenta PDF',
    'amount_due': 'Monto Actual a Pagar',
    'due_on': 'Vence el {{date}}',
    'pay_now': 'Pagar Ahora',
    'transaction_history': 'Historial de Transacciones',
    'no_transactions': 'Aún no hay transacciones',
    'first_payment_message': 'Tu historial de pagos aparecerá aquí cuando realices tu primer pago.',
    'unit_display': 'Unidad {{number}}',

    // Tenant Lease
    'lease_details_subtitle': 'Revisa tu contrato de alquiler activo y la información de la propiedad.',
    'lease_signed': 'Contrato Firmado',
    'sign_lease_now': 'Firmar Contrato Ahora',
    'contract_term': 'Duración del Contrato',
    'property_info': 'Información de la Propiedad',
    'landlord_owner': 'Propietario / Arrendador',
    'electronic_signature_recorded': 'Firma Electrónica Registrada',
    'signed_on': 'Firmado el: {{date}}',
    'digital_trace': 'Rastro Digital',
    'legal_disclosure': 'Divulgación Legal',
    'legal_disclosure_text': 'Al firmar este documento de manera electrónica, aceptas que tu firma electrónica tiene la misma validez legal que tu firma manual en este Acuerdo.',
    'electronic_lease_signing': 'Firma Electrónica de Contrato',
    'confirmation_statement': '"Yo, {{name}}, confirmo por la presente que he leído y acepto todos los términos del contrato de alquiler para {{building}}, Unidad {{unit}}."',
    'type_full_name': 'Escribe el Nombre Completo para Firmar',
    'digital_verification_required': 'Se Requiere Verificación de Firma Digital',
    'complete_signing': 'Completar Firma',
    'lease_not_found': 'Contrato No Encontrado',
    'lease_not_found_subtitle': 'Contacta con la administración si crees que esto es un error.',

    // Lease Management
    'renew_lease': 'Renovar Contrato',
    'extend_lease': 'Extender Contrato',
    'current_end_date': 'Fecha de Fin Actual',
    'new_end_date': 'Nueva Fecha de Fin',
    'extend': 'Extender',
    'transfer': 'Transferir',
    'transfer_apartment': 'Transferir Apartamento',
    'current_apartment': 'Apartamento Actual',
    'select_new_apartment': 'Seleccionar Nuevo Apartamento',
    'new_monthly_rent': 'Nuevo Alquiler Mensual',
    'transferring': 'Transfiriendo...',
    'failed_to_transfer_tenant': 'Error al transferir al inquilino',
    'tenant_transferred_success': 'Inquilino transferido con éxito',
    'expired': 'Caducado',
    'select_option': 'Seleccionar Opción',
    'invite_portal': 'Invitar al Portal',
    'tenant_documents': 'Documentos del Inquilino',
    'maintenance_requests': 'Solicitudes de Mantenimiento',
    'add_request': 'Añadir Solicitud',
    'reported_on': 'Reportado el',
    'send_portal_invitation': 'Enviar Invitación al Portal',
    'fully_signed': 'Totalmente Firmado',
    'voided': 'Anulado',
    'upgrade_for_analytics': 'Actualizar para Análisis',
    'upgrade_analytics_message': 'Actualiza para desbloquear funciones de análisis avanzadas.',
    'view_plans': 'Ver Planes',
    'choose_a_plan': 'Elige un Plan',
    'subscribe_with_stripe': 'Suscribirse con Stripe',
    'manage_subscription': 'Gestionar Suscripción',
    'upgrade': 'Actualizar',
    'contact_sales': 'Contactar Ventas',
    'no_payment_history': 'No hay Historial de Pagos',
    'no_subscription_history': 'No hay Historial de Suscripción',

    // ID Documents (Tenant & Owner)
    'id_documents': 'Documentos de Identidad',
    'id_document_front': 'Frente',
    'id_document_back': 'Reverso',
    'id_document_type': 'Tipo de Documento',
    'id_document_number': 'Número de Documento',
    'id_document_uploaded_at': 'Subido El',
    'select_document_type': 'Seleccionar tipo de documento',
    'national_id': 'DNI',
    'passport': 'Pasaporte',
    'driving_license': 'Licencia de Conducir',
    'residence_permit': 'Permiso de Residencia',
    'other_document': 'Otro',
    'document_number_placeholder': 'Ingresa número de documento (opcional)',
    'front_side': 'Lado Frontal',
    'back_side': 'Lado Posterior',
    'drag_drop_or_click': 'Arrastra y suelta o haz clic para subir',
    'supported_formats': 'Soportado: JPG, PNG, WEBP (máx. 5MB)',
    'upload_id_documents': 'Subir Documentos de Identidad',
    'uploading': 'Subiendo...',
    'id_documents_uploaded': 'Documentos de identidad subidos con éxito',
    'id_documents_upload_failed': 'Error al subir documentos de identidad',
    'delete_document_side': 'Eliminar documento de {{side}}',
    'confirm_delete_document': '¿Estás seguro de que deseas eliminar este documento?',
    'document_deleted': 'Documento eliminado con éxito',
    'document_delete_failed': 'Error al eliminar documento',
    'no_id_documents': 'Aún no se han subido documentos de identidad',
    'view_document': 'Ver Documento',
    'close_preview': 'Cerrar Vista Previa',
    'save_changes': 'Guardar Cambios',
    'pending_upload': 'Carga Pendiente',
    'id_documents_tab': 'Docs de Identidad',
    'tenant_id_documents': 'Documentos de ID del Inquilino',
    'owner_id_documents': 'Documentos de ID del Propietario',
    'id_documents_description': 'Sube y gestiona imágenes de documentos de identidad',

    // Waitlist
    'waitlist': 'Lista de Espera',
    'waitlist_management': 'Gestión de Lista de Espera',
    'search_waitlist': 'Buscar por nombre, teléfono o unidad...',
    'waitlist_empty': 'La Lista de Espera está Vacía',
    'no_prospective_tenants_waiting': 'Ningún posible inquilino está esperando por una unidad en este momento.',

    // Waitlist table columns
    'priority': 'Prioridad',
    'prospect': 'Prospecto',
    'desired_unit': 'Unidad Deseada',
    'move_in_preference': 'Preferencia de Mudanza',
    'added': 'Añadido',
    'rank': '#{{priority}}',
    'process_to_booking': 'Convertir a Reserva',
    'remove': 'Eliminar',
    'remove_from_waitlist': 'Eliminar de la Lista de Espera',
    'remove_waitlist_confirm': '¿Estás seguro de que deseas eliminar este prospecto de la lista de espera? Esta acción no se puede deshacer.',

    // Waitlist status messages
    'waitlist_processed': 'Prospecto convertido a reserva pendiente con éxito',
    'failed_process_waitlist': 'Error al convertir esta entrada de la lista de espera en una reserva',
    'entry_removed': 'Entrada eliminada de la lista de espera',
    'failed_remove_entry': 'Error al eliminar entrada de la lista de espera',

    // Add to Waitlist Modal
    'add_to_waitlist': 'Añadir a la Lista de Espera',
    'waitlist_form_subtitle': 'El prospecto será promovido automáticamente cuando la unidad esté disponible',
    'desired_unit': 'Unidad Deseada',
    'prospect_details': 'Detalles del Prospecto',
    'prospect_name': 'Nombre del Prospecto',
    'prospect_phone': 'Teléfono del Prospecto',
    'prospect_email': 'Correo del Prospecto',
    'scheduling_priority': 'Programación y Prioridad',
    'preferred_move_in_date': 'Fecha de Mudanza Preferida',
    'higher_is_first': 'mayor = primero en la fila',
    'priority_hint': 'Los prospectos de mayor prioridad suben en la fila. El valor por defecto es 0 (FIFO).',
    'priority_range_error': 'La prioridad debe estar entre 0 y 10',
    'loading_apartments': 'Cargando apartamentos...',
    'field_required': 'Este campo es requerido',
    'adding': 'Añadiendo...',
    'added_to_waitlist': 'Prospecto añadido a la lista de espera con éxito',
    'failed_add_waitlist': 'Error al añadir el prospecto a la lista de espera',
    'waitlist_auto_promote_info': 'Cuando el apartamento seleccionado esté disponible, este prospecto se convertirá automáticamente en una reserva pendiente según su prioridad y posición en la fila.',
    'waitlist_notes_placeholder': 'Requisitos especiales, fuente del cliente, notas del agente...',

    // Maintenance Hub
    'maintenance_hub': 'Centro de Mantenimiento',
    'track_and_assign_maintenance': 'Rastrea solicitudes de inquilinos y asigna órdenes de trabajo a proveedores',
    'search_requests': 'Buscar por problema, inquilino o apartamento...',
    'loading_requests': 'Cargando solicitudes...',
    'no_maintenance_found': 'No se encontraron solicitudes de mantenimiento',
    'issue': 'Problema',
    'location': 'Ubicación',
    'tenant': 'Inquilino',
    'assign_vendor': 'Asignar Proveedor',
    'update_status': 'Actualizar Estado',
    'status_updated': 'Estado actualizado con éxito',
    'error_updating_status': 'Error al actualizar el estado',
    'error_fetching_data': 'Error al obtener los datos',

    // Work Orders
    'create_work_order': 'Crear Orden de Trabajo',
    'work_order_created': 'Orden de trabajo creada y asignada',
    'error_creating_work_order': 'Error al crear la orden de trabajo',
    'select_vendor': 'Seleccionar Proveedor',
    'select_a_vendor': 'Selecciona un Proveedor',
    'estimated_cost': 'Costo Estimado',
    'scheduled_date': 'Fecha Programada',
    'work_description': 'Descripción del Trabajo',

    // Maintenance statuses
    'open': 'Abierto',
    'in_progress': 'En Progreso',
    'completed': 'Completado',
    'cancelled': 'Cancelado',

    // Vendor Management
    'vendor_management': 'Gestión de Proveedores',
    'manage_maintenance_vendors': 'Gestiona contratistas de mantenimiento y proveedores de servicios externos',
    'add_vendor': 'Añadir Proveedor',
    'add_new_vendor': 'Añadir Nuevo Proveedor',
    'edit_vendor': 'Editar Proveedor',
    'search_vendors': 'Buscar proveedores por nombre o categoría...',
    'no_vendors_found': 'No se encontraron proveedores',
    'vendor_name': 'Nombre del Proveedor',
    'category': 'Categoría',
    'contact_person': 'Persona de Contacto',
    'vendor_created': 'Proveedor creado con éxito',
    'vendor_updated': 'Proveedor actualizado con éxito',
    'vendor_deleted': 'Proveedor eliminado con éxito',
    'update_vendor': 'Actualizar Proveedor',
    'save_vendor': 'Guardar Proveedor',
    'confirm_delete_vendor': '¿Estás seguro de que deseas eliminar este proveedor? Esta acción no se puede deshacer.',
    'error_fetching_vendors': 'Error al obtener proveedores',
    'error_saving_vendor': 'Error al guardar proveedor',
    'error_deleting_vendor': 'Error al eliminar proveedor',
    'confirm_delete_vendor_title': 'Eliminar proveedor',
    'vendor_no_email': 'El proveedor no tiene dirección de correo',
    'vendor_invite_saved': '¡Invitación guardada!',
    'vendor_invite_link_copied': 'Enlace de configuración copiado al portapapeles',
    'vendor_invite_failed': 'Error al enviar la invitación',
    'vendor_invite_portal': 'Invitar al portal de proveedores',
    'vendor_category_placeholder': 'ej. Plomería, IT, Electricidad',
    'vendor_1099_nec': 'Proveedor 1099-NEC',
    'vendor_1099_desc': 'Informe anual IRS — proveedores pagados ≥ $600 en compensación no laboral',
    'vendor_1099_disclaimer': 'Los formularios 1099-NEC son obligatorios para cualquier proveedor (no empleado) que recibió ≥ $600 en un año calendario. La fecha límite de presentación del IRS es generalmente el 31 de enero. Verifique siempre con un profesional fiscal antes de presentar.',
    '1099_required': '1099 Requerido',
    'no_vendor_payments_recorded': 'No hay pagos de proveedores registrados para',

    // Contract Templates
    'contract_templates': 'Plantillas de Contratos',
    'manage_legal_templates_desc': 'Gestiona marcos legales y reglas automatizadas para contratos.',
    'create_template': 'Crear Plantilla',
    'search_templates': 'Buscar plantillas...',
    'no_templates_found': 'No se encontraron plantillas',
    'create_first_template_desc': 'Empieza creando tu primera plantilla de contrato legal.',
    'no_description_provided': 'No se proporcionó descripción.',
    'default_rules': 'Reglas Predeterminadas',
    'failed_to_load_templates': 'Error al cargar plantillas',
    'template_deleted_successfully': 'Plantilla eliminada con éxito',
    'failed_to_delete_template': 'Error al eliminar plantilla',
    'confirm_delete_template': '¿Estás seguro de que deseas eliminar esta plantilla? Esta acción no se puede deshacer.',

    // Contract Template Form
    'edit_template': 'Editar Plantilla',
    'create_new_template': 'Crear Nueva Plantilla',
    'template_details': 'Detalles de la Plantilla',
    'template_name': 'Nombre de la Plantilla',
    'is_active': 'Plantilla Activa',
    'legal_text': 'Contenido del Texto Legal',
    'default_variable_rules': 'Reglas de Variables Predeterminadas',
    'default_rules_desc': 'Define variables predeterminadas (como commission_rate) que usará el creador.',
    'add_rule': 'Añadir Regla',
    'no_default_rules': 'No se definieron reglas predeterminadas.',
    'variable_name_placeholder': 'Nombre de Variable (ej. tasa_comision)',
    'default_value_placeholder': 'Valor Predeterminado (ej. 8)',
    'archive_template': 'Archivar Plantilla',
    'archive_template_confirm': '¿Estás seguro de que deseas archivar esta plantilla? Ya no estará disponible para nuevos contratos.',
    'archive': 'Archivar',
    'template_archived_successfully': 'Plantilla archivada con éxito',
    'failed_to_archive_template': 'Error al archivar la plantilla',
    'template_updated_successfully': 'Plantilla actualizada con éxito',
    'template_created_successfully': 'Plantilla creada con éxito',
    'failed_to_save_template': 'Error al guardar la plantilla',
    'failed_to_load_template': 'Error al cargar la plantilla',

    // Contract types
    'management': 'Gestión',
    'lease': 'Arrendamiento',
    'sale': 'Venta',
    'lease_progress': 'Progreso del Contrato',
    // Maintenance status (for translated <select> options)
    'status_open': 'Abierto',
    'status_in_progress': 'En Progreso',
    'status_completed': 'Completado',
    'status_cancelled': 'Cancelado',
    // Maintenance priority badges
    'priority_low': 'Baja',
    'priority_medium': 'Media',
    'priority_high': 'Alta',
    'priority_urgent': 'Urgente',
    'priority_emergency': 'Emergencia',
    // Estimated cost label
    'estimated_cost': 'Costo Est.',
    // Portal submissions (overview + id docs tab)
    'tenant_portal_submissions': 'Envíos del Portal del Inquilino',
    'portal_submission_note': 'Archivos enviados por el inquilino a través de su portal de autoservicio',
    'tenant_proof_document': 'ID / Documento de Prueba',
    'tenant_insurance_document': 'Seguro / Certificado',
    'not_submitted': 'No Enviado',
    'saved': 'Guardado',
    'payment_method': 'Método',
    'tenant_ledger': 'Libro Mayor del Inquilino',
    'ledger_description': 'Registro inmutable de todos los cargos y pagos. Añade créditos para corregir errores.',
    'ledger_generate_monthly': 'Generar Mensual',
    'ledger_add_charge': 'Añadir Cargo',
    'ledger_add_credit': 'Añadir Crédito',
    'ledger_apply_late_fee': 'Aplicar Cargo por Mora',
    'ledger_late_fee': 'Cargo por Mora',
    'ledger_charge': 'Cargo',
    'ledger_deposit': 'Depósito',
    'ledger_payment': 'Pago',
    'ledger_credit': 'Crédito',
    'ledger_charge_rent_fee': 'Cargo (Alquiler / Cuota)',
    'ledger_description_placeholder': 'ej. Cuota de mantenimiento',
    'outstanding_balance': 'Saldo Pendiente',
    'ledger_balance_note': 'Derivado de todas las entradas del libro mayor',
    'ledger_total_entries': 'Total de Entradas',
    'ledger_no_entries': 'No hay entradas en el libro mayor todavía',
    'ledger_no_entries_hint': 'Genera el primer cargo mensual o registra un cargo manual arriba.',
    'ledger_balance_after': 'Saldo Después',
    'ledger_charge_added': 'Cargo añadido al libro mayor',
    'ledger_charge_failed': 'Error al añadir el cargo',
    'ledger_credit_added': 'Crédito añadido al libro mayor',
    'ledger_credit_failed': 'Error al añadir el crédito',
    'ledger_late_fee_applied': 'Cargo por mora aplicado al libro mayor',
    'ledger_late_fee_failed': 'Error al aplicar cargo por mora',
    'ledger_monthly_generated': 'Cargo mensual generado',
    'ledger_monthly_failed': 'Error al generar el cargo',
    'ledger_load_failed': 'Error al cargar el libro mayor',
    'created_by': 'Creado Por',
    'expired': 'Caducado',
    'expiring_soon': 'Vence Pronto',
    'email': 'Correo',

    // Tenant Portal
    // Dashboard
    'failed_to_load_dashboard_data': 'Error al cargar datos del panel',
    'welcome_back_user': 'Bienvenido de nuevo, {{name}}',
    'tenancy_overview': 'Un vistazo a tu arrendamiento',
    'unit_display': 'Unidad {{number}}',
    'current_balance': 'Saldo Actual',
    'action_required': 'Acción Requerida',
    'account_good_standing': 'Cuenta al día',
    'lease_ends': 'El contrato termina',
    'view_lease_short': 'Ver contrato',
    'need_repairs': '¿Necesitas Reparaciones?',
    'repairs_subtitle': 'Envía una solicitud de mantenimiento',
    'create_request': 'Crear Solicitud',
    'quick_actions': 'Acciones Rápidas',
    'pay_now': 'Pagar Ahora',
    'recent_account_activity': 'Actividad Reciente de la Cuenta',
    'view_ledger': 'Ver libro mayor',
    'no_ledger_entries_yet': 'Aún no hay entradas',
    'active_maintenance': 'Mantenimiento Activo',
    'view_all': 'Ver todo',
    'all_clear_maintenance': 'Todo despejado — sin solicitudes abiertas',
    'maintenance_request_default': 'Solicitud de Mantenimiento',
    'building_news': 'Noticias del Edificio',
    'lease_progress': 'Progreso del Contrato',
    'days_left': 'Quedan {{days}} días',
    'expires_today': '¡Caduca hoy!',
    'pct_elapsed': '{{pct}}% transcurrido',
    'balance_after': 'saldo:',

    // Payments
    'failed_to_load_payment_data': 'Error al cargar datos de pago',
    'failed_to_initiate_payment': 'Error al iniciar pago',
    'payments_billing': 'Pagos y Facturación',
    'payments_billing_subtitle': 'Tu historial de alquiler, cargos por servicio y libro mayor completo',
    'download_statement': 'Descargar Estado de Cuenta',
    'current_amount_due': 'Monto Actual a Pagar',
    'due_on': 'Vence el',
    'view_ledger_hint': '¿Quieres ver exactamente cómo se calculó esto?',
    'view_your_ledger': 'Ver tu libro mayor',
    'in_n_days': 'En {{count}} día',
    'in_n_days_plural': 'En {{count}} días',
    'due_today': '⚡ Vence hoy',
    'all_paid_up': '¡Todo pagado!',
    'tab_rent_payments': 'Pagos de Alquiler',
    'tab_service_charges': 'Cargos por Servicio',
    'tab_service_charges_due': 'Cargos por Servicio ({{count}} por pagar)',
    'tab_account_ledger': 'Libro Mayor',
    'transaction_history': 'Historial de Transacciones',
    'no_transactions': 'Aún no hay transacciones',
    'no_transactions_subtitle': 'Tu historial de pagos aparecerá aquí cuando se registren los pagos.',
    'rejected': 'Rechazado',
    'outstanding_service_charges': 'Cargos por Servicio Pendientes',
    'paid_service_history': 'Historial de Servicios Pagados',
    'service_charge_default': 'Cargo por Servicio',
    'pay': 'Pagar',
    'paid_badge': 'Pagado',
    'no_service_charges': 'Sin cargos por servicio',
    'no_service_charges_subtitle': 'No tienes cargos por servicio en este momento.',
    'account_balance': 'Saldo de la Cuenta',
    'ledger_calculated_from': 'Calculado a partir de {{count}} entradas',
    'full_account_statement': 'Estado de Cuenta Completo',
    'full_account_statement_subtitle': 'Cada cargo y pago en tu cuenta, con saldo acumulado.',
    'balance_after_col': 'Saldo Después',
    'no_ledger_entries': 'Aún no hay entradas',
    'no_ledger_entries_subtitle': 'Tu historial financiero aparecerá aquí una vez que se publiquen los cargos.',
    'ledger_type_charge': 'Cargo',
    'ledger_type_late_fee': 'Mora',
    'ledger_type_deposit': 'Depósito',
    'ledger_type_payment': 'Pago',
    'ledger_type_credit': 'Crédito',
    'payment_success_stripe': '¡Pago exitoso! Tu cuenta se actualizará en breve.',
    'payment_cancelled_stripe': 'El pago fue cancelado. No se realizó ningún cargo.',
    'online_payments_not_enabled': 'Los pagos en línea aún no están habilitados.',

    // Lease
    'failed_to_load_lease_details': 'Error al cargar detalles del contrato',
    'lease_signed_success': '¡Contrato firmado con éxito!',
    'failed_to_sign_lease': 'Error al firmar el contrato',
    'lease_pdf_download_success': 'PDF del contrato descargado con éxito',
    'lease_pdf_download_failed': 'Error al descargar PDF del contrato. Inténtalo de nuevo.',
    'generating': 'Generando…',
    'download_pdf': 'Descargar PDF',
    'download_your_lease': 'Descarga tu contrato firmado en PDF',
    'unit_prefix': 'Unidad',
    'ip_trace': 'Rastro de IP:',
    'integrity_hash': 'Hash de Integridad:',
    'signature_graphic': 'Gráfico de Firma:',
    'lease_details': 'Detalles del Contrato',
    'lease_details_subtitle': 'Tu acuerdo de alquiler activo e información de pago',
    'lease_signed': 'Firmado',
    'sign_lease_now': 'Firmar Contrato Ahora',
    'contract_term': 'Término del Contrato',
    'start_date': 'Fecha de Inicio',
    'end_date': 'Fecha de Fin',
    'property_information': 'Información de la Propiedad',
    'landlord_owner': 'Propietario / Arrendador',
    'payment_status': 'Estado de Pago',
    'payment_required': 'Pago requerido',
    'e_signature_recorded': 'Firma Electrónica Registrada',
    'signed_on': 'Firmado el',
    'legal_disclosure': 'Divulgación Legal',
    'legal_disclosure_text': 'Este contrato de arrendamiento es legalmente vinculante. Al firmar electrónicamente, aceptas todos los términos y condiciones. Asegúrate de haber leído el documento completo antes de firmar.',
    'lease_not_found': 'Contrato No Encontrado',
    'contact_management_error': 'Por favor, contacta con la administración si crees que esto es un error.',

    // Profile
    'my_profile': 'Mi Perfil',
    'my_profile_subtitle': 'Actualiza tu información de contacto y contraseña',
    'personal_information': 'Información Personal',
    'full_name': 'Nombre Completo',
    'your_full_name_placeholder': 'Tu nombre completo',
    'phone_placeholder': '+1 234 567 8900',
    'email_placeholder': 'tu@correo.com',
    'save_changes': 'Guardar Cambios',
    'change_password': 'Cambiar Contraseña',
    'current_password': 'Contraseña Actual',
    'new_password': 'Nueva Contraseña',
    'confirm_new_password': 'Confirmar Nueva Contraseña',
    'min_8_chars': 'Mín. 8 caracteres',
    'repeat_new_password': 'Repite la nueva contraseña',
    'update_password': 'Actualizar Contraseña',
    'updating': 'Actualizando...',
    'passwords_do_not_match': 'Las contraseñas no coinciden',
    'password_min_8': 'La contraseña debe tener al menos 8 caracteres',
    'failed_to_load_profile': 'Error al cargar el perfil',
    'profile_updated': '¡Perfil actualizado con éxito!',
    'password_changed': '¡Contraseña cambiada con éxito!',
    'failed_to_update_profile': 'Error al actualizar el perfil',
    'failed_to_change_password': 'Error al cambiar la contraseña',
    'account_id': 'ID de Cuenta',
    'tenant_since': 'Inquilino Desde',

    // Inspections
    'my_inspections': 'Mis Inspecciones',
    'my_inspections_subtitle': 'Informes de inspección de propiedad para tu unidad',
    'no_inspections_yet': 'Aún no hay inspecciones',
    'no_inspections_subtitle': 'Los informes de inspección completados para tu unidad aparecerán aquí.',
    'items_checked': '{{done}}/{{total}} elementos revisados',
    'inspection_items': 'Elementos de Inspección',
    'general_notes': 'Notas Generales',
    'failed_to_load_inspections': 'Error al cargar inspecciones',
    'inspection_type_move_in': 'Mudanza (Entrada)',
    'inspection_type_move_out': 'Mudanza (Salida)',
    'inspection_type_periodic': 'Periódica',
    'inspection_type_maintenance': 'Mantenimiento',
    'inspection_status_completed': 'Completada',
    'inspection_status_signed': 'Firmada',
    'inspection_status_draft': 'Borrador',

    // Services
    'service_charges_title': 'Cargos por Servicio',
    'service_charges_subtitle': 'Cuotas de servicio mensual del edificio para tu unidad',
    'total_charges': 'Cargos Totales',
    'outstanding_balance_label': 'Saldo Pendiente',
    'service_charges_year': 'Cargos por Servicio — {{year}}',
    'no_service_charges_year': 'No hay cargos por servicio en {{year}}',
    'no_service_charges_year_hint': 'Los cargos aparecerán aquí cuando sean generados por la administración del edificio.',
    'paid_on': 'Pagado el {{date}}',
    'unpaid': 'No Pagado',
    'pay_online': 'Pagar en Línea',
    'service_paid_success': '¡Cargo de servicio pagado con éxito!',
    'payment_canceled': 'Pago cancelado.',
    'failed_to_load_service_charges': 'Error al cargar cargos por servicio',

    // Owner Dashboard
    'portfolio_summary': 'Resumen de Cartera',
    'portfolio_subtitle': 'Métricas de rendimiento en tiempo real para {{name}}.',
    'portfolio_statement': 'Estado de Cartera',
    'total_units': 'Unidades Totales',
    'occupancy_rate': 'Tasa de Ocupación',
    'active_leases': '{{count}} Contratos Activos',
    'monthly_revenue': 'Ingresos Mensuales',
    'vacant_units': 'Unidades Vacantes',
    'installment_summary': 'Resumen de Plazos',
    'view_detailed_ledger': 'Ver Libro Mayor Detallado',
    'outstanding': 'Pendiente',
    'across_installments': 'A través de {{count}} plazos',
    'actions_required': '{{count}} Acciones Inmediatas Requeridas',
    'proceed_to_payments': 'Proceder a Pagos',
    'revenue_performance': 'Rendimiento de Ingresos (Últimos 6 Meses)',
    'no_revenue_data': 'No se encontraron datos de ingresos',
    'portfolio_distribution': 'Distribución de Cartera',
    'no_building_data': 'No se encontraron datos del edificio',
    'occupied_label': 'OCUPADO',
    'ready_to_scale': '¿Listo para crecer?',
    'ready_to_scale_subtitle': 'Gestiona tus propiedades con la máxima visibilidad.',
    'financials': 'Finanzas',
    'approvals': 'Aprobaciones',
    'failed_to_download_statement': 'Error al descargar estado de cuenta',

    // Properties
    'my_properties': 'Mis Propiedades',
    'my_properties_subtitle': 'Un resumen de todas las unidades dentro de tu cartera de gestión.',
    'portfolio_empty': 'Cartera Vacía',
    'portfolio_empty_subtitle': 'Actualmente no hay unidades asignadas a tu cuenta.',
    'floor_prefix': 'Piso',
    'current_rent': 'Alquiler Actual',
    'per_month_short': '/mes',
    'sqm': 'm²',

    // Maintenance
    'maintenance_approvals': 'Aprobaciones de Mantenimiento',
    'maintenance_approvals_subtitle': 'Revisa y aprueba las reparaciones solicitadas por inquilinos en toda tu cartera.',
    'no_maintenance_requests': 'Sin Solicitudes de Mantenimiento',
    'no_maintenance_subtitle': 'Todas tus propiedades están bien mantenidas actualmente.',
    'pending_approval': 'Pendiente de Aprobación',
    'approved_in_progress': 'Aprobado / En Progreso',
    'rejected_cancelled': 'Rechazado/Cancelado',
    'above_threshold': 'Por encima del umbral de ${{amount}}',
    'high_priority': 'Prioridad Alta',
    'medium_priority': 'Prioridad Media',
    'low_priority': 'Prioridad Baja',
    'est_cost': 'Costo Est.',
    'approve': 'Aprobar',
    'reject': 'Rechazar',
    'request_status_updated': 'Estado de solicitud actualizado',
    'failed_to_update_request': 'Error al actualizar el estado de la solicitud',
    'failed_to_load_maintenance': 'Error al cargar solicitudes de mantenimiento',
    'failed_to_load_properties': 'Error al cargar tus propiedades',

    // Financials
    'financial_overview': 'Resumen Financiero',
    'financial_subtitle': 'Rastrea los ingresos generados por tus inquilinos en todas las propiedades.',
    'no_financial_data': 'Sin Datos Financieros',
    'no_payments_message': 'Actualmente no hay pagos registrados para tu cartera.',
    'recent_payments': 'Pagos Recientes',
    'generating': 'Generando…',
    'overdue_payments': 'Pagos Atrasados',
    'property_tenant': 'Propiedad / Inquilino',
    'gross_amount': 'Monto Bruto',
    'commission': 'Comisión',
    'net_amount': 'Monto Neto',
    'since': 'Desde',
    'amount_owed': 'Monto Adeudado',
    'management_commission': 'Comisión de Gestión',
    'failed_to_load_financials': 'Error al cargar registros financieros',
    'statement_downloaded': '¡Estado de cuenta de {{month}} {{year}} descargado!',

    // Profile
    'member_since': 'Miembro Desde',
    'saving': 'Guardando...',

    // Messages
    'owner_messages_title': 'Administración de la Propiedad',
    'owner_messages_subtitle': 'Mensaje directo con el equipo de gestión',

    // Messages
    'management_team': 'Equipo de Gestión',
    'management_team_subtitle': 'Mensaje directo con la administración de la propiedad',
    'message_empty_state': 'Envía un mensaje para contactar a la administración.',
    'message_placeholder': 'Escribe un mensaje a la administración...',
    'failed_to_load_messages': 'Error al cargar mensajes',
    'failed_to_send_message': 'Error al enviar mensaje',

    // OwnerServices
    'owner_service_charges': 'Cargos por Servicio',
    'owner_service_charges_subtitle': 'Cuotas de servicio mensual del edificio para tus unidades vacantes',
    'owner_service_info': 'Los cargos por servicio solo aplican a tus unidades <strong>vacantes</strong>. Las unidades ocupadas por inquilinos se facturan directamente a ellos.',
    'total_charges': 'Cargos Totales',
    'outstanding_balance': 'Saldo Pendiente',
    'no_service_charges_year': 'Sin cargos por servicio para {{year}}',
    'no_service_charges_subtitle': 'Los cargos por servicio para unidades vacantes aparecerán aquí cuando se generen.',
    'paid_on': 'Pagado el {{date}}',
    'pay_online': 'Pagar en Línea',
    'service_charge_paid': '¡Cargo de servicio pagado con éxito!',
    'unpaid': 'No Pagado',

    // OwnerContracts / OwnerInstallments
    'my_agreements': 'Mis Acuerdos',
    'agreements_subtitle': 'Ver todos tus contratos de gestión y registros de propiedad.',
    'no_active_agreements': 'No hay Acuerdos Activos',
    'no_contracts_message': "Aún no tienes contratos de gestión registrados en nuestro sistema.",
    'total_value': 'Valor Total',
    'remaining': 'Restante',
    'indefinite': 'Indefinido',
    'sign_now': 'Firmar Ahora',
    'failed_to_load_agreements': 'Error al cargar acuerdos',
    'financial_ledger': 'Libro Mayor Financiero',
    'ledger_subtitle': 'Desglose detallado de los pagos a plazos de tu cuota de gestión y saldos pendientes.',
    'total_outstanding': 'Total Pendiente',
    'no_installments': 'No se encontraron plazos en tu libro mayor.',
    'settled': 'Saldado',
    'pay_amount': 'Pagar {{amount}}',
    'failed_to_load_installments': 'Error al cargar calendario de plazos',
    'failed_to_initiate_payment': 'Error al iniciar el pago',
    'error_connecting_payment': 'Error al conectar con el proveedor de pagos',
    'payment_success_msg': '¡Pago completado con éxito!',
    'payment_canceled_msg': 'El pago fue cancelado.',

    // Layout / Sidebar / Header
    'welcome_user': '¡Bienvenido/a, {{name}}!',
    'owner_portal': 'Portal del Propietario',
    'tenant_portal': 'Portal del Inquilino',
    'owner': 'Propietario',
    'tenant': 'Inquilino',

    // Sidebar section headings
    'core': 'Principal',
    'properties_&_contracts': 'Propiedades y Contratos',
    'financial': 'Financiero',
    'financial_&_lease': 'Finanzas y Contratos',
    'maintenance': 'Mantenimiento',

    // Sidebar nav item labels
    'Dashboard': 'Panel',
    'Properties': 'Propiedades',
    'Contracts': 'Contratos',
    'Installments': 'Plazos',
    'Service Charges': 'Cargos por Servicio',
    'Financials': 'Finanzas',
    'Maintenance': 'Mantenimiento',
    'Payments': 'Pagos',
    'Lease Details': 'Detalles del Contrato',
    'Inspections': 'Inspecciones',
    'Profile': 'Perfil',
    'documents': 'Documentos',
    'announcements': 'Anuncios',
    'messages': 'Mensajes',
    'Messages': 'Mensajes',

    // Tenant Maintenance
    'maintenance_subtitle': 'Envía y haz seguimiento de todas tus solicitudes de mantenimiento en un solo lugar.',
    'new_request': 'Nueva Solicitud',
    'report_an_issue': 'Reportar un Problema',
    'issue_summary': 'Resumen del Problema',
    'issue_summary_placeholder': 'ej. Grifo goteando en el baño',
    'urgency_level': 'Nivel de Urgencia',
    'low_urgency': 'Baja – No es urgente',
    'normal_urgency': 'Normal – Requiere atención',
    'high_urgency': 'Alta – Afecta la vida diaria',
    'emergency_urgency': 'Emergencia – Acción inmediata necesaria',
    'describe_the_problem': 'Describe el Problema',
    'describe_problem_placeholder': 'Por favor, describe el problema con el mayor detalle posible...',
    'upload_photo_optional': 'Subir Foto (Opcional)',
    'add_photo': 'Añadir Foto',
    'photo_upload_tip': 'Una foto nos ayuda a resolver el problema más rápido.',
    'photo_upload_specs': 'JPG, PNG o WEBP. Máx. 5MB.',
    'emergency_contact_warning': 'Para emergencias que pongan en peligro la vida, llama a los servicios de emergencia de inmediato. Trataremos esta solicitud como máxima prioridad.',
    'processing': 'Procesando...',
    'submit_request': 'Enviar Solicitud',
    'ongoing_past_requests': 'Solicitudes Pasadas y en Curso',
    'submitted': 'Enviado',
    'in_progress': 'En Progreso',
    'completed': 'Completado',
    'request_cancelled': 'Solicitud Cancelada',
    'all_clear': '¡Todo Despejado!',
    'no_maintenance_on_record': 'No hay solicitudes de mantenimiento registradas. ¡Todo parece estar bien!',
    'resolved_on': 'Resuelto el {{date}}',
    'failed_to_load_maintenance_requests': 'Error al cargar solicitudes de mantenimiento',
    'failed_to_submit_request': 'Error al enviar solicitud',
    'photo_size_limit_error': 'La foto debe pesar menos de 5MB',
    'request_submitted_success': 'Solicitud enviada con éxito',
    'low': 'Baja',
    'normal': 'Normal',
    'high': 'Alta',
    'emergency': 'Emergencia',
    'id': 'ID',

    // Tenant Announcements
    'announcements_subtitle': 'Mantente al día con las últimas noticias y actualizaciones de la administración del edificio.',
    'no_announcements_title': 'Sin Anuncios',
    'no_announcements_subtitle': 'Vuelve a revisar más tarde para ver actualizaciones de la administración del edificio.',
    'posted_by': 'Publicado por {{name}}',
    'failed_to_load_announcements': 'Error al cargar anuncios',

    // Tenant Documents
    'documents_verification': 'Documentos y Verificación',
    'documents_verification_subtitle': 'Sube y gestiona tus documentos requeridos. Mantener tus documentos actualizados asegura una experiencia de alquiler sin problemas.',
    'supported_formats_specs': 'Formatos aceptados: PDF, JPG, JPEG, PNG. Tamaño máximo de archivo: 5MB por documento.',
    'identification_proof': 'Prueba de Identificación',
    'identification_proof_desc': 'Identificación emitida por el gobierno como un pasaporte, DNI o licencia de conducir.',
    'renters_insurance': 'Seguro de Inquilino',
    'renters_insurance_desc': 'Un certificado de seguro de inquilino válido que cubra tu unidad.',
    'verified': 'Verificado',
    'missing': 'Faltante',
    'pdf_document': 'Documento PDF',
    'view_full_size': 'Ver Tamaño Completo',
    'replace': 'Reemplazar',
    'upload_file': 'Subir Archivo',
    'need_help_verification': '¿Necesitas ayuda con la Verificación?',
    'need_help_verification_subtitle': 'Si tienes problemas para subir tus documentos o necesitas enviar una forma alternativa de identificación, contacta a nuestro equipo de soporte y estaremos encantados de ayudarte.',
    'contact_support': 'Contactar Soporte',
    'failed_to_load_document_status': 'Error al cargar estado del documento',
    'file_size_large_error': 'Archivo demasiado grande. Máx. 5MB.',
    'document_uploaded_success': 'Documento subido con éxito',
    'failed_to_upload_document': 'Error al subir el documento',

    // Tenant Inspections
    'my_inspections': 'Mis Inspecciones',
    'my_inspections_subtitle': 'Ver todas las inspecciones de la propiedad relacionadas con tu arrendamiento.',
    'no_inspections_yet': 'Aún no hay inspecciones',
    'no_inspections_subtitle': 'Tus registros de inspección de la propiedad aparecerán aquí una vez completados.',
    'failed_to_load_inspections': 'Error al cargar inspecciones',
    'inspection_type_move_in': 'Mudanza (Entrada)',
    'inspection_type_move_out': 'Mudanza (Salida)',
    'inspection_type_periodic': 'Periódica',
    'inspection_type_maintenance': 'Mantenimiento',
    'inspection_status_completed': 'Completada',
    'inspection_status_signed': 'Firmada',
    'inspection_status_draft': 'Borrador',
    'unit_prefix': 'Unidad',
    'items_checked': '{{done}} / {{total}} elementos revisados',
    'inspection_items': 'Elementos de Inspección',
    'general_notes': 'Notas Generales',

    // Tenant Messages
    'management_team': 'Equipo de Gestión',
    'management_team_subtitle': 'Línea directa con la administración de tu edificio',
    'message_empty_state': 'No hay mensajes aún. ¡Comienza la conversación!',
    'failed_to_load_messages': 'Error al cargar mensajes',
    'failed_to_send_message': 'Error al enviar mensaje',
    'message_placeholder': 'Escribe un mensaje...',

    // Tenant Lease
    'lease_details_subtitle': 'Revisa tu contrato de alquiler, estado de pago y firma digital.',
    'lease_not_found': 'No Se Encontró Contrato',
    'contact_management_error': 'Por favor, contacta a la administración de tu edificio para obtener asistencia.',
    'lease_signed': 'Firmado',
    'download_your_lease': 'Descarga tu contrato en formato PDF',
    'generating': 'Generando...',
    'download_pdf': 'Descargar PDF',
    'sign_lease_now': 'Firmar Contrato Ahora',
    'contract_term': 'Término del Contrato',
    'property_information': 'Propiedad y Propietario',
    'landlord_owner': 'Arrendador / Propietario',
    'payment_status': 'Estado de Pago',
    'current_balance': 'Saldo Actual',
    'payment_required': 'Pago requerido',
    'account_good_standing': 'Cuenta al día',
    'lease_signed_success': '¡Contrato firmado con éxito!',
    'failed_to_sign_lease': 'Error al firmar el contrato',
    'lease_pdf_download_success': 'PDF del contrato descargado con éxito',
    'lease_pdf_download_failed': 'Error al descargar el PDF del contrato',
    'e_signature_recorded': 'Firma Electrónica Registrada',
    'signed_on': 'Firmado el',
    'ip_trace': 'IP',
    'integrity_hash': 'Hash',
    'signature_graphic': 'Tu Firma',
    'legal_disclosure': 'Divulgación Legal',
    'legal_disclosure_text': 'Este contrato de arrendamiento es un documento legalmente vinculante. Al firmar electrónicamente, aceptas todos los términos y condiciones descritos en el contrato. Si tienes alguna pregunta, contacta a la administración del edificio antes de firmar.',

    // Tenant Payments
    'payments_billing': 'Pagos y Facturación',
    'payments_billing_subtitle': 'Haz seguimiento a tus pagos de alquiler, cargos de servicio y libro mayor de la cuenta.',
    'download_statement': 'Descargar Estado de Cuenta',
    'current_amount_due': 'Monto Actual a Pagar',
    'due_on': 'Vence el',
    'view_ledger_hint': 'Ver tu historial completo de transacciones en el',
    'view_your_ledger': 'Libro Mayor de la Cuenta',
    'all_paid_up': '¡Todo Pagado!',
    'tab_rent_payments': 'Pagos de Alquiler',
    'tab_service_charges': 'Cargos por Servicio',
    'tab_service_charges_due': 'Cargos por Servicio ({{count}} vencidos)',
    'tab_account_ledger': 'Libro Mayor',
    'transaction_history': 'Historial de Transacciones',
    'no_transactions': 'No Hay Transacciones Aún',
    'no_transactions_subtitle': 'Tu historial de pagos de alquiler aparecerá aquí.',
    'outstanding_service_charges': 'Cargos de Servicio Pendientes',
    'service_charge_default': 'Cargo por Servicio',
    'paid_service_history': 'Historial de Servicios Pagados',
    'paid_badge': 'Pagado',
    'no_service_charges': 'Sin Cargos por Servicio',
    'no_service_charges_subtitle': 'No se han facturado cargos de servicio a tu cuenta.',
    'account_balance': 'Saldo de la Cuenta',
    'ledger_calculated_from': 'Calculado a partir de {{count}} transacciones',
    'full_account_statement': 'Estado de Cuenta Completo',
    'full_account_statement_subtitle': 'Todos los cargos y pagos en tu cuenta',
    'no_ledger_entries': 'Sin Entradas en el Libro Mayor',
    'no_ledger_entries_subtitle': 'La actividad de tu cuenta aparecerá aquí.',
    'balance_after_col': 'Saldo Después',
    'ledger_type_charge': 'Cargo',
    'ledger_type_late_fee': 'Mora',
    'ledger_type_deposit': 'Depósito',
    'ledger_type_payment': 'Pago',
    'ledger_type_credit': 'Crédito',
    'payment_success_stripe': '¡Pago exitoso! Tu cuenta ha sido actualizada.',
    'payment_cancelled_stripe': 'Pago cancelado. No se realizaron cargos.',
    'online_payments_not_enabled': 'Los pagos en línea no están habilitados para tu cuenta.',
    'failed_to_initiate_payment': 'Error al iniciar el pago',
    'failed_to_load_payment_data': 'Error al cargar los datos de pago',

    // Tenant Profile
    'my_profile': 'Mi Perfil',
    'my_profile_subtitle': 'Gestiona tu información personal y la seguridad de tu cuenta.',
    'personal_information': 'Información Personal',
    'full_name': 'Nombre Completo',
    'your_full_name_placeholder': 'Tu nombre completo',
    'phone_placeholder': '+1 (555) 000-0000',
    'email_placeholder': 'tu@ejemplo.com',
    'saving': 'Guardando...',
    'save_changes': 'Guardar Cambios',
    'change_password': 'Cambiar Contraseña',
    'current_password': 'Contraseña Actual',
    'new_password': 'Nueva Contraseña',
    'confirm_new_password': 'Confirmar Nueva Contraseña',
    'min_8_chars': 'Mín. 8 caracteres',
    'repeat_new_password': 'Repite la nueva contraseña',
    'passwords_do_not_match': 'Las contraseñas no coinciden',
    'updating': 'Actualizando...',
    'update_password': 'Actualizar Contraseña',
    'account_id': 'ID de la Cuenta',
    'tenant_since': 'Inquilino desde',
    'failed_to_load_profile': 'Error al cargar el perfil',
    'profile_updated': 'Perfil actualizado con éxito',
    'failed_to_update_profile': 'Error al actualizar el perfil',
    'password_changed': 'Contraseña cambiada con éxito',
    'failed_to_change_password': 'Error al cambiar la contraseña',
    'password_min_8': 'La contraseña debe tener al menos 8 caracteres',

    // Tenant Services
    'service_charges_title': 'Cargos por Servicio',
    'service_charges_subtitle': 'Visualiza y paga tus facturas de servicios públicos y otros cargos.',
    'total_charges': 'Cargos Totales',
    'outstanding_balance_label': 'Pendiente',
    'service_charges_year': 'Cargos por Servicio — {{year}}',
    'no_service_charges_year': 'Sin cargos por servicio para {{year}}',
    'no_service_charges_year_hint': 'Intenta seleccionar un año diferente.',
    'paid_on_date': 'Pagado el {{date}}',
    'unpaid_label': 'No Pagado',
    'pay_online': 'Pagar en Línea',
    'service_paid_success': '¡Cargo por servicio pagado con éxito!',
    'payment_canceled': 'El pago fue cancelado.',
    'failed_to_load_service_charges': 'Error al cargar cargos por servicio',

    // Owner Dashboard
    'portfolio_summary': 'Resumen de Cartera',
    'portfolio_subtitle': 'Bienvenido/a de nuevo, {{name}}. Aquí está el resumen de tu cartera de propiedades.',
    'portfolio_statement': 'Estado de la Cartera',
    'total_units': 'Unidades Totales',
    'occupancy_rate': 'Tasa de Ocupación',
    'active_leases': '{{count}} contratos activos',
    'monthly_revenue': 'Ingresos Mensuales',
    'vacant_units': 'Unidades Vacantes',
    'installment_summary': 'Resumen de Plazos',
    'view_detailed_ledger': 'Ver Libro Mayor Detallado',
    'outstanding': 'Pendiente',
    'across_installments': 'A través de {{count}} plazos',
    'overdue': 'Atrasado',
    'actions_required': '{{count}} acciones requeridas',
    'proceed_to_payments': 'Proceder a Pagos',
    'revenue_performance': 'Rendimiento de Ingresos',
    'no_revenue_data': 'No hay datos de ingresos disponibles',
    'portfolio_distribution': 'Distribución de Cartera',
    'no_building_data': 'No hay datos de edificios disponibles',
    'occupied_label': 'ocupado',
    'ready_to_scale': '¿Listo para gestionar tu cartera?',
    'ready_to_scale_subtitle': 'Accede a herramientas clave para estar al tanto de tus propiedades',
    'failed_to_load_dashboard_data': 'Error al cargar datos del panel',
    'failed_to_download_statement': 'Error al descargar estado de cuenta',

    // Owner Messages
    'owner_messages_title': 'Mensajes',
    'owner_messages_subtitle': 'Comunicaciones directas con la administración del edificio',

    // Owner Properties
    'my_properties': 'Mis Propiedades',
    'my_properties_subtitle': 'Ver todos los apartamentos y unidades asignadas a tu cartera.',
    'portfolio_empty': 'No Se Encontraron Propiedades',
    'portfolio_empty_subtitle': 'Aún no se han asignado apartamentos a tu cartera. Contacta al administrador del edificio para obtener ayuda.',
    'floor_prefix': 'Piso',
    'sqm': 'm²',
    'current_rent': 'Alquiler Actual',
    'per_month_short': '/mes',
    'failed_to_load_properties': 'Error al cargar propiedades',

    // Owner Maintenance
    'maintenance_approvals': 'Aprobaciones de Mantenimiento',
    'maintenance_approvals_subtitle': 'Revisa y aprueba o rechaza solicitudes de mantenimiento de inquilinos para tus propiedades.',
    'failed_to_load_maintenance': 'Error al cargar solicitudes de mantenimiento',
    'request_status_updated': 'Estado de solicitud actualizado con éxito',
    'failed_to_update_request': 'Error al actualizar la solicitud de mantenimiento',
    'pending_approval': 'Pendiente de Aprobación',
    'approved_in_progress': 'Aprobada / En Progreso',
    'rejected_cancelled': 'Rechazada / Cancelada',
    'above_threshold': 'Por encima del umbral (${{amount}})',
    'no_maintenance_requests': 'Sin Solicitudes de Mantenimiento',
    'no_maintenance_subtitle': 'Las solicitudes de mantenimiento de inquilinos que requieran tu aprobación aparecerán aquí.',

    // Owner Financials
    'financial_overview': 'Resumen Financiero',
    'financial_subtitle': 'Rastrea los ingresos generados por tus inquilinos en todas tus propiedades.',
    'no_financial_data': 'Sin Datos Financieros',
    'no_payments_message': 'Actualmente no hay pagos registrados para tu cartera.',
    'recent_payments': 'Pagos Recientes',
    'property_tenant': 'Propiedad / Inquilino',
    'gross_amount': 'Monto Bruto',
    'commission': 'Comisión',
    'net_amount': 'Monto Neto',
    'overdue_payments': 'Pagos Atrasados',
    'failed_to_load_financials': 'Error al cargar información financiera',
    'statement_downloaded': 'Estado de cuenta de {{month}} {{year}} descargado',
    'management_commission': 'Comisión de Gestión',
    'unit_display': 'Unidad {{number}}',
    'since': 'Desde',
    'amount_owed': 'Monto Adeudado',

    // Owner Installments
    'financial_ledger': 'Libro Mayor Financiero',
    'ledger_subtitle': 'Todos los pagos a plazos de tus contratos de propiedades.',
    'total_outstanding': 'Total Pendiente',
    'installment': 'Plazo',
    'due_date': 'Fecha de Vencimiento',
    'action': 'Acción',
    'partial': 'Parcial',
    'owner_contract': 'Contrato del Propietario',
    'pay_amount': 'Pagar {{amount}}',
    'settled': 'Saldado',
    'no_installments': 'No se encontraron plazos.',
    'failed_to_load_installments': 'Error al cargar plazos',
    'payment_success_msg': '¡Pago exitoso! Gracias.',
    'payment_canceled_msg': 'Pago cancelado.',
    'error_connecting_payment': 'Error al conectar con el sistema de pago',

    // Owner Services
    'owner_service_charges': 'Cargos por Servicio',
    'owner_service_charges_subtitle': 'Visualiza y paga las cuotas de servicio facturadas a tus propiedades.',
    'owner_service_info': 'Los cargos por servicio son facturados por la administración del edificio. Por favor, paga los cargos pendientes con prontitud para evitar interrupciones en el servicio.',
    'outstanding_balance': 'Saldo Pendiente',
    'service_charge_paid': '¡Cargo por servicio pagado con éxito!',
    'paid_on': 'Pagado el {{date}}',
    'unpaid': 'No Pagado',

    // Owner Contracts
    'my_agreements': 'Mis Acuerdos',
    'agreements_subtitle': 'Revisa y firma tus contratos de gestión de propiedades.',
    'no_active_agreements': 'No Se Encontraron Acuerdos',
    'no_contracts_message': 'Actualmente no tienes contratos en nuestros registros. Contacta con tu administrador del edificio para obtener ayuda.',
    'management_agreement': 'Acuerdo de Gestión',
    'total_value': 'Valor Total',
    'remaining': 'Restante',
    'failed_to_load_agreements': 'Error al cargar acuerdos',

    // Shared Keys
    'rent': 'Alquiler',
    'download_pdf': 'Descargar PDF',
    'generating': 'Generando...',

    // Admin Announcements Manager
    'announcements_manager': 'Anuncios',
    'announcements_manager_subtitle': 'Publica y gestiona anuncios para inquilinos, propietarios o edificios específicos.',
    'new_announcement': 'Nuevo Anuncio',
    'publish_announcement': 'Publicar',
    'publishing': 'Publicando...',
    'all_announcements': 'Todos los Anuncios',
    'announcement_created': '¡Anuncio publicado con éxito!',
    'announcement_create_failed': 'Error al publicar el anuncio.',
    'announcement_deleted': 'Anuncio eliminado.',
    'announcement_delete_failed': 'Error al eliminar el anuncio.',
    'announcement_delete_confirm': '¿Eliminar este anuncio? Esto no se puede deshacer.',
    'announcement_fields_required': 'Se requiere un título y contenido.',
    'announcement_building_required': 'Por favor selecciona un edificio.',
    'announcement_title_placeholder': 'ej. Mantenimiento de agua programado para el Lunes',
    'announcement_content_placeholder': 'Escribe tu mensaje aquí...',
    'target_audience': 'Público Objetivo',
    'audience_all': 'Todos',
    'audience_tenants': 'Solo Inquilinos',
    'audience_owners': 'Solo Propietarios',
    'audience_building': 'Edificio Específico',
    'select_building': 'Seleccionar Edificio',
    'select_building_placeholder': '— elige un edificio —',
    'no_announcements_yet': 'Aún no hay anuncios',
    'no_announcements_yet_subtitle': 'Haz clic en "Nuevo Anuncio" para enviar tu primer mensaje.',
    'announcements_owner_subtitle': 'Mira las últimas noticias y actualizaciones de tu administrador de propiedades.',
    'announcements_check_back': 'Vuelve a revisar más tarde para ver noticias y actualizaciones de tu administrador de propiedades.',
    'posted_by': 'Publicado por {{name}}',

    // Management Fee Report
    'management_fee_report': 'Informe de Comisiones de Gestión',
    'management_fee_report_subtitle': 'Seguimiento de recaudación de plazos de propietarios y análisis de antigüedad',
    'ledger_activity_report': 'Informe de Actividad del Libro Mayor',
    'ledger_activity_report_subtitle': 'Todas las entradas del libro mayor — cargos, pagos, recargos por mora, créditos y depósitos',
    'ledger_type_charge':   'Cargo',
    'ledger_type_late_fee': 'Cargo por Mora',
    'ledger_type_deposit':  'Depósito',
    'ledger_type_payment':  'Pago',
    'ledger_type_credit':   'Crédito',
    'ledger_net_balance':   'Saldo Pendiente',

    // Feature lock
    'feature_locked': 'Función Bloqueada',
    'mgmt_fee_analytics_required': 'Los informes de Comisiones de Gestión requieren el plan de Análisis.',
    'upgrade': 'Actualizar',

    // Filters
    'year': 'Año',
    'month': 'Mes',
    'all_months': 'Todos los Meses',
    'all_owners': 'Todos los Propietarios',
    'all_statuses': 'Todos los Estados',
    'status_paid': 'Pagado',
    'status_pending_upcoming': 'Pendiente (próximo)',
    'status_overdue': 'Atrasado',
    'status_partial': 'Parcial',
    'status_cancelled_label': 'Cancelado',
    'clear_filters': 'Limpiar filtros',

    // Action buttons
    'print_pdf': 'Imprimir / PDF',
    'export_csv': 'Exportar CSV',
    'exporting': 'Exportando...',

    // KPI cards
    'total_expected': 'Total Esperado',
    'total_collected': 'Total Recaudado',
    'overdue_balance': 'Saldo Atrasado',
    'collection_rate': 'Tasa de Recaudación',
    'n_installments': '{{count}} plazos',
    'n_paid': '{{count}} pagados',
    'n_overdue_installments': '{{count}} plazos atrasados',
    'n_upcoming': '{{count}} próximos',

    // Monthly chart
    'monthly_breakdown': 'Desglose Mensual — {{year}}',
    'monthly_breakdown_filtered': 'Desglose Mensual — {{year}} (filtrado a {{month}})',
    'chart_expected': 'Esperado',
    'chart_collected': 'Recaudado',
    'chart_overdue': 'Atrasado',
    'no_installment_data_year': 'No hay datos de plazos para {{year}}',

    // Bar chart tooltips
    'tooltip_expected': 'Esperado:',
    'tooltip_collected': 'Recaudado:',
    'tooltip_overdue': 'Atrasado:',

    // All Installments table
    'all_installments': 'Todos los Plazos',
    'n_records': '{{count}} registro',
    'n_records_plural': '{{count}} registros',
    'page_of': 'página {{page}}/{{total}}',
    'no_installments_found': 'No se encontraron plazos',
    'try_adjusting_filters': 'Intenta ajustar tus filtros.',

    // Table column headers
    'col_owner': 'Propietario',
    'col_apt': 'Apt',
    'col_building': 'Edificio',
    'col_due_date': 'Fecha de Vencimiento',
    'col_amount': 'Monto',
    'col_paid': 'Pagado',
    'col_balance': 'Saldo',
    'col_status': 'Estado',
    'col_days_late': 'Días de Retraso',

    // Footer totals row
    'totals_all_pages': 'Totales (todas las páginas):',

    // Pagination
    'previous': '← Anterior',
    'next': 'Siguiente →',
    'page_x_of_y': 'Página {{page}} de {{total}} ({{count}} total)',

    // Aging / Overdue table
    'overdue_aging_title': 'Plazos Atrasados — Análisis de Antigüedad',
    'col_aging': 'Antigüedad',
    'all_installments_up_to_date': '¡Todos los plazos están al día!',
    'no_overdue_found': 'No se encontraron plazos de comisiones de gestión atrasados.',
    'total_overdue': 'Total Atrasado:',
    'n_days': '{{count}} días',

    // Aging bucket labels
    'aging_1_30': '1–30 días',
    'aging_31_60': '31–60 días',
    'aging_61_90': '61–90 días',
    'aging_90_plus': '90+ días',

    // Status badge labels
    'badge_paid': 'Pagado',
    'badge_partial': 'Parcial',
    'badge_pending': 'Pendiente',
    'badge_overdue': 'Atrasado',
    'badge_cancelled': 'Cancelado',

    // Failed / error
    'failed_to_load_mgmt_fee_report': 'Error al cargar el informe de comisiones de gestión',
    'export_failed': 'Error en la exportación',
    'export_downloaded_label': 'Descargado: {{label}}',

    // Report Templates
    'report_templates': 'Plantillas de Informes',
    'report_templates_subtitle': 'Crea y gestiona configuraciones de informes reutilizables',
    'create_template': 'Nueva Plantilla',
    'create_first_template': 'Crear Primera Plantilla',
    'template_name': 'Nombre de la Plantilla',
    'template_description': 'Descripción',
    'template_config': 'Configuración (JSON)',
    'no_templates': 'No hay Plantillas de Informes',
    'no_templates_message': 'Guarda tus configuraciones de informes usadas frecuentemente como plantillas reutilizables.',
    'template_created': 'Plantilla creada exitosamente',
    'template_updated': 'Plantilla actualizada exitosamente',
    'template_deleted': 'Plantilla eliminada',
    'delete_template_title': 'Eliminar Plantilla',
    'delete_template_message': '¿Estás seguro de que quieres eliminar "{{name}}"? Esta acción no se puede deshacer.',


    "insurance_tracking": "Seguimiento de Seguros",
    "insurance_desc": "Administrar pólizas de seguro de inquilinos, propietarios y edificios",
    "add_policy": "Agregar Póliza",
    "edit_policy": "Editar Póliza",
    "expiring_30d": "Vence en 30 días",
    "total_coverage": "Cobertura Total",
    "insurer": "Aseguradora",
    "insurer_name": "Nombre de la Aseguradora",
    "policy_number": "Número de Póliza",
    "policy_type": "Tipo de Póliza",
    "coverage_amount": "Monto de Cobertura",
    "annual_premium": "Prima Anual",
    "policy_added": "Póliza agregada",
    "policy_updated": "Póliza actualizada",
    "confirm_delete_policy": "¿Eliminar esta póliza?",
    "entity_type": "Tipo de Entidad",
    "entity_name": "Nombre de la Entidad",
    "no_policies_found": "No se encontraron pólizas",
    "add_first_policy": "Agregar Primera Póliza",
    "error_loading_insurance": "Error al cargar las pólizas de seguro",
    "renters_insurance": "Seguro de Inquilino",
    "renters_insurance_desc": "Seguimiento de cobertura, cumplimiento y fechas de vencimiento para todos los residentes",
    "audit_compliance": "Auditar Cumplimiento",
    "compliant": "Cumple",
    "non_compliant": "No Cumple",
    "expiring_soon": "Vence Pronto",
    "provider": "Proveedor",
    "expiration": "Vencimiento",
    "send_notice": "Enviar Aviso",
    "view_policy": "Ver Póliza",
    "no_insurance_records": "No se encontraron registros de seguro",
    "all_tenants_compliant_desc": "Todos los inquilinos cumplen actualmente",

    // Email Template Form
    'et_new_title': 'Nueva plantilla de correo',
    'et_edit_title': 'Editar plantilla de correo',
    'et_basic_info': 'Información básica',
    'et_template_name': 'Nombre de la plantilla *',
    'et_template_name_placeholder': 'ej. Recordatorio mensual de alquiler',
    'et_trigger_event': 'Evento desencadenador',
    'et_description': 'Descripción',
    'et_description_placeholder': 'Nota interna opcional',
    'et_subject_line': 'Línea de asunto *',
    'et_subject_placeholder': 'ej. Su alquiler de ${{rent_amount}} vence el {{due_date}}',
    'et_html_body': 'Cuerpo HTML',
    'et_editor': 'Editor',
    'et_preview': 'Vista previa',
    'et_quick_insert': 'Insertar variables rápidamente',
    'et_update_btn': 'Actualizar plantilla',
    'et_create_btn': 'Crear plantilla',
    'et_created': 'Plantilla creada',
    'et_updated': 'Plantilla actualizada',
    'et_failed_load': 'Error al cargar la plantilla',
    'et_save_failed': 'Error al guardar',
    'et_fields_required': 'El nombre, el asunto y el cuerpo son obligatorios',
    'issue_utility_bill': 'Emitir factura de servicios',
    'tenant_billing_assignment': 'Asignación de inquilino y facturación',
    'select_tenant': 'Seleccionar inquilino',
    'search_tenant_placeholder': 'Buscar por nombre o número de departamento...',
    'utility_details': 'Detalles de servicios',
    'period_month': 'Mes',
    'period_year': 'Año',
    'due_date': 'Fecha de vencimiento',
    'posting_options': 'Opciones de registro',
    'charge_immediately': 'Cargar al libro mayor inmediatamente',
    'charge_immediately_desc_on': 'El monto se registrará en el saldo del inquilino tan pronto como guarde.',
    'charge_immediately_desc_off': 'La factura se guardará como "Pendiente" y deberá cargarla manualmente más tarde.',
    'processing': 'Procesando...',
    'issue_and_charge': 'Emitir y cargar',
    'issue_bill': 'Emitir factura',
    'meter_identity_provider': 'Identidad del medidor y proveedor',
    'account_number': 'Número de cuenta',
    'meter_number': 'Número de medidor',
    'shared_meter_rubs': 'Medidor compartido (división RUBS)',
    'pricing_unit_measurement': 'Precios y unidad de medida',
    'rate_per_unit': 'Tarifa por unidad ($)',
    'unit_of_measure': 'Unidad de medida',
    'billing_day_monthly': 'Día de facturación (mensual)',
    'internal_notes': 'Notas internas',

    // Utility — edit / void / mark-paid
    'edit_utility_account': 'Editar cuenta de servicios',
    'void_bill': 'Anular factura',
    'void_reason': 'Motivo (opcional)',
    'void_reason_placeholder': 'p.ej. Error de facturación, duplicado...',
    'confirm_void_bill': 'Esta factura será anulada y no podrá ser cobrada.',
    'confirm_void_bill_sent': 'Esta factura ya fue cobrada. Se emitirá un crédito para revertir el cargo.',
    'bill_voided': 'Factura anulada',
    'bill_marked_paid': 'Factura marcada como pagada',
    'confirm_mark_paid': '¿Marcar esta factura como pagada (pago externo)?',
    'deactivate_utility_account': 'Desactivar cuenta',
    'confirm_deactivate_utility_account': '¿Está seguro de que desea desactivar esta cuenta de servicios?',
    'post_utility_charge': 'Registrar cargo de servicio',
    'account_updated': 'Cuenta actualizada exitosamente',
    'utility_bill': 'Factura de servicio',
    'tenant_info': 'Inquilino',
    'tenant_name_5': 'Nombre',
    'email_15': 'Correo electrónico',
    'reading_history': 'Historial de lecturas',
    'usage_breakdown': 'Desglose de consumo',
    'previous_reading': 'Lectura anterior',
    'current_reading': 'Lectura actual',
    'view_account': 'Ver cuenta de servicio',

    // Currency
    'currency_selector_label': 'Moneda de la organización',
    'currency_stripe_warning': 'Los pagos en línea a través de Stripe no están disponibles para esta moneda. Los inquilinos pagarán solo en persona.',
    'online_payment_unavailable': 'El pago en línea no está disponible para su moneda. Por favor pague en persona.',

    // --- HIGH-QUALITY MANUAL TRANSLATIONS ---
    'total_properties': 'Propiedades Totales',
    'active_properties': 'Propiedades Activas',
    'active_tenants': 'Inquilinos Activos',
    'monthly_revenue': 'Ingresos Mensuales',
    'pending_payments': 'Pagos Pendientes',
    'lease_expiring_soon': 'Contrato por expirar pronto',
    'payment_risk': 'Riesgo de Pago',
    'ai_scored_late_payment': 'Probabilidad de pago atrasado (IA)',
    'high_risk': 'Alto Riesgo',
    'medium_risk': 'Riesgo Medio',
    'low_risk': 'Bajo Riesgo',
    'no_scores_yet': 'No hay puntajes aún. Haz clic en actualizar.',
    'renewal_risk': 'Riesgo de Renovación',
    'leases_expiring_in_90_days': 'Contratos que expiran en 90 días',
    'exp_in_30d': 'Expira en 30d',
    'exp_in_90d': 'Expira en 90d',
    'no_leases_expiring_90d': 'No hay contratos que expiren en los próximos 90 días.',
    'leasing_office': 'Oficina de Arrendamiento',
    'marketing_links': 'Enlaces de Marketing',
    'bulk_import': 'Importación Masiva',
    'evictions': 'Desalojos',
    'accounting': 'Contabilidad',
    'payments': 'Pagos',
    'portfolio_kpis': 'Portafolio y KPIs',
    'bulk_comms': 'Mensaje Masivo',
    'email_templates': 'Plantillas de Correo',
    'building_view': 'Vista de Edificio',
    'failed_to_load_logs': 'Error al cargar los registros',
    'export_failed': 'Error al exportar registros',
    'all_user_activities_desc': 'Seguimiento de todas las acciones del sistema',
    'search_logs': 'Buscar registros...',
    'entries': 'entradas',
    'filter_activities': 'Filtrar Actividades',
    'action_type': 'Tipo de Acción',
    'all_actions': 'Todas las Acciones',
    'entity_type': 'Tipo de Entidad',
    'all_types': 'Todos los Tipos',
    'start_date': 'Fecha de Inicio',
    'end_date': 'Fecha de Fin',
    'reset': 'Restablecer',
    'apply_filter': 'Aplicar Filtro',
    'time': 'Hora',
    'user': 'Usuario',
    'action': 'Acción',
    'entity': 'Entidad',
    'details': 'Detalles',
    'amount': 'Monto',
    'no_logs_matching_search': 'No hay registros que coincidan.',
    'no_logs_available': 'No hay registros disponibles.',
    'showing_range': 'Mostrando {{start}} a {{end}} de {{total}}',
    'previous': 'Anterior',
    'next': 'Siguiente',
    'exporting': 'Exportando...',
    'export': 'Exportar',
    'filter': 'Filtrar',
    'activity_logs': 'Registros de Actividad',
    'invitation_only_onboarding': 'Registro solo por invitación',
    'approve_payment_msg': '¿Estás seguro de que deseas aprobar este pago?',
    'reject_payment_msg': 'Por favor, proporciona una razón para rechazar este pago.',
    'errors_serverError': 'Error interno del servidor',
    'timePeriods_month': 'Mes',
    'timePeriods_quarter': 'Trimestre',
    'timePeriods_year': 'Año',
    'common_startDate': 'Fecha de Inicio',
    'common_endDate': 'Fecha de Fin',
    'common_type': 'Tipo',
    'common_all': 'Todos',
    'common_tenant': 'Inquilino',

  
  
  
    // Auto-added translations
    'leases_expiring_90d': 'Arrendamientos que vencen 90d',
    'left': 'Izquierda',
    'view_all_renewal_risks': 'Ver todos los riesgos de renovación',
    're_run_ai_scoring': 'Volver a ejecutar la puntuación de Ai',
    'medium': 'Medio',
    'owed': 'adeudado',
    'view_all_risk_scores': 'Ver todas las puntuaciones de riesgo',
    'at_12_pm': 'a las 12 pm',
    'unpaid_balance': 'Saldo impago',
    'lease_period': 'Período de arrendamiento',
    'view_record': 'Ver registro',
    'apartment_created_successfully': 'Apartamento creado con éxito',
    'apartment_updated_successfully': 'Apartamento actualizado con éxito',
    'manage_your_properties': 'Administre sus propiedades',
    'filter_apartments': 'Filtrar apartamentos',
    'no_matching_apartments_message': 'No hay mensajes de apartamentos coincidentes',
    'furnished_apartment': 'Apartamento amueblado',
    'manage': 'Administrar',
    'delete_apartment': 'Eliminar Apartamento',
    'select_at_least_one_floor': 'Seleccione al menos un piso',
    'add_at_least_one_unit_type': 'Agregue al menos un tipo de unidad',
    'apartments_created': 'Apartamentos creados',
    'skipped_duplicates': 'Duplicados omitidos',
    'apartments_created_successfully': 'Apartamentos creados con éxito',
    'error_creating_apartments': 'Error al crear apartamentos',
    'select_floors': 'Seleccionar pisos',
    'clear': 'Borrar',
    'qty_per_floor': 'Cantidad por piso',
    'units_per_floor': 'Unidades por piso',
    'select_floors_and_types': 'Seleccione pisos y tipos',
    'future_tenant_only': 'Solo futuro inquilino',
    'converted': 'Convertido',
    'confirmed': 'Confirmado',
    'hold': 'Espera',
    'failed_confirm_booking': 'Error al confirmar la reserva',
    'failed_cancel_booking': 'Error al cancelar la reserva',
    'failed_convert_tenant': 'Error al convertir inquilino',
    'converted_to_tenant': 'Convertido a inquilino',
    'cancellation_reason': 'Motivo de cancelación',
    'hold_expired': 'Retener caducado',
    'cancel_booking_question': 'Cancelar pregunta de reserva',
    'yes_cancel': 'Sí Cancelar',
    'keep_it': 'Guárdalo',
    'booking_created': 'Reserva creada',
    'failed_save_booking': 'No se ha podido guardar la reserva',
    'building_created_successfully': 'Edificio creado con éxito',
    'building_updated_successfully': 'Edificio actualizado exitosamente',
    'bulk_add': 'Agregar en masa',
    'total_buildings': 'Edificios totales',
    'avg_occupancy': 'Ocupación promedio',
    'building_has_no_apartments': 'El edificio no tiene apartamentos',
    'add_apartments_hint': 'Agregar sugerencia de apartamentos',
    'due': 'debido',
    'description': 'Descripción',
    'next_7_days': 'Los próximos 7 días',
    'next_14_days': 'Próximos 14 días',
    'next_30_days': 'Próximos 30 días',
    'view_arrow': 'Ver flecha',
    'search_unit_tenant': 'Buscar inquilino de unidad',
    'no_results_for_filters': 'No hay resultados para filtros',
    'charged': 'cargado',
    'bank': 'banco',
    'cheque': 'comprobar',
    'stripe': 'raya',
    'failed_to_load_revenue': 'No se pudieron cargar los ingresos',
    'no_tenant_logs': 'Sin registros de inquilinos',
    'payment_record_error': 'Error de registro de pago',
    'contract_not_found': 'Contrato no encontrado',
    'back_to_owner': 'Volver al propietario',
    'contract_id': 'Identificación del contrato',
    'summary_info': 'Información resumida',
    'n_a': 'n.a.',
    'paid_progress': 'Progreso pagado',
    'total_installments': 'Cuotas totales',
    'paid_installments': 'Cuotas pagadas',
    'pending_installments': 'Cuotas pendientes',
    'legal_document': 'Documento Legal',
    'signatures': 'Firmas',
    'owner_signature': 'Firma del propietario',
    'awaiting_owner_signature': 'En espera de la firma del propietario',
    'admin_signature': 'Firma del administrador',
    'awaiting_admin_signature': 'En espera de la firma del administrador',
    'paid_amount': 'Monto pagado',
    'save_payment': 'Guardar pago',
    'language': 'Idioma',
    'exportPDF': 'Exportar PDF',
    'print': 'Imprimir',
    'receiptNo': 'Número de recibo',
    'contractDetails': 'Detalles del contrato',
    'contractNo': 'Número de contrato',
    'contractType': 'Tipo de contrato',
    'startDate': 'Fecha de inicio',
    'endDate': 'Fecha de finalización',
    'openEnded': 'Abierto',
    'financialSummary': 'Resumen financiero',
    'totalValue': 'Valor total',
    'totalPaid': 'Total pagado',
    'balanceDue': 'Saldo adeudado',
    'installmentSchedule': 'Calendario de pagos',
    'dueDate': 'Fecha de vencimiento',
    'paidAmt': 'Importe pagado',
    'paymentDate': 'Fecha de pago',
    'paidWatermark': 'Marca de agua pagada',
    'paymentDetails': 'Detalles de pago',
    'installmentNo': 'Número de cuota',
    'amountDue': 'Monto adeudado',
    'amountPaid': 'Monto pagado',
    'paymentStatus': 'Estado de pago',
    'paymentConfirmed': 'Pago confirmado',
    'awaitingPayment': 'En espera de pago',
    'balanceRemaining': 'Saldo restante',
    'authorizedSig': 'Firma autorizada',
    'ownerSig': 'Firma del propietario',
    'generatedBy': 'Generado por',
    'informationalOnly': 'Sólo informativo',
    'failed_to_load_owner_data': 'No se pudieron cargar los datos del propietario',
    'sending': 'Enviando',
    'payment_reminder_message': 'Mensaje de recordatorio de pago',
    'reminder_sent_success': 'Recordatorio enviado correctamente',
    'failed_to_send_reminder': 'No se pudo enviar el recordatorio',
    'owner_has_no_email': 'El propietario no tiene correo electrónico',
    'portal_invitation_sent_successfully': 'La invitación al portal se envió correctamente',
    'failed_to_send_portal_invite': 'No se pudo enviar la invitación al portal',
    'owner_not_found': 'Propietario no encontrado',
    'total_income': 'Ingresos totales',
    'residence': 'Residencia',
    'does_not_live_on_property': 'No vive en la propiedad',
    'outstanding_fees_note': 'Nota de tarifas pendientes',
    'pending_signature': 'Firma pendiente',
    'fully_executed': 'Completamente ejecutado',
    'error_loading_financials': 'Error al cargar las finanzas',
    'due_soon': 'Vencimiento pronto',
    'owner_updated_successfully': 'Propietario actualizado exitosamente',
    'invitation_sent': 'Invitación enviada',
    'invitation_failed': 'Invitación fallida',
    'owner_created_successfully': 'Propietario creado con éxito',
    'preferred_language': 'Idioma preferido',
    'drop_here': 'Caer aquí',
    'failed_to_load_owners_data': 'No se pudieron cargar los datos de los propietarios',
    'connection_error': 'Error de conexión',
    'failed_to_delete_owner': 'No se pudo eliminar el propietario',
    'failed_to_delete_owners': 'No se pudieron eliminar los propietarios',
    'edit_owner': 'Editar propietario',
    'delete_owner': 'Eliminar propietario',
    'occupied_lowercase': 'Minúsculas ocupadas',
    'confirm_bulk_delete_title': 'Confirmar eliminación masiva del título',
    'refresh_owners': 'Actualizar propietarios',
    'delete_selected_owners': 'Eliminar propietarios seleccionados',
    'export_to_pdf': 'Exportar a PDF',
    'print_owners': 'Propietarios de impresión',
    'min_zero': 'Mínimo cero',
    'count_formatted': 'Contar formateado',
    'invalid_plan_selected': 'Plan seleccionado no válido',
    'could_not_start_checkout': 'No se pudo iniciar el pago',
    'checkout_failed': 'Pago fallido',
    'could_not_open_portal': 'No se pudo abrir el portal',
    'failed_to_open_portal': 'No se pudo abrir el portal',
    'payment_approved_success': 'Pago aprobado con éxito',
    'failed_to_approve_payment': 'No se pudo aprobar el pago',
    'provide_rejection_reason': 'Proporcionar motivo de rechazo',
    'payment_rejected': 'Pago rechazado',
    'failed_to_reject_payment': 'No se pudo rechazar el pago',
    'stripe_connected': 'Raya conectada',
    'redirecting': 'Redireccionando',
    'approve_payment': 'Aprobar pago',
    'reject_payment': 'Rechazar pago',
    'errors.serverError': 'Error del servidor',
    'export_excel': 'Exportar Excel',
    'timePeriods.month': 'Mes',
    'timePeriods.quarter': 'Cuarto',
    'timePeriods.year': 'Año',
    'common.startDate': 'Fecha de inicio',
    'common.endDate': 'Fecha de finalización',
    'common.type': 'Tipo',
    'common.all': 'Todos',
    'common.tenant': 'inquilino',
    'common.searchTenant': 'Buscar inquilino',
    'ledgerReport.netBalance': 'Saldo Neto',
    'ledgerReport.entries': 'Entradas',
    'common.noData': 'Sin datos',
    'common.date': 'Fecha',
    'common.building': 'edificio',
    'common.apartment': 'Apartamento',
    'common.description': 'Descripción',
    'common.amount': 'Cantidad',
    'ledgerReport.balanceAfter': 'Saldo después',
    'ledgerReport.createdBy': 'Creado por',
    'common.page': 'Página',
    'metric': 'Métrica',
    'value': 'Valor',
    'failed_to_export': 'No se pudo exportar',
    'select_date_range': 'Seleccionar rango de fechas',
    'revenue_deep_dive_restricted': 'Análisis profundo de ingresos restringido',
    'showing_building_revenue': 'Mostrando los ingresos del edificio',
    'showing_owner_revenue': 'Mostrando los ingresos del propietario',
    'showing_monthly_revenue': 'Mostrando ingresos mensuales',
    'receiptTitle': 'Título del recibo',
    'receiptDate': 'Fecha de recepción',
    'residentName': 'Nombre del residente',
    'servicePeriod': 'Período de servicio',
    'signature': 'Firma',
    'responsible': 'Responsable',
    'thankYou': 'gracias',
    'invalid_amount': 'Cantidad no válida',
    'payment_generated_successfully': 'Pago generado exitosamente',
    'failed_to_generate_payment': 'No se pudo generar el pago',
    'no_owner': 'Sin propietario',
    'rented': 'Alquilado',
    'payer': 'Pagador',
    'failed_to_load_service_data': 'No se pudieron cargar los datos del servicio',
    'records': 'Registros',
    'no_matching_payments_found': 'No se encontraron pagos coincidentes',
    'paid_count': 'Recuento pagado',
    'unpaid_count': 'Recuento impago',
    'no_data_to_export': 'No hay datos para exportar',
    'export_successful': 'Exportación exitosa',
    'months_with_data': 'Meses con datos',
    'data_refreshed_successfully': 'Datos actualizados exitosamente',
    'payment_marked_as_paid': 'Pago marcado como pagado exitosamente',
    'payment_marked_as_unpaid': 'Pago marcado como no pagado exitosamente',
    'rented': 'Alquilado',
    'service_charge_deleted': 'Cargo de servicio eliminado exitosamente',
    'failed_to_delete_service_charge': 'Error al eliminar el cargo de servicio',
    'service_payment_note_default': 'Pago de servicio para {{month}} {{year}}',
    'failed_init_stripe': 'Franja de inicio fallida',
    'refresh_status': 'Actualizar estado',
    'failed_to_load_user_data': 'No se pudieron cargar los datos del usuario',
    'error_updating_profile': 'Error al actualizar el perfil',
    'error_updating_password': 'Error al actualizar la contraseña',
    'failed_to_load_system_data': 'No se pudieron cargar los datos del sistema',
    'logo_upload_success': 'Carga exitosa del logotipo',
    'error_from_server': 'Error del servidor',
    'error_uploading_logo': 'Error al cargar el logotipo',
    'error_updating_system_settings': 'Error al actualizar la configuración del sistema',
    'contact_email': 'Correo electrónico de contacto',
    'contact_phone': 'Teléfono de contacto',
    'office_address': 'Dirección de la oficina',
    'organization_logo': 'Logotipo de la organización',
    'nameLabel': 'Etiqueta de nombre',
    'floorPre': 'Pre-piso',
    'aptPre': 'Apto Pre',
    'periodLabel': 'Etiqueta de período',
    'officeCommission': 'Comisión de oficina',
    'invalid_date': 'Fecha no válida',
    'tenant_has_no_email': 'El inquilino no tiene correo electrónico',
    'portal_invitation_failed': 'Error en la invitación al portal',
    'lease_extended_success': 'Arrendamiento extendido exitoso',
    'failed_to_extend_lease': 'No se pudo extender el contrato de arrendamiento',
    'lease_renewed_success': 'Arrendamiento renovado con éxito',
    'failed_to_renew_lease': 'No se pudo renovar el contrato de arrendamiento',
    'ending_lease': 'Fin del contrato de arrendamiento',
    'no_additional_fees': 'Sin cargos adicionales',
    'electronic_signature': 'Firma Electrónica',
    'no_maintenance_requests_message': 'No hay mensaje de solicitudes de mantenimiento',
    'add_first_request': 'Agregar primera solicitud',
    'extending': 'Extendiendo',
    'renewing': 'Renovando',
    'tenant_updated_successfully': 'Inquilino actualizado correctamente',
    'tenant_created_successfully': 'Inquilino creado exitosamente',
    'no_phone': 'Sin teléfono',
    'not_assigned': 'No asignado',
    'financial_details': 'Detalles financieros',
    'more_info': 'Más información',
    'apartment_specs': 'Especificaciones del apartamento',
    'user_created_email_failed': 'El correo electrónico creado por el usuario falló',
    'user_created_email_failed_2': 'El correo electrónico creado por el usuario falló 2',
    'invitation_email_could_not_be_sent': 'No se pudo enviar el correo electrónico de invitación',
    'user_created_email_failed_3': 'El correo electrónico creado por el usuario falló 3',
    'manual_onboarding_link': 'Enlace de incorporación manual',
    'manual_onboarding_desc': 'Descripción de incorporación manual',
    'link_copied_to_clipboard': 'Enlace copiado al portapapeles',
    'copy_link': 'Copiar enlace',
    'add_another_user': 'Agregar otro usuario',
    'invitation_only_onboarding_desc': 'Descripción de incorporación solo por invitación',
    'hide_inactive_users': 'Ocultar usuarios inactivos',
    'show_inactive_users': 'Mostrar usuarios inactivos',
    'error_loading_users': 'Error al cargar usuarios',
    'no_users_message': 'Ningún mensaje de usuario',
    'create_first_user': 'Crear primer usuario',
    'rent_reminder': 'Recordatorio de alquiler',
    'enable_rent_reminders': 'Habilitar recordatorios de alquiler',
    'request_failed': 'Solicitud fallida',
    'send_test': 'Enviar prueba',
    'failed_load_notification_settings': 'Configuración de notificación de carga fallida',
    'settings_save_failed': 'Error al guardar la configuración',
    'preview_failed': 'Error en la vista previa',
    'reminders_sent': 'Recordatorios enviados',
    'notification_settings': 'Configuración de notificaciones',
    'notification_settings_desc': 'Descripción de configuración de notificaciones',
    'loading_units': 'Unidades de carga',
    'listed_rent': 'Alquiler listado',
    'portfolio_occupancy': 'Ocupación de la cartera',
    'avg_renewal_increase': 'Aumento promedio de renovación',
    'title': 'Título',
    'content': 'Contenido',
    'marketing_links_desc': 'Descripción de enlaces de marketing',
    'download_failed': 'Descarga fallida',
    'run_report': 'Ejecutar informe',
    'downloading': 'Descargando',
    'total_ar': 'Ar total',
    'total_balance': 'Saldo Total',
    'no_outstanding_balances_found': 'No se encontraron saldos pendientes',
    'totals': 'Totales',
    'subject_body_required': 'Cuerpo del asunto requerido',
    'no_active_tenants': 'Sin inquilinos activos',
    'confirm_send_bulk': 'Confirmar envío masivo',
    'message_sent_to_tenants': 'Mensaje enviado a los inquilinos',
    'bulk_communications': 'Comunicaciones masivas',
    'message_sent_successfully': 'Mensaje enviado exitosamente',
    'in_app_announcement': 'Anuncio en la aplicación',
    'dismiss': 'Descartar',
    'target_building': 'Construcción de objetivos',
    'all_buildings_count': 'Todos los edificios cuentan',
    'compose_message': 'Redactar mensaje',
    'subject': 'Asunto',
    'message_body': 'Cuerpo del mensaje',
    'markdown_hint': 'Sugerencia de rebajas',
    'characters': 'Personajes',
    'delivery_channels': 'Canales de entrega',
    'email_blast': 'Explosión de correo electrónico',
    'send_to_tenants': 'Enviar a inquilinos',
    'bulk_guidelines': 'Pautas masivas',
    'in_app_announcements': 'Anuncios en la aplicación',
    'in_app_desc': 'En la descripción de la aplicación',
    'email_blasts': 'Explosiones de correo electrónico',
    'email_blast_desc': 'Descripción de la explosión de correo electrónico',
    'send_immediate_desc': 'Enviar descripción inmediata',
    'professional_desc': 'Descripción profesional',
    'owner_balances': 'Saldos del propietario',
    'deselect_all': 'Deseleccionar todo',
    'select_all': 'Seleccionar todo',
    'notes_optional': 'Notas Opcional',
    'confirm_bulk_payout_title': 'Confirmar pago masivo',
    'error_loading_churn_data': 'Error al cargar datos de abandono',
    'running_scoring': 'Puntuación de carrera',
    'scored_tenants': 'Inquilinos puntuados',
    'scoring_failed': 'Puntuación fallida',
    'vendor_dashboard_subtitle': 'Subtítulo del panel de proveedores',
    'view_your_work_orders': 'Ver sus órdenes de trabajo',
    'confirm_replace_content': 'Confirmar Reemplazar contenido',
    'applied_template': 'Plantilla aplicada',
    'templates': 'Plantillas',
    'editor': 'Redactor',
    'desktop': 'Escritorio',
    'mobile': 'Móvil',
    'realistic_sample_data': 'Datos de muestra realistas',
    'template_logic': 'Lógica de plantilla',
    'event_trigger_desc': 'Descripción del activador de evento',
    'admin_only': 'Sólo administrador',
    'click_to_insert': 'Haga clic para insertar',
    'body': 'cuerpo',
    'template_deactivated': 'Plantilla desactivada',
    'failed_to_deactivate': 'No se pudo desactivar',
    'enter_test_email': 'Ingrese el correo electrónico de prueba',
    'test_email_sent_to': 'Correo electrónico de prueba enviado a',
    'failed_to_send_test': 'No se pudo enviar la prueba',
    'active_templates_count': 'Recuento de plantillas activas',
    'send_test_email': 'Enviar correo electrónico de prueba',
    'save_failed': 'Error al guardar',
    'description_required': 'Descripción requerida',
    'post_failed': 'Publicación fallida',
    'code': 'Código',
    'create_account': 'Crear cuenta',
    'apply': 'Aplicar',
    'account': 'cuenta',
    'debit': 'Débito',
    'credit': 'Crédito',
    'lines': 'Líneas',
    'hide': 'Ocultar',
    'reverse': 'revertir',
    'run': 'correr',
    'total_debits': 'Débitos totales',
    'total_credits': 'Créditos totales',
    'journal_entry': 'Entrada de diario',
    'building_id_label': 'Etiqueta de identificación del edificio',
    'units_count': 'Recuento de unidades',
    'enable_in_settings': 'Habilitar en configuración',
    'unit_label': 'Etiqueta de unidad',
    'no_messages_yet': 'Aún no hay mensajes',
    'failed_to_load_notification_log': 'No se pudo cargar el registro de notificaciones',
    'no_notifications_found': 'No se encontraron notificaciones',
    'channel': 'canal',
    'recipient': 'Destinatario',
    'discount_rent': 'Alquiler con descuento',
    'lease_start': 'Inicio del arrendamiento',
    'lease_end': 'Fin del arrendamiento',
    'next_bill': 'Próxima factura',
    'no_units_found': 'No se encontraron unidades',
    'csv_download_failed': 'Error al descargar CSV',
    'all_1099_downloaded': 'Todos los 1099 descargados',
    'no_reportable_owners': 'No hay propietarios reportables',
    'pdf_download_failed': 'Error al descargar el PDF',
    'pdf_generation_failed': 'Error al generar el PDF',
    'generating_pdfs': 'Generando archivos PDF',
    'download_all_pdfs': 'Descargar todos los PDF',
    'important': 'importante',
    'irs_1099_disclaimer': 'Irs 1099 Descargo de responsabilidad',
    'owner_payment_summary': 'Resumen de pago del propietario',
    'irs_threshold': 'Umbral de Irs',
    'total_paid': 'Total pagado',
    'form': 'Formulario',
    'file_form': 'Formulario de archivo',
    'no_owner_payments_found': 'No se encontraron pagos del propietario',
    'no_deposits_found': 'No se encontraron depósitos',
    'deposit_amount': 'Monto del depósito',
    'deductions': 'Deducciones',
    'error_loading_showing': 'Error al cargar mostrando',
    'required_fields_error': 'Error de campos obligatorios',
    'showing_updated': 'Mostrando actualizado',
    'showing_scheduled': 'Mostrando programado',
    'time_conflict_error': 'Error de conflicto de tiempo',
    'choose_unit': 'Elija unidad',
    'agent_name_placeholder': 'Marcador de posición del nombre del agente',
    'schedule': 'Horario',
    'error_loading_showings': 'Error al cargar proyecciones',
    'marked_as': 'Marcado como',
    'update_failed': 'Actualización fallida',
    'delete_failed': 'Eliminación fallida',
    'mark_completed': 'Marcar completado',
    'mark_no_show': 'Marcar como no presentado',
    'confirm_delete': 'Confirmar eliminación',
    'confirm_delete_showing': 'Confirmar Eliminar Mostrando',
    'error_loading_surveys': 'Error al cargar encuestas',
    'from_responses': 'De las respuestas',
    'no_data_yet': 'Aún no hay datos',
    'utility_type_required': 'Tipo de utilidad requerida',
    'failed_to_create_account': 'No se pudo crear la cuenta',
    'select_tenant_error': 'Error de selección de inquilino',
    'please_fix_errors': 'Por favor corrija los errores',
    'bill_issued_successfully': 'Factura emitida exitosamente',
    'failed_to_issue_bill': 'No se pudo emitir la factura',
    'download_csv': 'Descargar CSV',
    'vendor_1099_disclaimer': 'Descargo de responsabilidad del proveedor 1099',
    'vendor': 'vendedor',
    'first_payment': 'Primer Pago',
    'last_payment': 'Último pago',
    'no_vendor_payments_recorded': 'No se registraron pagos a proveedores',
    'ok_200': 'vale 200',
    'failed_load_webhooks': 'Error al cargar webhooks',
    'failed_load_deliveries': 'Entregas de carga fallidas',
    'failed_update': 'Actualización fallida',
    'delete_webhook_confirm': 'Eliminar webhook Confirmar',
    'failed_delete': 'Eliminación fallida',
    'rotate_secret_confirm': 'Girar Secreto Confirmar',
    'secret_rotated': 'secreto girado',
    'failed_rotate': 'Rotación fallida',
    'copied_to_clipboard': 'Copiado al portapapeles',
    'add_endpoint': 'Agregar punto final',
    'no_webhooks_yet': 'Aún no hay webhooks',
    'no_webhooks_desc': 'Sin descripción de Webhooks',
    'failures': 'Fallos',
    'disable': 'Desactivar',
    'enable': 'Habilitar',
    'rotate_secret': 'Girar secreto',
    'no_deliveries_yet': 'Aún no hay entregas',
    'event': 'Evento',
    'http': 'http',
    'account_deactivated': 'Cuenta desactivada',
    'server_no_response': 'Servidor sin respuesta',
    'logging_in': 'Iniciar sesión',
    'company_name_required': 'Nombre de la empresa requerido',
    'registration_failed': 'Registro fallido',
    'enter_company_name': 'Introduzca el nombre de la empresa',
    'fully_signed_active': 'Totalmente firmado activo',
    'pending_owner_signature': 'Firma del propietario pendiente',
    'pending_admin_signature': 'Firma del administrador pendiente',
    'terminated': 'Terminado',
    'back_to_contracts': 'Volver a Contratos',
    'contract_terms': 'Términos del contrato',
    'payment_schedule': 'Calendario de pagos',
    'no_installments_defined': 'No hay cuotas definidas',
    'signed_by': 'Firmado por',
    'awaiting_admin_review': 'En espera de revisión del administrador',
    'sign_contract': 'firmar contrato',
    'past': 'Pasado',
    'tenant_signin_success': 'Inicio de sesión exitoso del inquilino',

    // Auto-added mass translations from ESLint Codemod
    '10': '10 /',
    '12': '/ 12',
    '16': '−16%',
    '25': '25 /',
    '50': '50 /',
    '100': '100 /',
    '600': ': $600',
    'ai_assistant_pro_only': 'Asistente de IA: solo Pro',
    'ask_questions_about_your_portfolio_in_pl': 'Haga preguntas sobre su portafolio en un inglés sencillo. Obtenga respuestas instantáneas sobre ingresos, pagos vencidos, vacantes y más.',
    'upgrade_to_pro': 'Actualízate a Pro',
    'here_s_what_s_happening_across_your_port': 'Esto es lo que está sucediendo hoy en su cartera.',
    'portfolio_risk': 'Riesgo de cartera',
    'pro_only': 'Sólo profesional',
    'pending_collections': 'Cobros pendientes',
    'ask_ai_assistant': 'Pregúntele al asistente de IA',
    'unlock_ai_assistant_upgrade_to_pro': 'Desbloquear AI Assistant: actualizar a Pro',
    'download': 'Descargar',
    'd': 're',
    'view_details_1': 'Ver detalles',
    'export_data': 'Exportar datos',
    'refresh_data': 'Actualizar datos',
    'property_pulse': 'Pulso de propiedad',
    'cash_flow_analysis_for_the_current_fisca': 'Análisis de flujo de caja para el año fiscal en curso',
    'yearly_report': 'Informe Anual',
    'analytics_pro_required': 'Se requiere análisis profesional',
    'unlock_deep_financial_insights_and_custo': 'Desbloquee conocimientos financieros profundos e informes de pronóstico personalizados.',
    'upgrade_now': 'Actualiza ahora',
    'items_requiring_immediate_follow_up': 'Artículos que requieren seguimiento inmediato',
    'activity_log': 'Registro de actividad',
    'view_history': 'Ver historial',
    'no_recent_logs_found': 'No se encontraron registros recientes',
    'active_issues': 'Problemas activos',
    'pro': 'profesional',
    'pro_1': 'profesional',
    'sell_unit': 'Vender Unidad',
    'floor_1': 'piso',
    'size_1': 'Tamaño',
    'm': 'm²',
    'amenities': 'Servicios',
    'last_updated_today': 'Última actualización: hoy',
    'back_to_apartment': 'Volver al apartamento',
    'sell_unit_1': 'Vender Unidad',
    'floor_2': 'piso',
    'select_buyer': 'Seleccionar comprador',
    'existing_owner': 'Propietario existente',
    'new_buyer': 'Nuevo comprador',
    'no_owners_found_switch_to_new_buyer_to_c': 'No se encontraron propietarios: cambie a "Nuevo comprador" para crear uno',
    'edit_1': 'Editar',
    'the_buyer_will_be_created_as_an_owner_an': 'El comprador será creado como propietario y vinculado a esta venta automáticamente.',
    'sale_terms': 'Condiciones de venta',
    'total_sale_price': 'Precio total de venta *',
    'down_payment': 'Pago inicial',
    'annual_interest_rate': 'Tasa de interés anual (%)',
    'term_months': 'Plazo (meses) *',
    'yrs': 'años)',
    'sale_start_date': 'Fecha de venta / inicio *',
    'quick_preview': 'Vista previa rápida',
    'principal': 'Director',
    'down_payment_1': 'Pago inicial',
    'term': 'Término',
    'months_1': 'meses',
    'amortization_schedule': 'Calendario de amortización',
    'confirm_sale': 'Confirmar venta',
    'buyer': 'Comprador',
    'floor_3': '— Piso',
    'financial_terms': 'Términos financieros',
    'draft_sale_contract': 'borrador de contrato de venta',
    'will_be_created_the_apartment_will_be_ma': 'será creado. El apartamento quedará marcado como',
    'sold': 'Vendido',
    'only_after_both_you_and_the_buyer_digita': 'solo después de que tanto usted como el comprador firmen digitalmente el contrato.',
    'sale_finalized': '¡Venta finalizada!',
    'the_sale_contract_for_unit': 'El contrato de venta de la Unidad',
    'has_been_created_use_the_links_below_to': 'ha sido creado. Utilice los enlaces a continuación para incorporar al comprador.',
    'public_sign_link': 'Enlace de señal pública',
    'p_sign_owner': '/p/firma/propietario/',
    'portal_invite_link': 'Enlace de invitación al portal',
    'portal_setup_password_type_owner_id': '/portal/setup-contraseña?type=propietario&id=',
    'email_1': '&correo electrónico=',
    'token': '&token=',
    'view_owner': 'Ver propietario',
    'manage_contract': 'Gestionar contrato',
    '0_10': '(0-10,',
    'm_1': 'm²',
    'm_2': 'm²',
    'm_3': 'm²',
    'm_4': 'm²',
    'empty_key': '✕',
    'this_apartment_already_has': 'Este apartamento ya tiene',
    'active_booking_s_for_these_dates': 'reserva(s) activa(s) para estas fechas.',
    'levels': 'Niveles',
    'cap': 'gorra',
    'no_inventory_data': 'Sin datos de inventario',
    'init_units': 'Unidades iniciales',
    'm_5': 'm²',
    'm_6': 'm²',
    'supports_markdown_placeholders_e_g': 'Admite MarkDown y marcadores de posición, p.',
    'empty_key_1': '✓',
    'trial_ends_in': 'El juicio termina en',
    'days_subscribe': 'días - Suscríbete',
    'new_lease_agreement': 'Nuevo contrato de arrendamiento',
    'tenant_unit_assignment': 'Asignación de inquilinos y unidades',
    'please_select_a_building_first': 'Por favor seleccione un edificio primero',
    'lease_terms_duration': 'Términos y duración del arrendamiento',
    'lease_type': 'Tipo de arrendamiento',
    'fixed_term': 'Plazo fijo',
    'month_to_month': 'Mes a mes',
    'end_date_optional': 'Fecha de finalización (opcional)',
    'financial_obligations': 'Obligaciones financieras',
    'empty_key_2': ') *',
    'notes_special_provisions': 'Notas / Disposiciones Especiales',
    'empty_key_3': ': #',
    'send_for_signature': 'Enviar para firma',
    'copy_sign_link': 'Copiar enlace de firma',
    'download_contract_pdf': 'Descargar Contrato PDF',
    'contract_summary': 'Resumen del contrato',
    'generated_from_template': 'Generado a partir de plantilla:',
    'digitally_executed': 'Ejecutado digitalmente',
    'electronic_signatures': 'Firmas Electrónicas',
    'management_office': 'Oficina de Gestión',
    'authorized_signature': 'Firma autorizada',
    'owner_landlord': 'Propietario / Propietario',
    'email_2': 'Correo electrónico:',
    'signed': 'Firmado:',
    'ip': 'IP:',
    'reason_for_voiding': 'Razón para anular',
    'building_agreement_for': 'Acuerdo de construcción para',
    'contract_builder_rules': 'Reglas del constructor de contratos',
    'select_contract_template': 'Seleccionar plantilla de contrato',
    'no_template_manual_mode': 'Sin plantilla (modo manual)',
    'template_dynamic_variables': 'Variables dinámicas de plantilla',
    'owner_default_commission': 'Comisión por defecto del propietario:',
    'maintenance_threshold': 'Umbral de mantenimiento:',
    'unit_1': 'Unidad',
    'sale_unit_purchase': 'Venta / Compra Unitaria',
    'fixed_maintenance_contract': 'Contrato de mantenimiento fijo',
    'lease_agreement': 'Contrato de arrendamiento',
    'start_date_1': 'Fecha de inicio',
    'auto_generate_quarterly': 'Generación automática trimestral',
    'add_custom_installment': 'Agregar cuota personalizada',
    'plan_total': 'Total del plan',
    'agreement': 'Acuerdo',
    'copy_portal_link': 'Copiar enlace del portal',
    'ledger': 'Libro mayor',
    'empty_key_4': ') â†’',
    'owner_documents': 'Documentos del propietario',
    'add_document': 'Agregar documento',
    'name_1': 'Nombre *',
    'tax': 'Impuesto',
    'file_url': 'URL del archivo *',
    'cancel_1': 'Cancelar',
    'no_documents_yet': 'Aún no hay documentos',
    '30_days': '(30 días)',
    'view_1': 'Ver',
    'future_scheduled_installments': 'futuras cuotas programadas',
    'unit_2': ', Unidad',
    'no_investment_data_available_add_purchas': 'No hay datos de inversión disponibles. Agregue el precio de compra y el valor actual a los apartamentos para ver las métricas.',
    'click_the_edit_icon_on_any_unit_to_updat': 'Haga clic en el ícono de edición en cualquier unidad para actualizar su valor de mercado actual o precio de compra.',
    'unit_3': 'Unidad',
    'unit_mo': '/unidad/mes',
    'save_16_billed_annually': 'Ahorre 16% · facturado anualmente',
    'reason_for_rejection': 'Motivo del rechazo',
    'of_1': 'de',
    'error_loading_receipt': 'Error al cargar el recibo',
    'go_back': 'Volver',
    'receipt_not_found': 'Recibo no encontrado',
    'the_requested_payment_receipt_could_not': 'No se pudo encontrar el recibo de pago solicitado.',
    'go_back_1': 'Volver',
    'payment_receipt': 'Recibo de pago',
    'issue_date': 'Fecha de emisión:',
    'from_1': 'De',
    'phone_1': 'Teléfono:',
    'to_1': 'a',
    'phone_2': 'Teléfono:',
    'amount_1': 'Cantidad',
    'notes_1': 'Notas',
    'thank_you_for_your_payment': '¡Gracias por tu pago!',
    'this_receipt_was_generated_automatically': 'Este recibo se generó automáticamente.',
    'delete_template': 'Eliminar plantilla',
    'cancel_2': 'Cancelar',
    'delete_1': 'Eliminar',
    'description_optional': 'Descripción (opcional)',
    'report_type': 'Tipo de informe',
    'choosing_a_report_type_shows_the_relevan': 'Al elegir un tipo de informe, se muestran los filtros relevantes a continuación.',
    'saved_filters': 'Filtros guardados',
    'select_a_report_type_above_to_set_saved': 'Seleccione un tipo de informe arriba para establecer valores de filtro guardados para esta plantilla.',
    'cancel_3': 'Cancelar',
    'saved_filter': 'filtro guardado',
    'saved_1': 'Guardado',
    'favourites': 'Favoritos',
    'all_templates': 'Todas las plantillas',
    'load_template': 'Cargar plantilla',
    'favourites_1': 'Favoritos',
    'no_templates_for_this_report_type': 'No hay plantillas para este tipo de informe',
    'saved_filter_1': 'filtro guardado',
    'manage_apartment_sales_and_track_sold_un': 'Administre las ventas de apartamentos y realice un seguimiento de las unidades vendidas',
    'apartments_1': 'apartamentos',
    'available': 'disponible',
    'sold_1': 'vendido',
    'sold_rate': 'Tasa de % vendido',
    'floor_4': 'piso',
    'units_1': 'unidades',
    'available_1': 'disponible',
    'sold_2': 'vendido',
    'unit_4': 'Unidad',
    'owner_buyer': 'Propietario / Comprador',
    'sale_price': 'Precio de venta',
    'sale_date': 'Fecha de venta',
    'sell_unit_2': 'Vender Unidad',
    'view_details_2': 'Ver detalles',
    'print_1': 'Imprimir',
    'apartment_management_system': 'Sistema de gestión de apartamentos',
    'erbil_kurdistan_region_iraq': 'Erbil, Región del Kurdistán - Irak',
    'tel_xxx_xxxxxxxx': 'Teléfono: +XXX XXXXXXXX',
    'receipt': 'Recibo #:',
    'name_2': 'Nombre:',
    'phone_3': 'Teléfono:',
    'building_1': 'Edificio:',
    'payment_details_1': 'Detalles de pago',
    'amount_2': 'Cantidad:',
    'payment_date_1': 'Fecha de pago:',
    'period_1': 'Periodo:',
    'notes_2': 'Notas',
    'thank_you_for_your_payment_1': '¡Gracias por tu pago!',
    'tenant_information_1': 'Información del inquilino',
    'name_3': 'Nombre:',
    'phone_4': 'Teléfono:',
    'apartment_1': 'Apartamento:',
    'building_2': 'Edificio:',
    'furnished_1': 'Amueblado:',
    'at_12_00_pm': 'a las 12:00 p.m.',
    'monthly_rent_1': 'Renta Mensual:',
    'insurance_1': 'Seguro:',
    'additional_notes': 'Notas adicionales',
    'tenant_signature': 'Firma del inquilino',
    'this_receipt_is_electronically_generated': 'Este recibo se genera electrónicamente y es válido sin firma.',
    'apartment_management_system_all_rights_r': 'Sistema de gestión de apartamentos. Reservados todos los derechos.',
    'lease_renewal_risk': 'Riesgo de renovación del arrendamiento',
    'expiring_in_30_days': 'Expira en 30 días',
    'expiring_in_60_days': 'Expira en 60 días',
    'expiring_in_90_days': 'Expira en 90 días',
    'expiring_in_180_days': 'Expira en 180 días.',
    'all_risk_levels': 'Todos los niveles de riesgo',
    'no_leases_matching_the_selected_filters': 'No hay arrendamientos que coincidan con los filtros seleccionados.',
    'd_1': 're',
    'no_documents_uploaded_for_this_tenant': 'No se han cargado documentos para este inquilino.',
    'empty_key_5': '✓',
    'empty_key_6': '✕',
    'empty_key_7': '($) *',
    'ai_lease_reader': 'Lector de arrendamiento de IA',
    'upload_a_lease_pdf_to_auto_fill_the_form': 'Cargue un PDF de arrendamiento para completar automáticamente el formulario',
    'empty_key_8': '●',
    'empty_key_9': '✓',
    '10_1': '10 /',
    '25_1': '25 /',
    '50_1': '50 /',
    '100_1': '100 /',
    'register_as_maintenance_provider_service': 'Regístrese como proveedor de mantenimiento (proveedor de servicios)',
    'this_will_automatically_create_a_record': 'Esto creará automáticamente un registro en el Centro de mantenimiento para que pueda asignar órdenes de trabajo a este usuario.',
    'assigned_buildings_portfolio': 'Edificios asignados (Cartera)',
    'select_the_buildings_this_portfolio_mana': 'Seleccione los edificios a los que puede acceder este administrador de cartera. SÓLO verán datos de estos edificios.',
    'no_buildings_found_please_create_buildin': 'No se encontraron edificios. Primero cree edificios.',
    'building_3': 'edificio',
    'empty_key_10': '☀️',
    '1_315_333_7884': '+1 (315) 333-7884',
    'sent_sid': '✅ ¡Enviado! ID:',
    'iraq_964_is_blocked_by_default_enable_it': '🌍 Irak (+964) está bloqueado de forma predeterminada. Habilítelo:',
    'twilio_messaging_geo_permissions_iraq_on': 'Twilio → Mensajería → Permisos geográficos → Irak → ACTIVADO → Guardar',
    'trial_accounts_can_only_message': '🔒 Las cuentas de prueba solo pueden enviar mensajes',
    'verified_numbers': 'números verificados',
    'apt_1': '· Apto',
    'mo_1': '/mes',
    'mo_2': '/mes',
    'manage_building_amenities_unit_features': 'Administre las comodidades del edificio, las características de las unidades y los espacios de estacionamiento',
    'all_buildings_1': 'Todos los edificios',
    'add_amenity': 'Agregar amenidad',
    'no_building_amenities_found': 'No se encontraron servicios del edificio',
    'all_buildings_2': 'Todos los edificios',
    'all_units': 'Todas las unidades',
    'add_unit_amenity': 'Agregar comodidades de la unidad',
    'no_unit_amenities_found': 'No se encontraron servicios de unidad',

    'unit_amenities': 'Servicios de la unidad',
    'col_monthly_fee': 'Tarifa mensual',
    'col_available': 'Disponible',
    'all_buildings_3': 'Todos los edificios',
    'available_2': 'Disponible',
    'reserved': 'Reservado',
    'add_space': 'Agregar espacio',
    'no_parking_spaces_found': 'No se encontraron plazas de aparcamiento',
    'assign': 'Asignar',
    'unassign': 'Desasignar',
    'spaces': 'Espacios',
    'driveway_area': 'Área de entrada',
    'cancel_4': 'Cancelar',
    'complete': 'completo',
    'confirm_1': 'Confirmar',
    'cancel_5': 'Cancelar',
    'complete_1': 'completo',
    'assign_space': 'Asignar espacio',
    'select_tenant_1': 'Seleccionar inquilino',
    'choose_tenant': '-- Elija inquilino --',
    'select_owner': 'Seleccionar propietario',
    'choose_owner': '-- Elija propietario --',
    'cancel_6': 'Cancelar',
    'assign_1': 'Asignar',
    'new_amenity_booking': 'Nueva reserva de servicios',
    'amenity': 'Comodidad *',
    'select_amenity': 'Seleccione amenidad…',
    'tenant_1': 'Inquilino *',
    'select_tenant_2': 'Seleccione inquilino…',
    'date_1': 'Fecha *',
    'notes_3': 'Notas',
    'cancel_7': 'Cancelar',
    'deactivated': 'Desactivado',
    'max_uses': 'Usos máximos',
    'generate_application_link': 'Generar enlace de aplicación',
    'building_4': 'Edificio *',
    'specific_unit_optional': 'Unidad específica (opcional)',
    'any_unit_in_building': 'Cualquier unidad en el edificio.',
    'unit_5': 'Unidad',
    'floor_5': '– Piso',
    'label': 'Etiqueta',
    'expires_at': 'Vence en',
    'max_uses_1': 'Usos máximos',
    'cancel_8': 'Cancelar',
    'label_unit': 'Etiqueta / Unidad',
    'token_url': 'URL del token',
    'uses': 'Usos',
    'status_1': 'Estado',
    'no_links_yet_click_generate_link_to_crea': 'Aún no hay enlaces. Haga clic en "Generar enlace" para crear uno.',
    'unit_6': '· Unidad',
    '1_30': '1–30',
    '31_60': '31–60',
    '61_90': '61–90',
    'building_amenity': 'Amenidades del edificio',
    'amenity_details': 'Detalles de las comodidades',
    'building_5': 'Edificio *',
    'name_4': 'Nombre *',
    'category_1': 'categoría',
    'monthly_fee': 'Cuota Mensual ($)',
    'operating_hours': 'Horas de funcionamiento',
    'capacity': 'Capacidad',
    'description_1': 'Descripción',
    'notes_4': 'Notas',
    'available_for_booking': 'Disponible para reservar',
    'cancel_9': 'Cancelar',
    'saving_1': 'Guardando…',
    'bulk_tenant_import': 'Importación masiva de inquilinos',
    'import_tenants_from_a_csv_file_apartment': 'Importe inquilinos desde un archivo CSV: los apartamentos coinciden por nombre del edificio + número de unidad',
    'download_csv_template': 'Descargar plantilla CSV',
    'use_this_template_to_format_your_data_co': 'Utilice esta plantilla para formatear sus datos correctamente',
    'template': 'Plantilla',
    'required_columns': 'Columnas requeridas',
    'optional_columns': 'Columnas opcionales',
    'payment_date_2': 'fecha_pago',
    'day_of_month_1_31': '= día del mes (1–31)  ·',
    'contract_start_contract_end': 'inicio_contrato / fin_contrato',
    'yyyy_mm_dd': '= AAAA-MM-DD  ·',
    'en_ar_fr_de_it_sp': '= en, ar, fr, de, it, sp',
    'parsing_csv': 'Analizando CSV…',
    'or_click_to_browse_max_2_mb': 'o haga clic para navegar: máximo 2 MB',
    'import_preview': 'Vista previa de importación',
    'rows_found_review_before_importing': 'filas encontradas: revisar antes de importar',
    'start_over': 'Empezar de nuevo',
    'name_5': 'Nombre',
    'phone_5': 'Teléfono',
    'building_unit': 'Edificio / Unidad',
    'contract_1': 'Contrato',
    'status_2': 'Estado',
    'empty_key_11': '· #',
    'ready_to_import': 'Listo para importar',
    'tenant_2': 'inquilino',
    'row': 'fila',
    'with_errors_will_be_skipped': 'con errores serán omitidos',
    'no_valid_rows_to_import': 'No hay filas válidas para importar',
    'fix_the_errors_in_your_csv_and_try_again': 'Corrija los errores en su CSV y vuelva a intentarlo',
    'upload_new_file': 'Cargar nuevo archivo',
    'import_complete': 'Importación completa',
    'tenants_successfully_imported': 'Inquilinos importados exitosamente',
    'row_1': 'fila',
    'skipped_rows': 'Filas omitidas',
    'row_2': 'Fila',
    'import_another_file': 'Importar otro archivo',
    'view_tenants': 'Ver inquilinos',
    'upload_document': 'Cargar documento',
    'tenant_3': 'Inquilino *',
    'select_tenant_3': 'Seleccione inquilino…',
    'document_name': 'Nombre del documento *',
    'category_2': 'categoría',
    'file_pdf_image_word_max_5mb': 'Archivo * (PDF, Imagen, Word - máximo 5 MB)',
    'upload_document_1': 'Cargar documento',
    'document_management': 'Gestión de documentos',
    'document': 'documento',
    'across_all_tenants': 'en todos los inquilinos',
    'upload': 'Subir',
    'all_categories': 'Todas las categorías',
    'document_1': 'Documento',
    'tenant_4': 'inquilino',
    'category_3': 'categoría',
    'status_3': 'Estado',
    'uploaded': 'subido',
    'actions_1': 'Acciones',
    'no_documents_found': 'No se encontraron documentos',
    'of_2': 'de',
    'prev': 'Anterior',
    'next_1': 'Siguiente',
    'open_eviction_case': 'Caso de desalojo abierto',
    'tenant_5': 'inquilino',
    'tenant_6': 'Inquilino *',
    'building_apartment_auto_filled_from_tena': 'Edificio y apartamento completado automáticamente desde el registro del inquilino',
    'case_details': 'Detalles del caso',
    'reason': 'Razón *',
    'notice_type': 'Tipo de aviso',
    'cancel_10': 'Cancelar',
    'open_case': 'Caso abierto',
    'eviction_management': 'Gestión de desalojos',
    'track_and_manage_eviction_cases_from_not': 'Seguimiento y gestión de casos de desalojo desde el aviso hasta su finalización',
    'new_case': 'Nuevo caso',
    'pipeline': 'Tubería',
    'no_eviction_cases_found': 'No se encontraron casos de desalojo',
    'advance': 'Avanzar →',
    'eviction_case': 'Caso de desalojo #',
    'tenant_7': 'inquilino',
    'unit_7': '· Unidad #',
    'reason_1': 'Razón',
    'amount_owed_1': 'Monto adeudado',
    'pipeline_status': 'Estado de la tubería',
    'notes_5': 'Notas',
    'expense_details': 'Detalles de gastos',
    'payment_info': 'Información de pago',
    'description_2': 'Descripción',
    'no_accounts_posted_yet': 'Aún no hay cuentas publicadas.',
    'total_1': 'totales',
    'assets': 'Activos',
    'liabilities': 'Pasivos',
    'select_a_date_and_click_run_to_generate': 'Seleccione una fecha y haga clic en Ejecutar para generar el balance.',
    'from_2': 'De',
    'to_2': 'a',
    'run_1': 'correr',
    'operating_activities': 'Actividades operativas',
    'net_operating_cash_flow': 'Flujo de caja operativo neto',
    'financing_activities': 'Actividades de Financiamiento',
    'net_financing_cash_flow': 'Flujo de Caja de Financiamiento Neto',
    'net_change_in_cash': 'Cambio neto en efectivo',
    'select_a_date_range_and_click_run': 'Seleccione un rango de fechas y haga clic en Ejecutar.',
    'balance_sheet': 'Balance general',
    'cash_flow_statement': 'Flujo de caja',
    'total_assets': 'Total de activos',
    'total_liabilities': 'Total de pasivos',
    'total_equity': 'Total de patrimonio',
    'bs_balanced_msg': '✓ Equilibrado — Activos = Pasivos + Patrimonio',
    'bs_unbalanced_msg': '⚠ Desequilibrado — revise los asientos del diario',
    'operating_cash_flow': 'Flujo de caja operativo',
    'financing_cash_flow': 'Flujo de caja de financiamiento',
    'edit_expense': 'Editar gasto',
    'expense_updated': 'Gasto actualizado',
    'rated': 'clasificado',
    'property_inspections': 'Inspecciones de propiedad',
    'move_in_move_out_periodic_20_item_standa': 'Mudarse · Mudarse · Periódico · Lista de verificación estandarizada de 20 elementos',
    'new_inspection': 'Nueva inspección',
    'no_inspections_found': 'No se encontraron inspecciones.',
    'adjust_the_filters_or_create_a_new_inspe': 'Ajuste los filtros o cree una nueva inspección.',
    'showing_1': 'Mostrando',
    'of_3': 'de',
    'new_inspection_1': 'Nueva inspección',
    'apartment_2': 'Apartamento',
    'nothing_found': 'No se encontró nada.',
    'unit_8': '— Unidad',
    'no_active_tenant_on_this_unit': 'No hay inquilinos activos en esta unidad.',
    'tenant_8': 'inquilino',
    'no_tenant_vacant': 'Sin inquilino (vacante)',
    'inspection_type': 'Tipo de inspección',
    'overall_condition': 'Condición general',
    'a_20_item_standardized_checklist_entranc': 'Se creará automáticamente una lista de verificación estandarizada de 20 elementos (entrada, sala de estar, cocina, baño, dormitorio, general).',
    'cancel_11': 'Cancelar',
    'creating': 'Creando…',
    'create_inspection': 'Crear inspección',
    'unit_9': '· Unidad',
    'tenant_9': 'Inquilino:',
    'inspector': 'inspectora:',
    'print_2': 'Imprimir',
    'checklist_completion': 'Completar la lista de verificación',
    'overall': 'En general:',
    'click_a_condition_button_to_rate_each_it': 'Haga clic en un botón de condición para calificar cada elemento. Las notas se guardan automáticamente cuando están borrosas.',
    'general_notes_1': 'Notas generales',
    'close_1': 'Cerrar',
    'completing': 'Completando…',
    'mark_as_completed': 'Marcar como completado',
    'close_2': 'Cerrar',
    'signing': 'Firmando…',
    'sign_inspection': 'Inspección de letreros',
    'signing_is_final_and_cannot_be_undone': 'La firma es definitiva y no se puede deshacer.',
    'covered_entity': 'Entidad cubierta',
    'select': 'Seleccionar',
    'policy_details': 'Detalles de la póliza',
    'start_date_2': 'Fecha de inicio',
    'notes_6': 'Notas',
    'cancel_12': 'Cancelar',
    'manage_tenant_owner_and_building_insuran': 'Gestionar pólizas de seguro de inquilinos, propietarios y edificios.',
    'empty_key_12': '✓',
    'new_lease_application': 'Nueva solicitud de arrendamiento',
    'applicant_information': 'Información del solicitante',
    'full_name_1': 'Nombre completo *',
    'email_3': 'Correo electrónico',
    'phone_6': 'Teléfono',
    'date_of_birth': 'Fecha de nacimiento',
    'current_address': 'Dirección actual',
    'employment': 'Empleo',
    'employment_status': 'Estado de empleo',
    'monthly_income': 'Ingreso Mensual ($)',
    'employer_name': 'Nombre del empleador',
    'employer_phone': 'Teléfono del empleador',
    'unit_preferences': 'Preferencias de unidad',
    'building_6': 'edificio',
    'unit_10': 'Unidad',
    'desired_move_in': 'Mudanza deseada',
    'desired_lease_months': 'Arrendamiento deseado (meses)',
    'has_pets': 'Tiene mascotas',
    'pet_details': 'Detalles de la mascota',
    'notes_7': 'Notas',
    'cancel_13': 'Cancelar',
    'submit_application': 'Enviar solicitud',
    'review_and_approve_prospective_tenant_ap': 'Revisar y aprobar solicitudes de posibles inquilinos',
    'all_buildings_4': 'Todos los edificios',
    'no_applications_found': 'No se encontraron aplicaciones',
    'showing_2': 'Mostrando',
    'of_4': 'de',
    'prev_1': 'Anterior',
    'next_2': 'Siguiente',
    'close_3': 'Cerrar',
    'unit_11': '· Unidad #',
    'monthly_rent_2': 'Renta Mensual *',
    'discount_1': 'Descuento',
    'contract_start_1': 'Inicio de contrato *',
    'contract_end_1': 'Fin de contrato *',
    'payment_day_of_month': 'Día de pago del mes *',
    'application': 'Solicitud',
    'rejection_reason': 'Motivo del rechazo',
    'cancel_14': 'Cancelar',
    'nightly_scan_flags_leases_expiring_in_90': 'El escaneo nocturno marca los arrendamientos que vencen en 90 días: los borradores de ofertas se crean automáticamente y se envían con un solo clic.',
    'send_all_drafts': 'Enviar todos los borradores (',
    'expiring_within_90_days': 'expira dentro de 90 días',
    'without_an_offer_yet': 'sin oferta aun',
    'd_2': 're',
    'offer_sent': 'oferta enviada',
    'no_offer': 'ninguna oferta',
    'all_statuses_1': 'Todos los estados',
    'no_renewals_found': 'No se encontraron renovaciones',
    'd_left': 'se fue',
    'convert_lease': 'Convertir arrendamiento',
    'counter_offer': 'Contraoferta',
    'tenant_10': 'Inquilino:',
    'counter_rent_amount': 'Monto del alquiler del mostrador *',
    'cancel_15': 'Cancelar',
    'send_counter': 'Enviar contador',
    'full_lease_lifecycle_create_renew_termin': 'Ciclo de vida completo del arrendamiento: creación, renovación, rescisión, historial',
    'new_lease': 'Nuevo contrato de arrendamiento',
    'all_status_1': 'Todo el estado',
    'active_1': 'Activo',
    'expired_1': 'Caducado',
    'renewed': 'Renovado',
    'all_buildings_5': 'Todos los edificios',
    'no_leases_found': 'No se encontraron arrendamientos',
    'expired_2': 'Caducado',
    'd_left_1': 'se fue',
    'd_left_2': 'se fue',
    'd_3': 're',
    'renew': 'Renovar',
    'terminate': 'terminar',
    'terminate_lease': 'Terminar el contrato de arrendamiento',
    'this_action_cannot_be_undone_the_lease_w': 'Esta acción no se puede deshacer. El contrato de arrendamiento quedará rescindido definitivamente.',
    'cancel_16': 'Cancelar',
    'empty_key_13': '- #',
    'new_start_date': 'Nueva fecha de inicio *',
    'monthly_rent_3': 'Renta Mensual ($) *',
    'lease_type_1': 'Tipo de arrendamiento',
    'fixed_term_1': 'Plazo fijo',
    'month_to_month_1': 'Mes a mes',
    'annual_1': 'Anual',
    'renew_lease_1': 'Renovar contrato de arrendamiento',
    'cancel_17': 'Cancelar',
    'description_3': 'Descripción',
    'tenant_11': 'inquilino',
    'close_4': 'Cerrar',
    'new_maintenance_schedule': 'Nuevo programa de mantenimiento',
    'schedule_details': 'Detalles del horario',
    'building_7': 'edificio',
    'all_buildings_6': 'Todos los edificios',
    'frequency': 'Frecuencia *',
    'first_due_date': 'Primera fecha de vencimiento *',
    'description_4': 'Descripción',
    'cancel_18': 'Cancelar',
    'create_schedule': 'Crear horario',
    'maintenance_schedules': 'Horarios de mantenimiento',
    'preventive_maintenance_tracking': 'Seguimiento del mantenimiento preventivo',
    'new_schedule': 'Nuevo horario',
    'overdue_work_orders_will_be_auto_created': 'vencido: las órdenes de trabajo se crearán automáticamente esta noche',
    'no_schedules_found': 'No se encontraron horarios',
    'history': 'Historia -',
    'no_history_yet': 'Aún no hay historial',
    'wo': 'OT #',
    'empty_key_14': '✓',
    'owner_ledger': 'Libro mayor del propietario',
    'immutable_financial_history': '— historial financiero inmutable',
    'refresh_1': 'Actualizar',
    'add_entry': 'Agregar entrada',
    'payouts': 'Pagos',
    'add_manual_ledger_entry': 'Agregar entrada manual al libro mayor',
    'amount_3': 'Cantidad *',
    'description_5': 'Descripción *',
    'cancel_19': 'Cancelar',
    'showing_3': 'Mostrando',
    'of_5': 'de',
    'prev_2': 'Anterior',
    'next_3': 'Siguiente',
    'new_parking_space': 'Nuevo espacio de estacionamiento',
    'creation_mode': 'Modo de creación',
    'single_space': 'Espacio único',
    'bulk_generation': 'Generación masiva',
    'building_8': 'Edificio *',
    'select_building_1': 'Seleccione edificio…',
    'prefix': 'Prefijo',
    'start_number': 'Número de inicio *',
    'end_number': 'Número final *',
    'pad_with_zeros_e_g_01_02': '¿Relleno con ceros? (por ejemplo, 01, 02)',
    'space_number': 'Número de espacio *',
    'level': 'Nivel',
    'type_1': 'Tipo',
    'monthly_fee_1': 'Cuota Mensual ($)',
    'notes_8': 'Notas',
    'cancel_20': 'Cancelar',
    'saving_2': 'Guardando…',
    'create_space': 'Crear espacio',
    'tenant_screening': 'Evaluación de inquilinos',
    'identity_verification_background_checks': 'Verificación de identidad y verificación de antecedentes',
    'unit_12': 'Unidad',
    'select_a_tenant_to_view_or_start_their_s': 'Seleccione un inquilino para ver o comenzar su evaluación',
    'final_decision': 'Decisión final',
    'set_on': 'Establecer en',
    'identity_verification': 'Verificación de identidad',
    'document_2': 'Documento:',
    'name_6': 'Nombre:',
    'start_identity_verification': 'Iniciar la verificación de identidad',
    'link_was_shared_with_the_tenant_waiting': 'El enlace se compartió con el inquilino, esperando que lo completara.',
    'background_check_checkr': 'Verificación de antecedentes (Checkr)',
    'adjudication': 'Adjudicación:',
    'checks': 'Cheques:',
    'start_background_check': 'Iniciar verificación de antecedentes',
    'united_states': 'Estados Unidos',
    'canada': 'Canadá',
    'fcra_consent_required': 'Se requiere consentimiento de la FCRA',
    'under_the_fair_credit_reporting_act_fcra': 'Según la Ley de Informe Justo de Crédito (FCRA), debe obtener el consentimiento por escrito del solicitante antes de realizar una verificación de antecedentes. El inquilino recibirá un correo electrónico de Checkr para completar el proceso.',
    'i_confirm_the_applicant_has_provided_wri': 'Confirmo que el solicitante ha dado su consentimiento por escrito para esta verificación de antecedentes.',
    'cancel_21': 'Cancelar',
    'invitation_sent_waiting_for_the_applican': 'Invitación enviada: esperando a que la complete el solicitante. Checkr actualizará esto automáticamente.',
    'set_final_decision': 'Establecer decisión final',
    'final_screening_decision': 'Decisión final de selección',
    'manual_review': 'Revisión manual',
    'cancel_22': 'Cancelar',
    'no_screening_started_for_this_tenant_yet': 'Aún no se ha iniciado ninguna evaluación para este inquilino.',
    'empty_key_15': '($) *',
    'prospect_information': 'Información del prospecto',
    'showing_details': 'Mostrando detalles',
    'empty_key_16': '· #',
    'empty_key_17': '· #',
    'add_unit_amenity_1': 'Agregar comodidades de la unidad',
    'bulk_addition_mode': 'Modo de adición masiva',
    'add_this_amenity_to_multiple_units_at_on': 'Agregue este servicio a varias unidades a la vez',
    'amenity_details_1': 'Detalles de las comodidades',
    'clear_all': 'Borrar todo',
    'nothing_found_1': 'No se encontró nada.',
    'amenity_name': 'Nombre del servicio *',
    'category_4': 'categoría',
    'condition': 'Condición',
    'notes_9': 'Notas',
    'cancel_23': 'Cancelar',
    'saving_3': 'Guardando…',
    'add_amenity_1': 'Agregar amenidad',
    'meter_accounts_rubs_billing_and_per_tena': 'Cuentas de medidores, facturación RUBS y cargos de servicios públicos por inquilino',
    'option_a_metered': 'Opción A - Medido:',
    'add_account_record_reading_generate_bill': 'Agregar cuenta → registrar lectura → generar facturas → cargar al libro mayor',
    'option_c_rubs': 'Opción B - RUBS:',
    'building_level_meter_split_equally_acros': 'El medidor a nivel del edificio se divide equitativamente entre todos los inquilinos activos',
    'reading_recorded_for': 'Lectura registrada para',
    'no_utility_accounts_yet_add_one_to_start': 'Aún no hay cuentas de servicios públicos: agregue una para comenzar la facturación con medidor.',
    'no_readings': 'Sin lecturas',
    'shared': 'Compartido',
    'reading': 'leyendo',
    'all_statuses_2': 'Todos los estados',
    'no_bills_yet_generate_from_meter_readings': 'Aún no hay facturas — agregue cuentas de medidor, registre lecturas y luego genere facturas.',
    'accounts': 'Cuentas',
    'bills': 'Facturas',
    'benchmarking': 'Análisis comparativo',
    'total_bills': 'Total de facturas',
    'total_billed': 'Total facturado',
    'charge': 'Cargar',
    'unit_13': 'Unidad',
    'notes_10': 'Notas',
    'cancel_24': 'Cancelar',
    'loading_1': 'Cargando…',
    'accounts_tracked': 'cuentas rastreadas',
    'monthly_consumption_last_6_months': 'Consumo mensual: últimos 6 meses',
    'monthly_cost': 'Costo Mensual ($)',
    'no_readings_recorded_yet_for': 'Aún no se han registrado lecturas para',
    'valuation_details': 'Detalles de valoración',
    'building_9': 'Edificio *',
    'market_value': 'Valor de mercado ($) *',
    'valuation_method': 'Método de valoración',
    'notes_11': 'Notas',
    'cancel_25': 'Cancelar',
    'portal': 'Portal ✓',
    'invite_as_system_user_full_portal_access': 'Invitar como usuario del sistema (acceso completo al portal)',
    'this_will_create_a_staff_account_with_th': 'Esto creará una cuenta de personal con el rol de "proveedor". Recibirán una invitación por correo electrónico para establecer su contraseña.',
    'record_violation': 'Violación de récord',
    'tenant_unit': 'Inquilino y unidad',
    'tenant_12': 'Inquilino *',
    'unit_14': '— Unidad',
    'apartment_id': 'Identificación del apartamento',
    'auto_filled': 'autocompletado',
    'violation_details': 'Detalles de la infracción',
    'title_1': 'Título *',
    'type_2': 'Tipo *',
    'severity': 'Gravedad *',
    'incident_date': 'Fecha del incidente *',
    'fine_amount_optional': 'Monto de la multa (opcional)',
    'description_6': 'Descripción *',
    'if_a_fine_amount_is_entered_it_will_be_a': 'Si se ingresa un monto de multa, se cargará automáticamente al libro mayor del inquilino.',
    'cancel_26': 'Cancelar',
    'record_violation_1': 'Violación de récord',
    'violations_notices': 'Violaciones y avisos',
    'track_lease_violations_and_issue_formal': 'Realice un seguimiento de las infracciones del contrato de arrendamiento y emita avisos legales formales',
    'new_violation': 'Nueva infracción',
    'how_it_works_1': 'Cómo funciona',
    'all_statuses_3': 'Todos los estados',
    'notice': 'Aviso',
    'resolve': 'resolver',
    'issue_legal_notice': 'Emitir Aviso Legal',
    'cancel_27': 'Cancelar',
    'add_webhook_endpoint': 'Agregar punto final de webhook',
    'push_events_to_your_external_systems': 'Envíe eventos a sus sistemas externos',
    'successfully_created': '¡Creado con éxito!',
    'save_your_signing_secret_now_it_won_t_be': 'Guarde su secreto de firma ahora; no se volverá a mostrar.',
    'copy_secret': 'Copiar secreto',
    'done_return': 'Listo y regresar',
    'connection_details': 'Detalles de conexión',
    'payload_url': 'URL de carga útil',
    'description_7': 'Descripción',
    'event_subscriptions': 'Suscripciones a eventos',
    'you_can_always_add_more_events_later': 'Siempre puedes agregar más eventos más tarde.',
    'register_endpoint': 'Registrar punto final',
    'cancel_28': 'Cancelar',
    'assign_a_new_task_to_a_maintenance_provi': 'Asignar una nueva tarea a un proveedor de mantenimiento',
    'work_order_details': 'Detalles de la orden de trabajo',
    'work_order_title': 'Título de la orden de trabajo',
    'task_description': 'Descripción de la tarea',
    'scheduling_reference': 'Programación y referencia',
    'maintenance_request_id': 'ID de solicitud de mantenimiento',
    'assignment': 'tarea',
    'select_a_maintenance_provider': 'Seleccione un proveedor de mantenimiento',
    'priority_level_level': 'Nivel de prioridad Nivel',
    'dispatch_work_order': 'Orden de trabajo de despacho',
    'discard_changes': 'Descartar cambios',
    'pro_tip': 'Consejo profesional',
    'dispatching_a_work_order_will_immediatel': 'Al enviar una orden de trabajo, se notificará inmediatamente al proveedor a través de su portal y por correo electrónico, si está habilitado.',
    'update_work_order': 'Actualizar orden de trabajo',
    'status_priority': 'Estado y prioridad',
    'status_4': 'Estado',
    'completed_date': 'Fecha de finalización',
    'invoice': 'factura',
    'invoice_amount': 'Importe de la factura',
    'invoice_status': 'Estado de la factura',
    'cancel_29': 'Cancelar',
    'vendor_work_order_management': 'Gestión de órdenes de trabajo de proveedores.',
    'refresh_2': 'Actualizar',
    'new_work_order': 'Nueva orden de trabajo',
    'all_statuses_4': 'Todos los estados',
    'no_work_orders_found': 'No se encontraron órdenes de trabajo',
    'mr': 'Señor:',
    'work_order': 'Orden de trabajo #',
    'priority_1': 'prioridad',
    'description_8': 'Descripción',
    'linked_maintenance_request': 'Solicitud de mantenimiento vinculada',
    'unit_15': 'Unidad',
    'invoice_1': 'factura',
    'view_invoice_document': 'Ver documento de factura',
    'review_approve_invoice': 'Revisar y aprobar factura',
    'edit_work_order': 'Editar orden de trabajo',
    'approve_invoice': 'Aprobar factura',
    'you_are_approving_a_vendor_invoice_of': 'Está aprobando una factura de proveedor de',
    'for': 'para',
    'charge_to_tenant_ledger': 'Cargo al libro mayor de inquilinos',
    'the_cost_will_be_automatically_added_as': 'El costo se agregará automáticamente como un débito en el libro mayor del inquilino para que lo pague.',
    'organization_absorbs_cost': 'La organización absorbe el costo',
    'the_tenant_will_not_be_charged_this_crea': 'No se le cobrará al inquilino. Esto crea una entrada de Cuentas por pagar para la organización.',
    'cancel_30': 'Cancelar',
    'loading_2': 'Cargando…',
    'page_not_found': 'Página no encontrada',
    'the_page_you_re_looking_for_doesn_t_exis': 'La página que estás buscando no existe.',
    'go_to_dashboard': 'Ir al panel',
    'clear_signature': 'Borrar firma',
    'i_consent_to_use_electronic_signatures_a': 'Doy mi consentimiento para utilizar firmas electrónicas y acepto que mi firma electrónica',
    'cancel_31': 'es el equivalente legal de mi firma manual en este contrato. lo entiendo',
    'sign_contract_1': 'que tengo derecho a recibir una copia impresa de este documento.',
    'by_signing_this_document_electronically': 'Cancelar',
    'subscription_locked': 'firmar contrato',
    'your_subscription_status_is': 'Al firmar este documento electrónicamente, usted reconoce que su firma electrónica',
    'please_renew_your_subscription_to_contin': 'es jurídicamente vinculante y tiene el mismo efecto que una firma manuscrita. Tu dirección IP',
    'payment_options': 'y la marca de tiempo se registrará para fines de verificación.',
    'please_contact_the_administrator_to_proc': 'Suscripción bloqueada',
    'contact_admin_to_renew': 'El estado de su suscripción es',
    'request_sent_pending_approval': '.',
    'need_help_contact_support_at_support_qua': 'Renueve su suscripción para continuar administrando sus propiedades.',
    'requires_the': 'Opciones de pago',
    'is_a_pro_feature': 'Comuníquese con el administrador para procesar su pago y reactivar su suscripción.',
    'upgrade_to_pro_to_unlock_ai_powered_inte': 'Contacte al administrador para renovar',
    'upgrade_to_pro_1': '¡Solicitud enviada! Pendiente de aprobación.',
    'starting_at_3_20_unit_month_no_minimum_u': '¿Necesitar ayuda? Póngase en contacto con el soporte en support@quadcores.com',
    'our_narrative': 'requiere el',
    'reimagined': 'es una característica Pro',
    'quadcores_properties_is_an_elite_operati': 'Actualice a Pro para desbloquear inteligencia impulsada por IA en todo su portafolio.',
    'core_capabilities': 'Actualízate a Pro',
    'our_approach_to': 'Desde $3.20 / unidad / mes · No se requieren unidades mínimas',
    'operations': 'Nuestra narrativa',
    'we_believe_property_management_should_be': 'reinventado.',
    'whether_you_manage_10_units_or_10_000_qu': 'Quadcores Properties es una capa operativa de élite para la cartera inmobiliaria moderna.',
    'complete_platform': 'Construido para escalar, diseñado para precisión y diseñado para quienes van en serio.',
    'all_features': 'Capacidades principales',
    '35_powerful_features_organized_into_7_co': 'Nuestro enfoque hacia',
    'link_unavailable': 'Enlace no disponible',
    'application_submitted': '¡Solicitud enviada!',
    'your_application_has_been_received_our_t': 'Su solicitud ha sido recibida. Nuestro equipo lo revisará y se comunicará con usted pronto.',
    'your_application_id': 'Su ID de aplicación',
    'successfully_registered': 'Registrado exitosamente',
    'track_application_status': 'Seguimiento del estado de la solicitud',
    'rental_application': 'Solicitud de alquiler',
    'unit_16': 'Unidad',
    'applying_for': 'Solicitando',
    'full_name_2': 'Nombre completo *',
    'email_address': 'Dirección de correo electrónico *',
    'national_id_passport': 'DNI / Pasaporte',
    'date_of_birth_1': 'Fecha de nacimiento',
    'current_address_1': 'Dirección actual',
    'employment_income': 'Empleo e ingresos',
    'employment_status_1': 'Estado de empleo',
    'employed': 'Empleado',
    'self_employed': 'Trabajador Autónomo',
    'retired': 'jubilado',
    'student': 'estudiante',
    'unemployed': 'Desempleado',
    'monthly_income_1': 'Ingreso Mensual',
    'employer_name_1': 'Nombre del empleador',
    'employer_phone_1': 'Teléfono del empleador',
    'lease_preferences': 'Preferencias de arrendamiento',
    'desired_move_in_date': 'Fecha de mudanza deseada',
    'lease_duration_months': 'Duración del arrendamiento (meses)',
    'months_2': 'meses',
    'i_have_pets': 'tengo mascotas',
    'emergency_contact': 'Contacto de emergencia',
    'name_7': 'Nombre',
    'phone_7': 'Teléfono',
    'relation': 'Relación',
    'additional_notes_1': 'Notas adicionales',
    'your_information_is_kept_private_and_use': 'Su información se mantiene privada y se utiliza únicamente para la evaluación del alquiler.',
    'track_application': 'Seguimiento de la solicitud',
    'ref_id': 'ID de referencia: #',
    'verification_email': 'Correo electrónico de verificación',
    'review': 'Revisión',
    'approval': 'Aprobación',
    'notice_from_the_team': 'Aviso del equipo',
    'applicant': 'Solicitante',
    'property_1': 'Propiedad',
    'submitted_1': 'Enviado',
    'approved_for_lease': 'Aprobado para arrendamiento',
    'next_steps_sign_lease': 'Próximos pasos: firmar el contrato de arrendamiento',
    'questions_contact': '¿Preguntas? Contacto',
    'support': 'Soporte',
    'or_call_our_leasing_office': 'o llama a nuestra oficina de arrendamiento.',
    'verification_code': 'Código de verificación',
    'verify_code': 'Verificar código',
    'resend_code': 'Reenviar código',
    'back_to_login': 'Volver a iniciar sesión',
    'invalid_link': 'Enlace no válido',
    'go_to_login': 'Ir a Iniciar sesión',
    'welcome_aboard': '¡Bienvenido a bordo!',
    'secure_onboarding': 'Incorporación segura',
    'welcome_to_the_quadcores_property_manage': 'Bienvenido al portal de administración de propiedades de Quadcores. Terminemos de configurar su cuenta interna.',
    'account_role': 'Función de cuenta',
    'email_address_1': 'Dirección de correo electrónico',
    'set_your_password': 'Establece tu contraseña',
    'please_choose_a_secure_password_for_your': 'Elija una contraseña segura para su cuenta.',
    'show_password': 'Mostrar contraseña',
    'complete_account_setup': 'Configuración completa de la cuenta',
    'password_requirement_minimum_8_character': 'Requisito de contraseña: Mínimo 8 caracteres. Recomendamos utilizar una combinación de letras, números y símbolos para máxima seguridad.',
    'thank_you_for_your_subscription_your_acc': 'Gracias por tu suscripción. Su cuenta ha sido actualizada.',
    'go_to_dashboard_1': 'Ir al panel',
    'back_to_home': 'Volver a Inicio',
    'pricing_plans': 'Precios + Planes',
    'pay_for_what': 'pagar por lo que',
    'you_actually_use': 'realmente usas.',
    'annual_2': 'Anual',
    '16_1': '−16%',
    'per_unit_pricing_no_minimum_portfolio_si': 'Precios por unidad. Sin tamaño mínimo de cartera. Cancele en cualquier momento.',
    'current_1': 'Actual',
    'unit_17': '/ unidad',
    'from_3': 'de',
    'mo_3': '/mes',
    'minimum': 'mínimo',
    '2_months_free_annual_billing': '2 meses gratis · Facturación anual',
    'includes': 'Incluye',
    'enterprise_custom_contract': 'Contrato empresarial/personalizado',
    '10_000_units_custom_sla_dedicated_suppor': 'Más de 10 000 unidades, SLA personalizado, soporte dedicado, opción local.',
    'talk_to_sales': 'Hablar con ventas →',
    'feature_matrix': 'Matriz de características',
    'full_capability': 'Capacidad total',
    'breakdown': 'avería.',
    'starter': 'entrante',
    'growth': 'Crecimiento',
    'pro_2': 'profesional',
    'no_minimum_units_no_setup_fees_enterpris': 'Sin unidades mínimas. Sin tarifas de instalación. Seguridad de nivel empresarial en todos los planes.',
    'legal': 'Legales',
    'privacy': 'Privacidad',
    'policy': 'Política.',
    'we_are_committed_to_protecting_your_prof': 'Nos comprometemos a proteger sus datos profesionales y personales con el mismo rigor que aplicamos a las operaciones inmobiliarias.',
    'principles': 'La transparencia es nuestra base.',
    'section_0': 'Principios',
    'legal_and_compliance': 'SECCIÓN 0',
    'inquiries': 'Legal y cumplimiento',
    'if_you_have_questions_about_how_we_handl': 'consultas.',
    'info_quadcores_com': 'Si tiene preguntas sobre cómo manejamos sus datos o si necesita ejercer sus derechos de privacidad, comuníquese con nuestro equipo de cumplimiento.',
    'please_review_the_full_contract_terms_be': 'Estamos aquí para garantizar su tranquilidad.',
    'link_expired_or_invalid': 'info@quadcores.com',
    'we_couldn_t_find_the_contract_associated': 'Revise los términos completos del contrato a continuación.',
    'your_signature_has_been_recorded_a_copy': 'Enlace caducado o no válido',
    'setup_your_portal': 'No pudimos encontrar el contrato asociado a este enlace. Comuníquese con la oficina de administración de la propiedad para obtener un nuevo enlace de firma.',
    'access_your_payments_installments_and_do': 'Su firma ha sido registrada. En breve le enviaremos una copia del contrato firmado a su correo electrónico.',
    'activate_my_account': 'Configura tu Portal',
    'go_to_dashboard_2': 'Acceda a sus pagos, cuotas y documentos en cualquier momento configurando su cuenta del portal.',
    'id_1': 'Activar mi cuenta',
    'contract_signature_portal': 'Ir al panel',
    'review_sign': 'Identificación: #',
    'hello': 'Portal de firma de contrato',
    'please_review_your_contract_details_for': 'Revisar y firmar',
    'property_2': 'hola',
    'contract_value': ', revise los detalles de su contrato para la propiedad a continuación.',
    'timeline': 'Propiedad',
    'to_3': 'Valor del contrato',
    'legal_terms': 'Línea de tiempo',
    'en_ar': 'a',
    'legal_disclaimer': 'Aviso legal',
    'electronic_signatures_are_legally_equiva': 'Las firmas electrónicas son legalmente equivalentes a las manuscritas.',
    'your_ip_address_and_device_information_w': 'Su dirección IP y la información de su dispositivo se registrarán por motivos de seguridad.',
    'you_can_download_the_pdf_anytime_after_c': 'Puede descargar el PDF en cualquier momento una vez completado.',
    'ready_to_complete': '¿Listo para completar?',
    'continue_to_plans': 'Continuar a Planes',
    'next_step': 'Siguiente paso...',
    'complete_registration': 'Completar registro',
    'verify_phone_number': 'Verifica tu número de teléfono',
    'verification_code_sent_to_phone': 'Código de verificación enviado a tu teléfono. Por favor ingrésalo a continuación.',
    'popular': 'populares',
    'mo_4': '/mes',
    'up_to': 'hasta',
    'units_2': 'unidades',
    'back_to_info': 'Volver a información',
    'verification_code_1': 'Código de verificación',
    'please_enter_the_6_digit_code_sent_to': 'Por favor ingresa el código de 6 dígitos enviado a',
    'verify_phone': 'Verificar teléfono',
    'guidelines': 'Directrices',
    'terms_of': 'Términos de',
    'use': 'Uso.',
    'our_terms_are_designed_to_ensure_a_secur': 'Nuestros términos están diseñados para garantizar un entorno seguro, confiable y justo para propietarios, inquilinos y administradores de propiedades por igual.',
    'conditions': 'Condiciones',
    'clause_0': 'CLÁUSULA 0',
    'agreement_to': 'Acuerdo para',
    'arbitration': 'arbitraje.',
    'by_using_the_platform_you_agree_that_any': 'Al utilizar la plataforma, usted acepta que cualquier disputa se resolverá mediante mediación profesional o arbitraje vinculante, lo que garantiza una resolución eficiente del conflicto operativo.',
    'last_updated_march_2026': 'Nos comprometemos a mantener una relación de colaboración con todos nuestros usuarios.',
    'system_architecture': 'Última actualización: marzo de 2026',
    'refined': 'Arquitectura del sistema',
    'operations_1': 'refinado',
    'a_masterclass_in_property_management_we': 'Operaciones.',
    'complete_platform_1': 'Una clase magistral en gestión inmobiliaria. Eliminamos el ruido para dejar solo lo necesario, potente y con un diseño impecable.',
    'everything_you_need_to_manage': 'Plataforma completa',
    'your_properties': 'tus propiedades.',
    'a_comprehensive_property_management_syst': 'Un sistema integral de administración de propiedades creado para brindar eficiencia, automatización y escala.',
    'view_all_24_features': 'Ver las 24 funciones',
    'get_started': 'empezar',
    'take_control_of': 'tomar el control de',
    'your_entire_portfolio': 'todo tu portafolio.',
    'hundreds_of_property_managers_have_alrea': 'Cientos de administradores de propiedades ya han trasladado sus operaciones a QuadProperties.',
    'start_free_trial': 'Comience su prueba gratuita, no se necesita tarjeta de crédito.',
    'already_have_an_account': 'Iniciar prueba gratuita',
    'quadcores_properties': '¿Ya tienes una cuenta?',
    'the_apartment_management_platform_built': 'Propiedades de cuatro núcleos',
    'quadcores': 'La plataforma de gestión de apartamentos diseñada para operaciones serias.',
    'quadcores_properties_1': 'cuatro núcleos',
    'every_property': 'Propiedades de cuatro núcleos',
    'under_control': 'Cada propiedad.',
    'one_platform_for_leases_rent_collection': 'Bajo control.',
    'start_free_trial_1': 'Una plataforma para arrendamientos, cobro de alquileres, mantenimiento e inquilinos:',
    'view_dashboard': 'construido para administradores de propiedades que van en serio.',
    'scroll': 'Iniciar prueba gratuita',
    'quadcores_properties_2': 'Ver panel',
    'tenant_login': 'Desplazarse',
    'owner_login': 'Propiedades de cuatro núcleos',
    'sign_in': 'Inicio de sesión de inquilino',
    'get_started_1': 'Inicio de sesión de propietario',
    'sign_in_1': 'Iniciar sesión',
    'menu': 'Empezar →',
    'get_started_2': 'Iniciar sesión',
    'tenant_13': 'Menú',
    'owner_1': 'Empezar',
    'nav_features': 'Funciones',
    'nav_pricing': 'Precios',
    'nav_about': 'Acerca de',
    'our_tiers': 'inquilino',
    'choose_the_right': 'Elige lo correcto',
    'plan_for_you': 'planifica para ti.',
    'monthly_1': 'Mensual',
    'annual_3': 'Anual',
    'mo_5': '/mes',
    '20_off_annual_billing': '-20% de descuento en facturación anual',
    'quadcores_properties_3': 'Propiedades de cuatro núcleos',
    'the_apartment_management_platform_built_1': 'La plataforma de gestión de apartamentos diseñada para operaciones serias.',
    'quadcores_1': 'cuatro núcleos',
    'solutions': 'Soluciones',
    'built_for_every_property_professional': 'Creado para todos los profesionales inmobiliarios.',
    'empty_key_18': '✦',
    'set_up_your_password': 'Configura tu contraseña',
    'create_a_strong_password_for': 'Crea una contraseña segura para',
    'email_address_2': 'Dirección de correo electrónico',
    'new_password_1': 'Nueva contraseña',
    'confirm_password_1': 'Confirmar contraseña',
    'back_to_login_1': 'Volver a iniciar sesión',
    'view_all_announcements': 'Ver todos los anuncios →',
    'session_expiring_soon': 'La sesión expirará pronto',
    'you_will_be_logged_out_automatically': 'Se cerrará tu sesión automáticamente',
    'log_out': 'Cerrar sesión',
    'stay_logged_in': 'Manténgase conectado',
    'id_2': 'Identificación: #',
    'to_4': 'a',
    'ip_1': 'IP:',
    'ip_2': 'IP:',
    'contract_already_signed': 'Contrato ya firmado',
    'you_have_already_signed_this_contract': 'Ya has firmado este contrato.',
    'review_sign_contract': 'Revisar y firmar el contrato',
    'awaiting_your_signature': 'Esperando su firma',
    'contract_summary_1': 'Resumen del contrato',
    'property_3': 'Propiedad',
    'start_date_3': 'Fecha de inicio',
    'end_date_1': 'Fecha de finalización',
    'terms_and_conditions': 'Términos y condiciones',
    'important_information': 'Información importante',
    'by_signing_you_agree_to_all_terms_and_co': '• Al firmar, acepta todos los términos y condiciones establecidos anteriormente.',
    'your_electronic_signature_is_legally_bin': '• Su firma electrónica es legalmente vinculante',
    'you_will_receive_a_signed_copy_via_email': '• Recibirás una copia firmada por correo electrónico',
    'you_can_download_the_signed_contract_any': '• Puedes descargar el contrato firmado en cualquier momento desde tu portal',
    'cancel_32': 'Cancelar',
    'sign_contract_2': 'firmar contrato',
    'units_3': 'unidades',
    'unit_18': 'Unidad',
    'tenant_14': 'Inquilino:',
    'empty_key_19': '·$',
    'mo_6': '/mes',
    'no_properties_found_in_your_portfolio': 'No se encontraron propiedades en su cartera.',
    'my_ledger': 'Mi libro mayor',
    'complete_history_of_your_financial_trans': 'Historial completo de tus transacciones financieras',
    'current_balance_1': 'Saldo actual',
    'no_ledger_entries_yet_1': 'Aún no hay entradas en el libro mayor',
    'transactions_will_appear_here_once_recor': 'Las transacciones aparecerán aquí una vez registradas.',
    'unit_19': 'Unidad',
    'bal': 'bal',
    'professional_access': 'Acceso profesional',
    'owner_2': 'propietario',
    'secure_identify_for_property_executives': 'Identificación segura para ejecutivos y administradores de propiedades.',
    'email_or_phone_number': 'Correo electrónico o número de teléfono',
    'secure_password': 'Contraseña segura',
    'switch_to_resident_login': 'Cambiar a inicio de sesión para residentes',
    'institutional_oversight': 'Supervisión institucional.',
    'portfolio_suite': 'Conjunto de cartera',
    'full_control_over_your': 'Control total sobre tu',
    'property_assets': 'activos inmobiliarios.',
    'audited_secure_compliant': 'Auditado. Seguro. Obediente.',
    'empty_key_20': ':$',
    'per_unit_p_l_last_12_months': 'PyG por unidad: últimos 12 meses',
    'loading_report': 'Cargando informe…',
    'no_properties_found': 'No se encontraron propiedades',
    'unit_20': '· Unidad #',
    'mo_lease_ends': '/mes · Fin del contrato de arrendamiento',
    '12_mo_noi': 'NOI de 12 meses',
    'empty_key_21': '▾',
    'monthly_collections_last_6_months': 'Cobros mensuales (últimos 6 meses)',
    'tax_documents': 'Documentos Fiscales',
    'annual_payment_summary_for_tax_reporting': 'Resumen de pago anual para declaración de impuestos (1099-NEC)',
    'total_paid_1': 'Total pagado',
    'this_is_your_personal_payment_summary_fo': 'Este es su resumen de pago personal. Para obtener el formulario oficial 1099-NEC, comuníquese con el administrador de su propiedad. Sólo los pagos de $600 o más en un año calendario deben declararse al IRS.',
    'unit_21': 'Unidad',
    'no_payments_recorded_for': 'No se registraron pagos por',
    'select_a_different_year_to_view_your_pay': 'Seleccione un año diferente para ver su historial de pagos.',
    'browse_facilities_and_book_time_slots': 'Explorar instalaciones y reservar franjas horarias',
    'no_amenities_available_in_your_building': 'No hay servicios disponibles en su edificio',
    'mo_7': '/mes',
    'capacity_1': 'Capacidad:',
    'book_time_slot': 'Reservar franja horaria',
    'book_an_amenity': 'Reserva un servicio',
    'amenity_1': 'Comodidad *',
    'select_amenity_1': 'Seleccionar amenidad',
    'date_2': 'Fecha *',
    'start_time_1': 'Hora de inicio *',
    'end_time_1': 'Hora de finalización *',
    'notes_optional_1': 'Notas (opcional)',
    'cancel_33': 'Cancelar',
    'no_upcoming_bookings': 'No hay reservas próximas',
    'browse_amenities': 'Explorar servicios',
    'cancel_34': 'Cancelar',
    'history_1': 'Historia',
    'property_assistant': 'Asistente de propiedad',
    'ask_about_your_account': 'Pregunta por tu cuenta',
    'lease_history': 'Historial de arrendamiento',
    'your_current_and_past_lease_agreements': 'Sus contratos de arrendamiento actuales y pasados',
    'active_lease': 'Arrendamiento Activo',
    'unit_22': 'Unidad',
    'building_10': 'edificio',
    'monthly_rent_4': 'Renta Mensual',
    'expires_1': 'Vence',
    'open_ended': 'Abierto',
    'start_date_4': 'Fecha de inicio',
    'security_deposit_1': 'Depósito de seguridad',
    'type_3': 'Tipo',
    'no_active_lease_on_file': 'No hay ningún contrato de arrendamiento activo registrado',
    'history_2': 'Historia',
    'mo_8': '/mes',
    'no_lease_records_found': 'No se encontraron registros de arrendamiento',
    'secure_access': 'Acceso seguro',
    'hello_1': 'hola',
    'again': 'De nuevo.',
    'enter_your_details_to_manage_your_home_a': 'Introduce tus datos para gestionar tu vivienda y tus pagos.',
    'your_email': 'Tu correo electrónico',
    'your_password': 'Tu Contraseña',
    'switch_to_owner_login': 'Cambiar a inicio de sesión de propietario',
    'everything_in_one_place': 'Todo en un solo lugar.',
    'tools_for_you': 'Herramientas para ti',
    'everything_you_need': 'Todo lo que necesitas',
    'to_manage_your_home': 'para gestionar tu hogar.',
    'safe_private_reliable': 'Seguro. Privado. Confiable.',
    'we_use_professional_grade_encryption_to': 'Utilizamos cifrado de nivel profesional para garantizar que sus datos y pagos estén siempre protegidos.',
    'empty_key_22': ': #',
    'auto_pay_is_on': 'El pago automático está activado',
    'your_rent_is_charged_automatically_on_th': '· Su alquiler se carga automáticamente en la fecha de vencimiento.',
    'enable_auto_pay': 'Habilitar pago automático',
    'save_a_card_or_bank_account_and_never_mi': 'Guarde una tarjeta o cuenta bancaria y nunca más pierda un pago de alquiler.',

    'autopay_enabled_toast': 'Pago automatico activado! Su alquiler se cargara automaticamente en la fecha de vencimiento.',
    'autopay_setup_canceled': 'La configuracion del pago automatico fue cancelada.',
    'autopay_setup_failed': 'No se pudo iniciar la configuracion del pago automatico.',
    'autopay_start_failed': 'Error al iniciar la configuracion del pago automatico.',
    'confirm_disable_autopay': 'Esta seguro de que desea desactivar el pago automatico? Se eliminara su metodo de pago guardado.',
    'autopay_disabled_success': 'El pago automatico ha sido desactivado.',
    'autopay_disable_failed': 'Error al desactivar el pago automatico.',
    'card_ending_label': '{{brand}} que termina en ••••{{last4}}',
    'payment_method_saved': 'Metodo de pago guardado',
    'disable_auto_pay': 'Desactivar pago automatico',
    'set_up_auto_pay': 'Configurar pago automatico',
    'due_colon': 'Vencimiento:',
    'disabling': 'Desactivando…',
    'renewal_offers': 'Ofertas de Renovación',
    'review_and_respond_to_lease_renewal_offe': 'Revisar y responder a las ofertas de renovación de contrato de arrendamiento de su arrendador.',
    'no_renewal_offers_yet': 'Aún no hay ofertas de renovación',
    'your_property_manager_will_send_a_renewa': 'El administrador de su propiedad le enviará una oferta de renovación aquí cuando su contrato de arrendamiento se acerque a su fecha de finalización.',
    'unit_23': 'Unidad',
    'offer_sent_1': 'Oferta enviada',
    'per_month': 'por mes',
    'offered_rent': 'Alquiler ofrecido',
    'per_month_1': 'por mes',
    'new_term': 'Nuevo término:',
    'note_from_management': 'Nota de la gerencia',
    'decline': 'Rechazar',
    'past_offers': 'Ofertas pasadas',
    'unit_24': 'Unidad',
    'mo_9': '/mes',
    'responded': 'Respondido',
    'share_feedback': 'Compartir comentarios',
    'your_opinion_helps_us_improve': 'Tu opinión nos ayuda a mejorar',
    'thank_you': '¡Gracias!',
    'your_feedback_has_been_submitted': 'Tus comentarios han sido enviados.',
    'submit_another': 'Enviar otro',
    'category_5': 'categoría',
    'your_rating': 'Tu calificación',
    'comment_optional': 'Comentario (opcional)',
    'your_past_feedback': 'Tus comentarios pasados',

    'general': 'General',
    'submit_feedback': 'Enviar valoración',
    'please_select_rating': 'Por favor seleccione una valoración con estrellas',
    'submission_failed': 'Error al enviar',
    'tell_us_placeholder': 'Cuéntenos qué piensa…',
    'rating_very_poor': 'Muy malo',
    'rating_poor': 'Malo',
    'rating_okay': 'Regular',
    'rating_good': 'Bueno',
    'rating_excellent': 'Excelente',
    'utility_bills_1': 'Facturas de servicios públicos',
    'electricity_water_gas_and_other_utility': 'Gastos de electricidad, agua, gas y otros servicios públicos.',
    'paid_on_time': 'Pagado a tiempo',
    'monthly_utility_spend': 'Gasto mensual en servicios públicos',
    'no_utility_bills_yet': 'Aún no hay facturas de servicios públicos',
    'bills_will_appear_here_once_issued_by_ma': 'Las facturas aparecerán aquí una vez emitidas por la administración.',
    'due_now': 'Vencimiento ahora (',
    'history_3': 'Historia (',
    'due_1': 'debido',
    'violations_notices_1': 'Violaciones y avisos',
    'view_violations_and_official_notices_iss': 'Ver infracciones y avisos oficiales que se le hayan enviado',
    'no_violations_on_record': 'No hay violaciones registradas',
    'you_have_a_clean_record_keep_it_up': 'Tienes un historial limpio, ¡sigue así!',
    'fine': 'Bien:',
    'resolution': 'Resolución',
    'unit_25': 'Unidad',
    'no_notices': 'Sin avisos',
    'no_official_notices_have_been_issued_to': 'No se le han enviado avisos oficiales.',
    'here_s_an_overview_of_your_operations_to': 'Aquí encontrará una descripción general de sus operaciones actuales.',
    'system_live': 'Sistema en vivo',
    'active_operations': 'Operaciones activas',
    'priority_task_queue': 'Cola de tareas prioritarias',
    'no_active_tasks_in_your_queue': 'No hay tareas activas en tu cola.',
    'compliance_alert': 'Alerta de cumplimiento',
    'insurance_expires_in_12_days_please_uplo': 'El seguro vence en 12 días. Cargue documentos actualizados.',
    'upgrade_1': 'Actualizar',
    'service_score': 'Puntuación de servicio',
    'detailed_analysis': 'Análisis detallado',
    'system_activity': 'Actividad del sistema',
    'profile_load_error': 'Error de carga del perfil',
    'the_registry_could_not_verify_your_ident': 'El registro no pudo verificar su identidad. Póngase en contacto con los administradores del sistema.',
    'operator': 'Operador',
    'tier_platinum': 'Nivel: Platino',
    'identity_matrix': 'Matriz de identidad',
    'logistical_data': 'Datos logísticos',
    'verified_credentials': 'Credenciales verificadas',
    'profile_modifications_are_managed_by_ins': 'Las modificaciones de perfil son gestionadas por protocolos de seguridad institucional. Solicite actualizaciones a través del escritorio de control para la integridad de la red.',
    'invalid_or_expired_link': 'Enlace no válido o caducado',
    'security_established': 'Seguridad establecida',
    'your_portal_access_key_has_been_successf': 'Su clave de acceso al portal se ha creado correctamente.',
    'proceed_to_login': 'Proceder a iniciar sesión',
    'access_setup': 'Configuración de acceso',
    'finalize_your_credentials_for': 'Finalice sus credenciales para',
    'new_access_key': 'Nueva clave de acceso',
    'confirm_authorization': 'Confirmar autorización',
    'finalize_connection': 'Finalizar conexión',
    'w_9_tax_form': 'Formulario de impuestos W-9',
    'request_for_taxpayer_identification_numb': 'Solicitud de número de identificación del contribuyente: necesaria para la presentación 1099-NEC',
    'w_9_on_file': 'W-9 en el archivo',
    'certified_on': 'Certificado en',
    'you_can_update_and_re_certify_at_any_tim': '. Puede actualizar y volver a certificarse en cualquier momento.',
    'this_form_is_required_by_the_irs_if_you': 'Este formulario es requerido por el IRS. Si recibe $600 o más en un año calendario, se emitirá un 1099-NEC utilizando esta información. Su SSN completo nunca se almacena; solo los últimos 4 dígitos, si se proporcionan.',
    '1_legal_name_as_shown_on_income_tax_retu': '1. Nombre legal (como se muestra en la declaración del impuesto sobre la renta) *',
    '3_federal_tax_classification': '3. Clasificación fiscal federal *',
    'employer_id_number_ein': 'Número de identificación del empleador (EIN)',
    'ssn_last_4_digits_only': 'SSN: solo los últimos 4 dígitos',
    'we_only_store_the_last_4_for_your_privac': 'Solo almacenamos los últimos 4 para tu privacidad.',
    '5_address': '5. Dirección',
    'city': 'ciudad',
    'state': 'Estado',
    'certification': 'Certificación',
    'under_penalties_of_perjury_i_certify_tha': 'Bajo pena de perjurio, certifico que: (1) el número mostrado es mi número de identificación de contribuyente correcto; (2) No estoy sujeto a retención adicional; (3) soy ciudadano estadounidense u otra persona estadounidense; (4) Estoy exento de presentar informes FATCA (si corresponde).',
    'by_clicking': 'Al hacer clic',
    'save_certify': 'Guardar y certificar',
    'you_are_electronically_signing_this_w_9': 'usted está firmando electrónicamente este W-9. Se registrarán su dirección IP y marca de tiempo.',
    'core_operations': 'Operaciones principales',
    'work_orders_1': 'Órdenes de trabajo',
    'execute_your_assignments_with_efficiency': 'Ejecute sus asignaciones con eficiencia y precisión.',
    'all_assignments': 'Todas las tareas',
    'assigned_tasks': 'Tareas asignadas',
    'currently_active': 'Actualmente activo',
    'completed_history': 'Historia completa',
    'no_assignments_found': 'No se encontraron asignaciones',
    'your_current_view_filters_haven_t_matche': 'Sus filtros de vista actuales no coinciden con ningún registro.',
    'unit_26': 'Unidad',
    'task_description_1': 'Descripción de la tarea',
    'completion_evidence': 'Evidencia de finalización',
    'logistics_control': 'Control Logístico',
    'start_mission': 'Iniciar misión',
    'mark_finished': 'Marcar terminado',
    'submit_invoice': 'Enviar factura',
    'view_brief': 'Ver resumen',
    'notice_1': 'Aviso',
    'safety_protocols_are_active_wear_authori': 'Los protocolos de seguridad están activos. Utilice en todo momento el EPI autorizado.',
    'page_1': 'Página',
    'of_6': 'de',
    'next_4': 'Siguiente',
    'submit_settlement': 'Enviar liquidación',
    'claim_amount_for': 'Monto del reclamo por',
    'cancel_35': 'Cancelar',
    'live': 'en vivo',
    'sign_out_1': 'Cerrar sesión',
    'sign_out_2': 'Cerrar sesión',

    // Missing translations added
    'BULK_ADD': 'Adición masiva',
    'QTY_PER_FLOOR': 'Cant. / Piso',
    'SELECT_FLOORS': 'Seleccionar pisos',
    'SIZE': 'Superficie',
    'bill_charged': 'Factura cargada al libro del arrendatario',
    'billing_day': 'Día de facturación del mes',
    'building_meter_hint': 'Medidor del edificio — use RUBS para dividir el costo entre todos los inquilinos',
    'calculating': 'Calculando…',
    'charge_all': 'Cobrar todo',
    'charging': 'Cobrando…',
    'deleted': 'Eliminado',
    'done': 'Listo',
    'generate_bills': 'Generar facturas',
    'generate_bills_now': 'Generar facturas ahora',
    'individual_meter_hint': 'Medidor individual — generar una factura para esta unidad',
    'run_rubs_btn': 'Ejecutar división RUBS',
    'utility_step1': 'Agregar una cuenta de servicio (electricidad, agua, gas…)',
    'utility_step2': 'Registrar una lectura de medidor',
    'utility_step3': 'Generar facturas a partir de lecturas',
    'utility_step4': 'Cargar facturas directamente al libro del inquilino',
    'view_application': 'Ver solicitud',

    'confirm_charge_bill': '¿Cargar esta factura de servicio al libro del arrendatario?',

    'generate_drafts': 'Generar borradores ahora',

    // Desalojos
    'ev_initiated': 'Iniciado',
    'ev_notice_served': 'Notificación entregada',
    'ev_court_filed': 'Demanda presentada',
    'ev_court_ruling': 'Resolución judicial',
    'ev_completed': 'Completado',
    'ev_dismissed': 'Desestimado',
    'ev_notice_pay_or_quit': 'Pagar o desocupar',
    'ev_notice_cure_or_quit': 'Remediar o desocupar',
    'ev_notice_unconditional': 'Desalojo incondicional',
    'ev_active_cases': 'Casos activos',
    'ev_total_owed': 'Total adeudado',
    'ev_notice_type': 'Tipo de notificación',
    'ev_amount_owed': 'Importe adeudado',
    'ev_status_updated': 'Estado actualizado',
    'ev_dismiss_case': 'Desestimar caso',
    'ev_dismiss_confirm': '¿Está seguro de que desea desestimar este caso de desalojo? Esta acción no se puede deshacer.',
    'ev_case_dismissed': 'Caso de desalojo desestimado',
    'ev_dismiss_failed': 'Error al desestimar el caso',
    'ev_case_timeline': 'Cronología del caso',
    'ev_notice_served_date': 'Notificación entregada',
    'ev_court_filing_date': 'Presentación en tribunal',
    'ev_court_date': 'Fecha de audiencia',
    'ev_ruling': 'Resolución',
    'ev_ruling_date': 'Fecha de resolución',
    'ev_vacate_date': 'Desalojar antes de',
    'ev_edit_notes': 'Editar notas',
    'ev_save_notes': 'Guardar notas',
    'ev_add_notes': 'Agregar nota',
    'ev_notes_saved': 'Notas guardadas',
    'ev_save_failed': 'Error al guardar',
    'filed': 'Presentado',

    // Inspecciones
    'insp_move_in': 'Entrada',
    'insp_move_out': 'Salida',
    'insp_periodic': 'Periódica',
    'insp_maintenance': 'Mantenimiento',
    'all_types': 'Todos los tipos',
    'all_status': 'Todos los estados',
    'unit_building': 'Unidad / Edificio',
    'checklist_progress': 'Progreso de la lista',
    'condition_1': 'Condición',

    // Infracciones
    'tenant_unit': 'Inquilino / Unidad',
    'severity': 'Gravedad',
    'fine': 'Multa',

    // Contratos
    'start': 'Inicio',
    'end': 'Fin',
    'expiry': 'Vencimiento',
    'rent_mo': 'Alquiler/mes',
    'open_ended': 'Sin fecha de fin',

    // Renovaciones
    'offered_rent': 'Alquiler ofrecido',
    'risk': 'Riesgo',
    'offer_expires': 'Vencimiento de oferta',

    // Solicitudes
    'applicant': 'Solicitante',
    'employment': 'Empleo',

    // Enlaces de solicitud
    'total_links': 'Total de enlaces',
    'active_links': 'Enlaces activos',
    'total_uses': 'Usos totales',
    'generating': 'Generando...',
    'generate_link': 'Generar enlace',
    'deactivate_link': 'Desactivar enlace',
    'deactivate_link_confirm': '¿Desactivar el enlace "{{label}}"? Ya no aceptará solicitudes.',
    'deactivate': 'Desactivar',

    // Asistente de venta
    'sw_step_buyer': 'Comprador',
    'sw_step_terms': 'Condiciones',
    'sw_step_schedule': 'Plan de pagos',
    'sw_step_confirm': 'Confirmar',
    'back': 'Atrás',
    'creating': 'Creando...',
    'create_sale_contract': 'Crear contrato de venta',
    'hash': '#',
    'due_date': 'Fecha de vencimiento',
    'principal': 'Capital',
    'interest': 'Intereses',
    'monthly_payment': 'Pago mensual',
    'total_interest': 'Intereses totales',
    'total_cost': 'Costo total',
    'down_payment': 'Pago inicial',
    'sale_price': 'Precio de venta',
    'financed_amount': 'Monto financiado',
    'interest_rate': 'Tasa de interés',
    'term': 'Plazo',

    'error_loading_violations': 'Error al cargar las infracciones',
    'marked_as_resolved': 'Marcado como resuelto',
    'error_updating_violation': 'Error al actualizar la infracción',
    'title_and_notice_body_required': 'El título y el contenido del aviso son obligatorios',
    'notice_issued': 'Aviso emitido',
    'error_issuing_notice': 'Error al emitir el aviso',
    'search_violations': 'Buscar por inquilino, título o descripción...',
    'loading_violations': 'Cargando infracciones...',
    'no_violations_recorded': 'No se han registrado infracciones',
    'no_status_violations': 'No hay infracciones {{status}}',
    'notice_type_required': 'Tipo de aviso *',
    'delivery_method_required': 'Método de entrega *',
    'notice_title_required': 'Título del aviso *',
    'notice_deadline_optional': 'Plazo de cumplimiento (opcional)',
    'notice_body_required': 'Cuerpo del aviso *',
    'issuing': 'Emitiendo...',
    'issue_notice_btn': 'Emitir aviso',
    'violations_count': '{{count}} infracciones',
    'open_tickets': 'Tickets abiertos',
    'has_balance': 'Tiene saldo',
    'perfect_payments': 'Pagos perfectos',
    'risk_score': 'Puntuación de riesgo',
    'failed_to_load_evictions': 'Error al cargar los desalojos',
    'failed_to_update_status': 'Error al actualizar el estado',
    'please_select_a_tenant': 'Por favor seleccione un inquilino',
    'tenant_must_have_apartment': 'El inquilino seleccionado debe tener un apartamento y edificio asignados para ser desalojado.',
    'reason_is_required': 'El motivo es obligatorio',
    'eviction_case_opened': 'Caso de desalojo abierto',
    'failed_to_create_eviction': 'Error al crear el desalojo',

    'wo_stat_total': 'Total',
    'wo_stat_assigned': 'Asignado',
    'wo_stat_in_progress': 'En progreso',
    'wo_stat_completed': 'Completado',
    'wo_col_title': 'Título',
    'wo_col_vendor': 'Proveedor',
    'wo_col_priority': 'Prioridad',
    'wo_col_status': 'Estado',
    'wo_col_scheduled': 'Programado',
    'wo_col_invoice': 'Factura',
    'wo_col_assigned_by': 'Asignado por',
    'wo_detail_scheduled': 'Programado',
    'wo_detail_completed': 'Completado',
    'wo_detail_created': 'Creado',
    'wo_failed_to_load': 'No se pudieron cargar las órdenes de trabajo',
    'wo_invoice_approved': '¡Factura aprobada con éxito!',
    'wo_confirm_approval': 'Confirmar aprobación',
    'wo_status_assigned': 'Asignado',
    'wo_status_in_progress': 'En progreso',
    'wo_status_on_hold': 'En espera',
    'inv_status_received': 'Recibida',
    'view_detail': 'Ver detalle',
    'wo_failed_approve': 'No se pudo aprobar la factura',
    'wo_failed_load_vendors': 'No se pudo cargar la lista de proveedores',
    'wo_vendor_required': 'El proveedor es requerido',
    'wo_title_required': 'El título es requerido',
    'wo_created': 'Orden de trabajo creada con éxito',
    'wo_failed_to_create': 'No se pudo crear la orden de trabajo',
    'wo_title_placeholder': 'ej. Reparar tubería con fuga en edificio A unidad 302',
    'wo_description_placeholder': 'Proporcione instrucciones detalladas para el proveedor...',
    'wo_linked_id_placeholder': 'ID vinculado opcional',
    'wo_nothing_to_update': 'Nada que actualizar',
    'wo_updated': 'Orden de trabajo actualizada',
    'wo_update_failed': 'Error al actualizar',
    'sch_col_title': 'Título',
    'sch_col_building': 'Edificio',
    'sch_col_frequency': 'Frecuencia',
    'sch_col_next_due': 'Próximo vencimiento',
    'sch_col_est_cost': 'Costo estimado',
    'sch_col_status': 'Estado',
    'sch_col_actions': 'Acciones',
    'sch_error_loading': 'Error al cargar los horarios',
    'sch_mark_complete_success': 'Marcado como completado, próxima fecha avanzada',
    'sch_error_complete': 'Error al completar el horario',
    'sch_confirm_remove': '¿Eliminar este horario?',
    'sch_removed': 'Horario eliminado',
    'sch_error_remove': 'Error al eliminar el horario',
    'sch_error_history': 'Error al cargar el historial',
    'sch_search_placeholder': 'Buscar horarios...',
    'sch_status_active': 'Activo',
    'sch_status_inactive': 'Inactivo',
    'sch_edit_success': 'Horario actualizado',
    'sch_error_edit': 'Error al actualizar el horario',
    'sch_edit_schedule': 'Editar horario',

    'search_conversations': 'Buscar conversaciones...',
    'load_more': 'Cargar más',
    'no_results': 'No se encontraron resultados',
    'BULK_ADD': 'Agregar en masa',
    'QTY_PER_FLOOR': 'Cantidad / Piso',
    'SELECT_FLOORS': 'Seleccionar pisos',
    'SIZE': 'Tamaño',
    'bill_charged': 'Factura cargada al libro mayor del inquilino',
    'billing_day': 'Día de facturación del mes',
    'building_meter_hint': 'Medidor del edificio — usar RUBS para dividir el costo entre todos los inquilinos',
    'calculating': 'Calculando…',
    'charge_all': 'Cobrar todo',
    'charging': 'Cobrando…',
    'deleted': 'Eliminado',
    'done': 'Hecho',
    'generate_bills': 'Generar facturas',
    'generate_bills_now': 'Generar facturas ahora',
    'individual_meter_hint': 'Medidor individual — generar una factura para esta unidad',
    'run_rubs_btn': 'Ejecutar división RUBS',
    'utility_step1': 'Agregar una cuenta de servicio (electricidad, agua, gas…)',
    'utility_step2': 'Registrar una lectura de medidor',
    'utility_step3': 'Generar facturas a partir de lecturas',
    'utility_step4': 'Cobrar facturas directamente al libro mayor del inquilino',
    'view_application': 'Ver solicitud',
    'failed_to_update_document_status': 'Error al actualizar el estado del documento',
    'buyer_name_placeholder': 'ej. Ahmed Al-Rashidi',
    'col_amenity': 'Comodidad',
    'col_space': 'Espacio',
    'delete_document': 'Eliminar documento',
    'delete_draft_confirm': '¿Está seguro de que desea eliminar esta inspección borrador?',
    'delete_draft_inspection': 'Eliminar inspección borrador',
    'document_added': 'Documento agregado',
    'document_name_placeholder': 'Nombre del documento',
    'edit_unit_amenity': 'Editar comodidad de unidad',
    'failed_create_inspection': 'Error al crear la inspección',
    'failed_delete_inspection': 'Solo se pueden eliminar las inspecciones en borrador',
    'failed_generate_invite_link': 'Error al generar el enlace de invitación',
    'failed_load_bookings': 'Error al cargar las reservas',
    'failed_load_inspections': 'Error al cargar las inspecciones',
    'failed_save_checklist': 'Error al guardar la lista de verificación',
    'failed_sign_inspection': 'Error al firmar la inspección',
    'failed_update_condition': 'Error al actualizar la condición',
    'fair': 'Regular',
    'inspection_completed': 'Inspección marcada como completada',
    'inspection_created': 'Inspección creada',
    'inspection_deleted': 'Inspección eliminada',
    'inspection_notes_placeholder': 'Observaciones o notas iniciales…',
    'inspection_signed': 'Inspección firmada',
    'investment': 'Inversión',
    'item_notes_placeholder': 'Agregar notas para este elemento…',
    'name_and_url_required': 'El nombre y la URL son obligatorios',
    'poor': 'Malo',
    'portal_link_copied': 'Enlace de configuración del portal copiado al portapapeles',
    'prospect_email_placeholder': 'john@example.com',
    'prospect_name_placeholder': 'ej. Juan García',
    'prospect_phone_placeholder': '+964 770 000 0000',
    'sale_notes_placeholder': 'Notas opcionales...',
    'search_apartment_placeholder': 'Buscar apartamento...',
    'search_inspections_placeholder': 'Buscar por unidad, edificio o inquilino…',
    'search_owners_placeholder': 'Buscar propietarios por nombre, teléfono o correo...',
    'search_unit_or_buyer': 'Buscar unidad o comprador...',
    'sign_inspection_message': '¿Marcar esta inspección como firmada? Esta acción es definitiva y no se puede deshacer.',
    'stat_available_to_sell': 'Disponible para vender',
    'stat_sold_units': 'Unidades vendidas',
    'status_all': 'Todos',
    'status_available': 'Disponible',
    'status_sold': 'Vendido',
    'uploaded_by': 'Subido por',
    'val_close_after_open': 'La hora de cierre debe ser posterior a la hora de apertura',
    'val_close_time_required': 'Por favor establezca una hora de cierre',
    'val_company_name_min': 'El nombre de la empresa debe tener al menos 2 caracteres',
    'val_description_max_2000': 'La descripción debe tener 2000 caracteres o menos',
    'val_email_invalid': 'Por favor ingrese una dirección de correo electrónico válida',
    'val_end_after_start': 'La hora de fin debe ser posterior a la hora de inicio',
    'val_expiry_after_start': 'La fecha de vencimiento debe ser posterior a la fecha de inicio',
    'val_fine_non_negative': 'El importe de la multa debe ser un número no negativo',
    'val_first_name_max': 'El nombre debe tener 50 caracteres o menos',
    'val_first_name_min': 'El nombre debe tener al menos 2 caracteres',
    'val_last_name_max': 'El apellido debe tener 50 caracteres o menos',
    'val_last_name_min': 'El apellido debe tener al menos 2 caracteres',
    'val_name_max_100': 'El nombre debe tener 100 caracteres o menos',
    'val_notes_max_1000': 'Las notas deben tener 1000 caracteres o menos',
    'val_notes_max_2000': 'Las notas deben tener 2000 caracteres o menos',
    'val_open_time_required': 'Por favor establezca una hora de apertura',
    'val_password_max': 'La contraseña debe tener 128 caracteres o menos',
    'val_password_min': 'La contraseña debe tener al menos 8 caracteres',
    'val_prospect_name_max': 'El nombre del prospecto debe tener 200 caracteres o menos',
    'val_title_max_200': 'El título debe tener 200 caracteres o menos',
    'val_url_invalid': 'La URL del documento debe comenzar con http:// o https://',
    'val_username_max': 'El nombre de usuario debe tener 30 caracteres o menos',
    'val_username_min': 'El nombre de usuario debe tener al menos 3 caracteres',
    'val_username_no_spaces': 'El nombre de usuario no puede contener espacios',
    'val_webhook_url_https': 'La URL del webhook debe comenzar con https://',
    'hw_record_violation': '1. Registrar infracción',
    'hw_record_violation_desc': 'Registre una infracción con tipo, gravedad y multa opcional. La multa se carga automáticamente al libro mayor del inquilino.',
    'hw_issue_notice': '2. Emitir aviso formal',
    'hw_issue_notice_desc': 'Adjunte un aviso legal y envíe por correo electrónico o WhatsApp.',
    'hw_track_resolution': '3. Seguimiento de la resolución',
    'hw_track_resolution_desc': 'Actualizar estado: reconocido → escalado → resuelto. Se mantiene rastro de auditoría completo.',
    'hw_escalate': '4. Escalar si es necesario',
    'hw_escalate_desc': 'Las infracciones escaladas pueden integrarse en el flujo de trabajo de solicitud de desalojo.',
    'notice_title_placeholder': 'ej. Aviso de pago o desalojo — Renta vencida',
    'notice_body_placeholder': 'Ingrese el texto completo del aviso legal...',
    'failed_to_load_tenants': 'No se pudieron cargar los inquilinos. Verifique su conexión.',
    'please_select_tenant': 'Por favor seleccione primero un inquilino',
    'title_is_required': 'El título es obligatorio',
    'violation_recorded_notice_sent': 'Infracción registrada — aviso enviado automáticamente al inquilino',
    'violation_recorded': 'Infracción registrada',
    'error_creating_violation': 'Error al crear la infracción',
    'select_tenant_placeholder': 'Seleccionar inquilino...',
    'violation_title_placeholder': 'ej. Queja por ruido — música alta después de medianoche',
    'violation_desc_placeholder': 'Describa la infracción en detalle...',
    'saving_ellipsis': 'Guardando...',
    'violation_status_open': 'Abierto',
    'violation_status_acknowledged': 'Reconocido',
    'violation_status_resolved': 'Resuelto',
    'violation_status_escalated': 'Escalado',
    'violation_status_closed': 'Cerrado',
    'violation_type_noise': 'Ruido',
    'violation_type_pets': 'Mascotas',
    'violation_type_damage': 'Daño',
    'violation_type_unauthorized_occupant': 'Ocupante no autorizado',
    'violation_type_parking': 'Estacionamiento',
    'violation_type_smoking': 'Fumar',
    'violation_type_cleanliness': 'Limpieza',
    'violation_type_lease_breach': 'Incumplimiento del contrato',
    'violation_type_late_payment': 'Pago tardío',
    'violation_type_general': 'General',
    'violation_severity_warning': 'Advertencia',
    'violation_severity_minor': 'Menor',
    'violation_severity_major': 'Mayor',
    'violation_severity_critical': 'Crítico',
    'notice_type_pay_or_quit': 'Pagar o desalojar',
    'notice_type_cure_or_quit': 'Corregir o desalojar',
    'notice_type_unconditional_quit': 'Desalojo incondicional',
    'notice_type_entry_notice': 'Aviso de entrada',
    'notice_type_non_renewal': 'No renovación',
    'notice_type_eviction_filing': 'Solicitud de desalojo',
    'notice_type_lease_termination': 'Rescisión del contrato',
    'notice_type_rent_increase': 'Aumento de renta',
    'notice_type_general': 'General',
    'delivery_method_email': 'Correo electrónico',
    'delivery_method_whatsapp': 'WhatsApp',
    'delivery_method_hand_delivered': 'Entregado en mano',
    'delivery_method_certified_mail': 'Correo certificado',
    'delivery_method_posted_on_door': 'Publicado en la puerta',
    'delivery_method_sms': 'SMS',
    'ev_reason_placeholder': 'No pago de renta, violación del contrato, etc.',
    'select_placeholder': 'Seleccionar...',
    'opening_ellipsis': 'Abriendo...',
    'err_loading_tenants': 'Error al cargar inquilinos',
    'identity_link_opened': 'Enlace de verificación de identidad abierto — compártalo con el inquilino',
    'failed_identity_verification': 'No se pudo iniciar la verificación de identidad',
    'fcra_consent_required_toast': 'Debe confirmar el consentimiento FCRA antes de realizar una verificación de antecedentes',
    'bg_invitation_sent': 'Invitación de verificación de antecedentes enviada al correo del inquilino',
    'failed_bg_check': 'No se pudo iniciar la verificación de antecedentes',
    'screening_decision_set': 'Decisión de selección establecida en: ',
    'failed_to_save_decision': 'No se pudo guardar la decisión',
    'search_tenants_placeholder': 'Buscar inquilinos...',
    'loading_ellipsis': 'Cargando...',
    'loading_screening_data': 'Cargando datos de selección...',
    'dob_optional': 'Fecha de nacimiento (opcional)',
    'zipcode_optional': 'Código postal (opcional)',
    'state_optional': 'Estado/Provincia (opcional)',
    'country_label': 'País',
    'sending_ellipsis': 'Enviando...',
    'send_to_tenant': 'Enviar al inquilino',
    'decision_label': 'Decisión',
    'add_notes_decision_placeholder': 'Agregue notas sobre esta decisión...',
    'save_decision': 'Guardar decisión',
    'badge_not_started': 'No iniciado',
    'badge_verified': 'Verificado',
    'badge_action_needed': 'Acción requerida',
    'badge_canceled': 'Cancelado',
    'badge_clear': 'Limpio',
    'badge_consider': 'A considerar',
    'badge_dispute': 'Disputado',
    'badge_suspended': 'Suspendido',
    'badge_approved': 'Aprobado',
    'badge_rejected': 'Rechazado',
    'badge_manual_review': 'Revisión manual',
}
};
